module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 163);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

module.exports = require("react");

/***/ },
/* 1 */
/***/ function(module, exports) {

module.exports = require("lodash.get");

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var currencyUtil = __webpack_require__(44);
var tracking = __webpack_require__(71);
var SV = __webpack_require__(162);
var get = __webpack_require__(1);
var pick = __webpack_require__(32);
var qs = __webpack_require__(33);
var PRICE_TYPES = __webpack_require__(30);

var undefined = void 0;

var _getVariantTrackingValue = function _getVariantTrackingValue(variant) {
    if (!variant) {
        return '';
    }
    if (variant === 'contactDealerGuidedCopy') {
        return 'pre-populated';
    }
    if (variant === 'contactDealerSidebar') {
        return 'contextual';
    }
    return variant;
};

var actions = module.exports = {
    eventOfferEnable: function eventOfferEnable(_ref) {
        var item = _ref.item,
            purchaseStatus = _ref.purchaseStatus,
            priceType = _ref.priceType,
            seller = _ref.seller;

        var trackedPrice = {};
        var dimension76 = void 0;

        tracking.trackEvent({
            category: 'make offer click',
            action: 'contact dealer modal',
            label: purchaseStatus
        });

        if (get(item, 'isPriceUponRequest')) {
            dimension76 = "price upon request";
        } else if (get(item, 'onHold') || get(item, 'isSold')) {
            dimension76 = "N/A";
        } else if (priceType === PRICE_TYPES.TYPE_SALE) {
            dimension76 = "saturday sale";
        } else if (priceType === PRICE_TYPES.TYPE_NET) {
            dimension76 = "trade net price";
        } else if (priceType === PRICE_TYPES.TYPE_RETAIL) {
            dimension76 = 'list price';
        }

        var prices = get(item, 'pricing.prices') || [];
        var price = prices.find(function (p) {
            return p.status === 'ACTIVE' && p.type === priceType;
        }) || {};
        if (get(price, 'amount.convertedAmountList')) {
            trackedPrice = price.amount.convertedAmountList.find(function (o) {
                return o.currency === 'USD';
            });
        }

        var categories = get(item, 'classification.categories') || [];
        var category = categories.length ? get(item, 'classification.categories[' + (categories.length - 1) + '].category.browseUrl') : undefined;

        tracking.trackEcommerce({
            type: 'addToCart',
            products: [{
                id: get(item, 'serviceId'),
                name: get(item, 'title'),
                brand: get(seller, 'serviceId'),
                price: get(trackedPrice, 'amount'),
                url: undefined,
                dealerPk: undefined,
                category: category,
                dimension76: dimension76
            }]
        });
    },
    eventOfferSuccessWithLowballOptions: function eventOfferSuccessWithLowballOptions(_ref2) {
        var selectedLowballOption = _ref2.selectedLowballOption,
            priceValue = _ref2.priceValue,
            offerAmount = _ref2.offerAmount,
            value = _ref2.value;

        var isOther = false;
        var isOriginalOffer = false;
        var percentage = void 0;
        if (selectedLowballOption) {
            isOther = selectedLowballOption.isOther;
            isOriginalOffer = selectedLowballOption.isOriginalOffer;
            percentage = 100 - selectedLowballOption.percentOff;
        } else {
            var offerValue = currencyUtil.parseFloat(offerAmount);
            percentage = offerValue / priceValue * 100;
        }
        var labelPartOne = selectedLowballOption && !isOriginalOffer ? 'revised' : 'initial';
        var labelPartTwo = !selectedLowballOption || isOther ? 'custom' : 'preset';
        var bucket = void 0;
        if (percentage === 100) {
            bucket = '100%';
        } else if (percentage > 90 && percentage < 100) {
            bucket = '91-99%';
        } else if (percentage > 80 && percentage <= 90) {
            bucket = '81-90%';
        } else if (percentage > 70 && percentage <= 80) {
            bucket = '71-80%';
        } else if (percentage > 60 && percentage <= 70) {
            bucket = '61-70%';
        } else if (percentage > 50 && percentage <= 60) {
            bucket = '51-60%';
        } else if (percentage > 40 && percentage <= 50) {
            bucket = '41-50%';
        } else if (percentage > 30 && percentage <= 40) {
            bucket = '31-40%';
        } else if (percentage > 20 && percentage <= 30) {
            bucket = '21-30%';
        } else if (percentage > 10 && percentage <= 20) {
            bucket = '11-20%';
        } else {
            bucket = '1-10%';
        }
        tracking.trackEvent({
            category: 'make offer form interaction',
            action: 'continue offer',
            label: labelPartOne + '|' + labelPartTwo + '|' + bucket,
            value: value
        });
    },
    eventOfferError: function eventOfferError(_ref3) {
        var errorMessage = _ref3.errorMessage,
            source = _ref3.source;

        tracking.trackEvent({
            category: 'form error',
            action: 'make offer|' + source + ' form|offer amount',
            label: errorMessage
        });
    },
    eventHoldRequestEnabled: function eventHoldRequestEnabled(params) {
        tracking.trackEvent(actions.holdRequestBaseOptions(Object.assign({}, params, { action: 'clicked' })));
    },
    eventHoldRequestDisplayed: function eventHoldRequestDisplayed(params) {
        tracking.trackEvent(actions.holdRequestBaseOptions(Object.assign({}, params, { action: 'displayed' })));
    },
    eventHoldRequestSubmitted: function eventHoldRequestSubmitted(params) {
        var holdOptions = actions.holdRequestBaseOptions(Object.assign({}, params, { action: 'submitted' }));
        tracking.trackEvent(Object.assign(holdOptions, {
            label: '' + params.sourceModal
        }));
    },
    eventLaunch: function eventLaunch(params) {
        tracking.trackEvent(Object.assign(actions.contactDealerBaseOptions(params), {
            action: 'contact dealer clicked'
        }));
    },
    eventSend: function eventSend(params) {
        tracking.trackEvent(Object.assign(actions.contactDealerBaseOptions(params), {
            action: 'contact dealer send clicked'
        }));
    },
    eventContactSuccess: function eventContactSuccess(params) {
        tracking.trackEvent(Object.assign(actions.contactDealerBaseOptions(params), {
            action: 'contact dealer submitted',
            value: params.isOptIn ? 1 : 0
        }));
    },
    eventVariantDisplayed: function eventVariantDisplayed(optimizelyVariant) {
        var variant = _getVariantTrackingValue(optimizelyVariant);

        tracking.trackEvent(Object.assign(actions.constants.guidedCopyVariantParams, {
            label: variant + ' displayed'
        }));
    },
    eventGuidedPromptSelected: function eventGuidedPromptSelected() {
        var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        tracking.trackEvent(Object.assign(actions.constants.guidedCopyVariantParams, {
            label: 'pre-populated submitted|' + selection
        }));
    },
    eventPreAuthOfferModalShown: function eventPreAuthOfferModalShown(isAbandonCheckout) {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry entry',
            label: isAbandonCheckout ? 'abandon checkout' : 'make offer modal'
        });
    },
    eventPreAuthOfferModalSubmitted: function eventPreAuthOfferModalSubmitted(isAbandonCheckout) {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry submitted',
            label: isAbandonCheckout ? 'abandon checkout' : 'make offer modal'
        });
    },
    netPriceEventSubmitted: function netPriceEventSubmitted(_ref4) {
        var trackingParams = _ref4.trackingParams;

        var label = qs.stringify(pick(trackingParams.vpvParams, 'pur', 'neg', 'ship', 'ret'), { delimiter: '|' });

        tracking.trackEvent(Object.assign({
            category: 'request net price',
            action: 'request net price submitted',
            label: label
        }));
    },

    // taken from IABActions
    trackPageLoadModal: function trackPageLoadModal(_ref5) {
        var props = _ref5.props;

        var action = props.referredFromAmp ? 'pdp make offer button-amppage' : 'email make offer button - ' + props.tracking.emailTmplName;
        tracking.trackEvent({
            category: 'make offer click',
            action: action
        });
    },
    resetPage: function resetPage() {
        return tracking.addGTMMessage({
            pageType: SV.get('tracking.initialDataLayerInfo.pageType'),
            pageSubType: SV.get('tracking.initialDataLayerInfo.pageSubType')
        });
    },
    contactDealerBaseOptions: function contactDealerBaseOptions(_ref6) {
        var linkLocation = _ref6.linkLocation,
            optimizelyVariant = _ref6.optimizelyVariant,
            trackVariant = _ref6.trackVariant,
            guidedPromptSelection = _ref6.guidedPromptSelection;

        var trackingVariantLabel = trackVariant ? '|' + _getVariantTrackingValue(optimizelyVariant) : '';
        var guidedPromptLabel = guidedPromptSelection ? ': ' + guidedPromptSelection : '';
        return {
            category: 'contact dealer',
            label: '' + linkLocation + trackingVariantLabel + guidedPromptLabel
        };
    },
    holdRequestBaseOptions: function holdRequestBaseOptions(_ref7) {
        var action = _ref7.action,
            sourceModal = _ref7.sourceModal;

        return {
            category: 'product',
            action: 'request hold ' + action,
            label: sourceModal
        };
    },
    offerInquiryEntry: function offerInquiryEntry() {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry entry',
            label: 'make offer modal'
        });
    },
    offerInquirySubmitted: function offerInquirySubmitted() {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry submitted',
            label: 'make offer modal'
        });
    },
    abandonOfferEntry: function abandonOfferEntry() {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry entry',
            label: 'checkout abandon modal: send offer without payment info'
        });
    },
    abandonOfferSubmitted: function abandonOfferSubmitted() {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry submitted',
            label: 'checkout abandon modal: send offer without payment info'
        });
    },


    //confirmation modal tracking
    appInstallClicked: function appInstallClicked() {
        tracking.trackEvent({
            category: 'app promotion actions',
            action: 'click to download iphone app',
            label: 'link click from contact dealer confirmation modal - continue in app'
        });
    },
    confirmationEntry: function confirmationEntry(_ref8) {
        var _ref8$secondaryMessag = _ref8.secondaryMessage,
            secondaryMessage = _ref8$secondaryMessag === undefined ? '' : _ref8$secondaryMessag;

        tracking.trackEvent({
            category: 'contact dealer',
            action: 'contact dealer confirmation modal displayed',
            label: secondaryMessage
        });
    },
    convertedHoldRequestFromConfirmationModal: function convertedHoldRequestFromConfirmationModal() {
        tracking.trackEvent({
            category: 'product',
            action: 'request hold submitted',
            label: 'contact dealer confirmation modal'
        });
    },
    favoriteDealerClicked: function favoriteDealerClicked() {
        tracking.trackEvent({
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'contact dealer confirmation modal'
        });
    },
    holdRequestSecondaryMessageShown: function holdRequestSecondaryMessageShown() {
        tracking.trackEvent({
            category: 'product',
            action: 'request hold displayed',
            label: 'contact dealer confirmation modal'
        });
    },
    makeOfferSecondaryCtaClicked: function makeOfferSecondaryCtaClicked() {
        tracking.trackEvent({
            category: 'make offer click',
            action: 'contact dealer confirmation modal'
        });
    },
    tradeApplicationLinkClicked: function tradeApplicationLinkClicked() {
        tracking.trackEvent({
            category: 'contact dealer',
            action: 'contact dealer form interaction',
            label: 'confirmation modal - apply to trade clicked'
        });
    },


    constants: {
        contactFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'contact dealer confirmation modal'
        },

        netPriceFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'net price confirmation modal'
        },

        offerFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'make offer confirmation modal'
        },

        contactOmtLinkParams: {
            category: 'contact dealer',
            action: 'contact dealer form interaction',
            label: 'view offer in bomt'
        },

        netPriceOmtLinkParams: {
            category: 'net price',
            action: 'net price form interaction',
            label: 'view offer in bomt'
        },

        offerOmtLinkParams: {
            category: 'make offer form interaction',
            action: 'view offer in bomt'
        },

        guidedCopyVariantParams: {
            category: 'contact dealer',
            action: 'guided contact dealer'
        },

        authFlowParams: {
            label: 'offer inquiry'
        }
    }
};

/***/ },
/* 3 */
/***/ function(module, exports) {

module.exports = {
	"clearAuthResultAction": "CLEAR_AUTH_RESULT_ACTION",
	"clearValidationErrors": "CLEAR_VALIDATION_ERRORS",
	"closeModal": "CLOSE_MODAL",
	"contactDataLoaded": "CONTACT_DATA_LOADED",
	"failedValidation": "FAILED_VALIDATION",
	"gotoModalStep": "GOTO_MODAL_STEP",
	"hideActiveModal": "HIDE_ACTIVE_MODAL",
	"holdFromConfirmationModal": "HOLD_REQUESTED_CONFIRMATION_MODAL",
	"initLowballOptions": "INIT_LOWBALL_OPTIONS",
	"messageSuccess": "MESSAGE_SENT",
	"modalIsSending": "MODAL_IS_SENDING",
	"openModal": "OPEN_MODAL",
	"resetContactField": "RESET_CONTACT_FIELD",
	"resetContactData": "RESET_CONTACT_DATA",
	"setAuthResultAction": "SET_AUTH_RESULT_ACTION",
	"setDidEmailCheck": "SET_DID_EMAIL_CHECK",
	"setAuthWasMakeOffer": "SET_AUTH_WAS_MAKE_OFFER",
	"setGhostText": "SET_GHOST_TEXT",
	"setGuidedPromptSelection": "SET_GUIDED_PROMPT_SELECTION",
	"setHideBackLink": "SET_HIDE_BACK_BUTTON",
	"setLowballOfferDiscount": "SET_LOWBALL_OFFER_DISCOUNT",
	"setLowballOption": "SET_LOWBALL_OPTION",
	"setServiceError": "SET_SERVICE_ERROR",
	"showActiveModal": "SHOW_ACTIVE_MODAL",
	"toggleMessage": "TOGGLE_MESSAGE_FIELD",
	"updateContactFields": "UPDATE_CONTACT_FIELDS",
	"setPreAuthOfferLowball": "SET_PRE_AUTH_OFFER_LOWBALL"
};

/***/ },
/* 4 */
/***/ function(module, exports) {

module.exports = require("react-relay");

/***/ },
/* 5 */
/***/ function(module, exports) {

module.exports = require("dibs-token-replace");

/***/ },
/* 6 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainFormContainer":"src-scss-form---mainFormContainer---3EgUV","offerInfo":"src-scss-form---offerInfo---20q95","priceInfo":"src-scss-form---priceInfo---1YH8z","disabledPrice":"src-scss-form---disabledPrice---1oiGY","offerSubmitLabel":"src-scss-form---offerSubmitLabel---1-FL4","form-input":"src-scss-form---form-input---1k8Xs","formInput":"src-scss-form---form-input---1k8Xs","form-radio-input":"src-scss-form---form-radio-input---3pu-Y","formRadioInput":"src-scss-form---form-radio-input---3pu-Y","form-checkbox":"src-scss-form---form-checkbox---3xBch","formCheckbox":"src-scss-form---form-checkbox---3xBch","form-select":"src-scss-form---form-select---3emXp","formSelect":"src-scss-form---form-select---3emXp","focused":"src-scss-form---focused---2EbRZ","form-radio-wrapper":"src-scss-form---form-radio-wrapper---QZYL3","formRadioWrapper":"src-scss-form---form-radio-wrapper---QZYL3","checkout-section-form-container":"src-scss-form---checkout-section-form-container---dR1tj","checkoutSectionFormContainer":"src-scss-form---checkout-section-form-container---dR1tj","checkout-saved-item":"src-scss-form---checkout-saved-item---2t8ID","checkoutSavedItem":"src-scss-form---checkout-saved-item---2t8ID","checkout-section-item":"src-scss-form---checkout-section-item---SSLC6","checkoutSectionItem":"src-scss-form---checkout-section-item---SSLC6","checkout-payment-form":"src-scss-form---checkout-payment-form---2EZD6","checkoutPaymentForm":"src-scss-form---checkout-payment-form---2EZD6","saved-address-new":"src-scss-form---saved-address-new---7xUQx","savedAddressNew":"src-scss-form---saved-address-new---7xUQx","saved-card-new":"src-scss-form---saved-card-new---11Svh","savedCardNew":"src-scss-form---saved-card-new---11Svh","expired":"src-scss-form---expired---1rHpI","disabled":"src-scss-form---disabled---2UOXZ","form-display-value":"src-scss-form---form-display-value---3XIrx","formDisplayValue":"src-scss-form---form-display-value---3XIrx","err-message":"src-scss-form---err-message---2y35v","errMessage":"src-scss-form---err-message---2y35v","active":"src-scss-form---active---2jHz5","preAuthOfferSubmitLabel":"src-scss-form---preAuthOfferSubmitLabel---dKbm4","spinnerWrapper":"src-scss-form---spinnerWrapper---2IMPv","centeredSpinner":"src-scss-form---centeredSpinner---3sulL","submitPreAuthOffer":"src-scss-form---submitPreAuthOffer---31tIE"};

/***/ },
/* 7 */
/***/ function(module, exports) {

module.exports = {
	"appInstallCta": "Install the App",
	"appInstallDescription": "Install the 1stdibs app to get notifications right to your phone when the dealer responds to your message.",
	"appInstallHeader": "Don't Miss the Dealer's Response",
	"confirmationHeader": "Thank You!",
	"favoriteItemCta": "Save Item",
	"favoriteItemDescription": "Save this piece to your favorites to get notified when it goes on sale.",
	"favoriteItemHeader": "Get Updates On This Piece",
	"followDealerCta": "FOLLOW DEALER",
	"followDealerHeader": "Stay Up-to-Date",
	"followDealerInstructions": "Follow to get weekly email alerts with new arrivals from this {dealerType}.",
	"makeOfferCta": "Make an Offer",
	"makeOfferDescription": "You can negotiate the price of this piece. Make an offer to show {dealerName} you're serious.",
	"makeOfferPrompt": "Don't let this piece get away.",
	"noThanksCta": "No, thanks",
	"placeHoldCta": "Request a Hold",
	"placeHoldDescription": "Place this item on hold while you review with your client.",
	"placeHoldRequestPrompt": "Don't let this piece get away.",
	"successMessage": "Your message has been sent to {dealerName}. <br> View all your messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageHold": "Your message and hold request have been sent to {dealerName}. <br /> View all your requests and messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageNetPrice": "Your request has been sent to {dealerName}. <br /> Ask questions about this piece or send additional messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageNetPriceHold": "Requests submitted! <br /> You will be notified when the dealer responds with the net price and if the dealer places the piece on hold for you. Dealers typically respond within one day. View all your messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessagePrivateOffer": "Your offer has been sent to {dealerName}. <br /> View all your requests and messages in <a href='/my/conversations'>My Conversations</a>.",
	"tradeCta": "Apply Now",
	"tradeDescription": "Join our trade program to receive net prices and exclusive trade benefits.",
	"tradePrompt": "Sign up for 1stdibs Trade Program",
	"tradeSecondaryCta": "I'm not a member of the trade."
};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var ACTION_TYPES = __webpack_require__(3);

module.exports = {
    openModal: function openModal(modalType) {
        return {
            type: ACTION_TYPES.openModal,
            activeModal: modalType
        };
    },
    closeModal: function closeModal() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return {
            type: ACTION_TYPES.closeModal,
            formSubmitted: payload.formSubmitted
        };
    },
    hideModal: function hideModal() {
        return {
            type: ACTION_TYPES.hideActiveModal
        };
    },
    showModal: function showModal() {
        return {
            type: ACTION_TYPES.showActiveModal
        };
    },
    goToStep: function goToStep(_ref) {
        var step = _ref.step,
            isBackLink = _ref.isBackLink,
            modalContentData = _ref.modalContentData;
        return {
            type: ACTION_TYPES.gotoModalStep,
            currentStep: step,
            isBackLink: isBackLink,
            modalContentData: modalContentData
        };
    }
};

/***/ },
/* 9 */
/***/ function(module, exports) {

module.exports = require("recompose");

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var isEmpty = __webpack_require__(158);
var contactModalTracking = __webpack_require__(2);
var ACTION_TYPES = __webpack_require__(3);
var _validateMessage = __webpack_require__(122);
var _validateOffer = __webpack_require__(123);

module.exports = {
    validateMessage: function validateMessage(_ref) {
        var validationPayload = _ref.validationPayload,
            options = _ref.options;

        var messageErrors = _validateMessage({ validationPayload: validationPayload, options: options });
        return isEmpty(messageErrors) ? Promise.resolve() : Promise.reject({ messageErrors: messageErrors });
    },
    validateOffer: function validateOffer(_ref2) {
        var validationPayload = _ref2.validationPayload,
            options = _ref2.options;

        var offerErrors = _validateOffer({ validationPayload: validationPayload, options: options });

        if (offerErrors && offerErrors.offer) {
            contactModalTracking.eventOfferError({
                source: 'offer',
                errorMessage: offerErrors.offer
            });
        }

        return isEmpty(offerErrors) ? Promise.resolve() : Promise.reject({
            isShowLowBallWarning: offerErrors.lowBall,
            offerErrors: offerErrors
        });
    },
    failedValidation: function failedValidation(_ref3) {
        var messageErrors = _ref3.messageErrors,
            offerErrors = _ref3.offerErrors,
            isShowLowBallWarning = _ref3.isShowLowBallWarning;
        return {
            type: ACTION_TYPES.failedValidation,
            messageErrors: messageErrors || {},
            offerErrors: offerErrors || {},
            isShowLowBallWarning: isShowLowBallWarning
        };
    }
};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var get = __webpack_require__(1);
var BuyerProfileMutation = __webpack_require__(60);
var ContactDealerMutation = __webpack_require__(38);
var HoldRequestMutation = __webpack_require__(39);
var MakePreAuthOfferMutation = __webpack_require__(121);
var FavoriteDealerMutation = __webpack_require__(25);
var FavoriteItemMutation = __webpack_require__(61);
var TradeStatusMutation = __webpack_require__(62);
var contactModalTracking = __webpack_require__(2);
var ACTION_TYPES = __webpack_require__(3);
var fetch = __webpack_require__(156);
var qs = __webpack_require__(33);
var modalWrapperActions = __webpack_require__(8);

module.exports = {
    updateBuyerProfile: function updateBuyerProfile(inputPayload) {
        return function (dispatch, getState) {
            var relay = inputPayload.relay,
                user = inputPayload.user,
                onSuccess = inputPayload.onSuccess,
                onFailure = inputPayload.onFailure;
            var nameFieldValue = getState().fields.nameFieldValue;

            var displayName = nameFieldValue || get(user, 'profile.displayName');

            return relay.commitUpdate(new BuyerProfileMutation({ user: user, displayName: displayName }), { onSuccess: onSuccess, onFailure: onFailure });
        };
    },
    sendPreAuthOffer: function sendPreAuthOffer(inputPayload) {
        return function () {
            var relay = inputPayload.relay,
                buyerId = inputPayload.buyerId,
                itemId = inputPayload.itemId,
                offerAmountPerItem = inputPayload.offerAmountPerItem,
                offerCurrency = inputPayload.offerCurrency,
                messageContent = inputPayload.messageContent,
                conversation = inputPayload.conversation,
                quantity = inputPayload.quantity,
                onSuccess = inputPayload.onSuccess,
                onFailure = inputPayload.onFailure;

            return relay.commitUpdate(new MakePreAuthOfferMutation({
                buyerId: buyerId,
                itemId: itemId,
                offerAmountPerItem: offerAmountPerItem,
                offerCurrency: offerCurrency,
                messageContent: messageContent,
                conversation: conversation,
                quantity: quantity
            }), { onSuccess: onSuccess, onFailure: onFailure });
        };
    },
    sendContactMessage: function sendContactMessage(inputPayload, mutationArgs) {
        return function (dispatch, getState) {
            var action = mutationArgs.action,
                context = mutationArgs.context,
                subject = mutationArgs.subject;
            var buyerItemConversation = inputPayload.buyerItemConversation,
                item = inputPayload.item,
                onFailure = inputPayload.onFailure,
                onSuccess = inputPayload.onSuccess,
                relay = inputPayload.relay,
                seller = inputPayload.seller,
                user = inputPayload.user;
            var _getState$fields = getState().fields,
                messageFieldValue = _getState$fields.messageFieldValue,
                optInFieldValue = _getState$fields.optInFieldValue;

            return relay.commitUpdate(new ContactDealerMutation({
                action: action,
                buyerItemConversation: buyerItemConversation,
                context: context,
                seller: seller,
                subject: subject,
                user: user,
                isOptIn: optInFieldValue,
                item: item || null,
                messageValue: messageFieldValue
            }), { onSuccess: onSuccess, onFailure: onFailure });
        };
    },
    sendHoldRequest: function sendHoldRequest(inputPayload) {
        return function () {
            var user = inputPayload.user,
                seller = inputPayload.seller,
                item = inputPayload.item,
                relay = inputPayload.relay,
                onSuccess = inputPayload.onSuccess,
                onFailure = inputPayload.onFailure;

            return relay.commitUpdate(new HoldRequestMutation({ user: user, seller: seller, item: item }), { onSuccess: onSuccess, onFailure: onFailure });
        };
    },
    emailCheckAndAuth: function emailCheckAndAuth() {
        return function (dispatch, getState) {
            var emailFieldValue = getState().fields.emailFieldValue;


            return fetch('/soa/identity-3/1/user?' + qs.stringify({ email: emailFieldValue }), { method: 'HEAD' }).then(function (res) {
                return res.status === 200;
            });
        };
    },
    goToSuccess: function goToSuccess(inputPayload) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function (dispatch, getState) {
            var authResultAction = inputPayload.authResultAction,
                chatSuccessTag = inputPayload.chatSuccessTag,
                chatTracking = inputPayload.chatTracking,
                guidedPromptSelection = inputPayload.guidedPromptSelection,
                holdRequestFieldValue = inputPayload.holdRequestFieldValue,
                optimizelyVariant = inputPayload.optimizelyVariant,
                trackingModalName = inputPayload.trackingModalName;

            var trackingParams = getState().tracking;
            var optInFieldValue = getState().fields.optInFieldValue;


            dispatch({ type: ACTION_TYPES.resetContactData });

            if (authResultAction === 'register') {
                dispatch({ type: ACTION_TYPES.closeModal, formSubmitted: true });
            } else {
                dispatch(modalWrapperActions.goToStep({
                    modalContentData: {
                        copySuffix: '',
                        headerSuffix: ''
                    },
                    step: 'confirmation'
                }));
            }

            if (options.isPreAuthOffer) {
                // preAuthOffer tracking is handled in the component
                // this ensures no extra tracking events are fired
                // when successfully submitting a pre auth offer
                return;
            }
            if (options.isNetPrice) {
                contactModalTracking.netPriceEventSubmitted({ trackingParams: trackingParams });
            } else {
                var trackVariantAfterSubmission = void 0;

                if (typeof Storage !== "undefined") {
                    trackVariantAfterSubmission = sessionStorage.getItem('trackVariantAfterSubmission');
                }

                contactModalTracking.eventContactSuccess(Object.assign({}, trackingParams, {
                    isOptIn: optInFieldValue,
                    trackVariant: trackVariantAfterSubmission,
                    guidedPromptSelection: guidedPromptSelection,
                    optimizelyVariant: optimizelyVariant
                }));

                sessionStorage.removeItem('trackVariantAfterSubmission');
            }
            if (holdRequestFieldValue) {
                contactModalTracking.eventHoldRequestSubmitted({ sourceModal: trackingModalName });
            }

            var trackChatEvent = chatTracking ? chatTracking[chatSuccessTag] : false;
            if (trackChatEvent) {
                trackChatEvent();
            }
        };
    },
    favoriteDealer: function favoriteDealer(inputPayload) {
        return function () {
            var relay = inputPayload.relay,
                seller = inputPayload.seller,
                userId = inputPayload.userId;


            var favorite = seller.favoritesByUser.length > 0 ? seller.favoritesByUser[0] : null;

            //if favorite is truthy the user is already following the dealer
            if (!favorite) {
                relay.commitUpdate(new FavoriteDealerMutation({ favorite: favorite, seller: seller, userId: userId }));
            }
        };
    },
    favoriteItem: function favoriteItem(_ref) {
        var item = _ref.item,
            userId = _ref.userId,
            relay = _ref.relay;
        return function () {
            relay.commitUpdate(new FavoriteItemMutation({ action: 'ADD', item: item, userId: userId }));
        };
    },
    updateTradeStatus: function updateTradeStatus(user, tradeStatus, relay) {
        return function () {
            relay.commitUpdate(new TradeStatusMutation({ user: user, tradeStatus: tradeStatus }));
        };
    },
    errorHandler: function errorHandler() {
        return { type: ACTION_TYPES.setServiceError };
    }
};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(141);
var React = __webpack_require__(0);

function Submit(props) {
    var className = props.className,
        handleSubmit = props.handleSubmit,
        isDisabled = props.isDisabled,
        isBusy = props.isBusy,
        copyCtaBusy = props.copyCtaBusy,
        copyCta = props.copyCta,
        dataTn = props.dataTn;

    return React.createElement(
        'button',
        {
            className: className || 'button-primary button-large ' + css.submit,
            onClick: handleSubmit,
            disabled: isDisabled,
            'data-tn': dataTn
        },
        isBusy ? copyCtaBusy : copyCta
    );
}

Submit.propTypes = {
    handleSubmit: React.PropTypes.func,
    isDisabled: React.PropTypes.bool.isRequired,
    isBusy: React.PropTypes.bool.isRequired,
    copyCta: React.PropTypes.string.isRequired,
    copyCtaBusy: React.PropTypes.string.isRequired,
    dataTn: React.PropTypes.string
};

module.exports = Submit;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var get = __webpack_require__(1);
var ACTION_TYPES = __webpack_require__(3);
var _toggleMessage = function _toggleMessage() {
    return {
        type: ACTION_TYPES.toggleMessage
    };
};

module.exports = {
    updateContactModalFields: function updateContactModalFields(inputPayload) {
        return function (dispatch, getState) {
            var isMessageFieldOpen = get(getState(), 'fields.isMessageFieldOpen');
            dispatch(_extends({
                type: ACTION_TYPES.updateContactFields
            }, inputPayload));
            if (inputPayload.field === 'holdRequest' && inputPayload.value && !isMessageFieldOpen) {
                dispatch(_toggleMessage());
            }
        };
    },
    resetContactModalField: function resetContactModalField(fieldKey) {
        return {
            type: ACTION_TYPES.resetContactField,
            fieldKey: fieldKey
        };
    },
    toggleMessage: _toggleMessage
};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = __webpack_require__(10),
    validateMessage = _require.validateMessage,
    validateOffer = _require.validateOffer,
    failedValidation = _require.failedValidation;

var ACTION_TYPES = __webpack_require__(3);

var _require2 = __webpack_require__(13),
    resetContactModalField = _require2.resetContactModalField;

var postToCheckout = __webpack_require__(120);

var _require3 = __webpack_require__(8),
    hideModal = _require3.hideModal,
    goToStep = _require3.goToStep;

var get = __webpack_require__(1);
var tracking = __webpack_require__(2);
var pick = __webpack_require__(32);
var MC_ACTIONS = __webpack_require__(29);

var AUTH_ACTIONS = {
    LOGIN: 'login'
};

var initLowBallOptions = function initLowBallOptions(payload) {
    return function (dispatch) {
        dispatch(_extends({
            type: ACTION_TYPES.initLowballOptions
        }, payload));
        dispatch(resetContactModalField('offer'));
    };
};

var makeOfferActions = module.exports = {
    contactDataLoaded: function contactDataLoaded(payload) {
        return _extends({
            type: ACTION_TYPES.contactDataLoaded
        }, payload);
    },
    messageSuccess: function messageSuccess() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _extends({
            type: ACTION_TYPES.messageSuccess
        }, payload);
    },
    setLowBallOption: function setLowBallOption(payload) {
        return function (dispatch) {
            dispatch(_extends({
                type: ACTION_TYPES.clearValidationErrors
            }, payload));
            dispatch(_extends({
                type: ACTION_TYPES.setLowballOption
            }, payload));
            dispatch(_extends({
                type: ACTION_TYPES.updateContactFields
            }, payload));
        };
    },
    setLowBallOfferDiscount: function setLowBallOfferDiscount(payload) {
        return function (dispatch) {
            dispatch(_extends({
                type: ACTION_TYPES.clearValidationErrors
            }, payload));
            dispatch(_extends({
                type: ACTION_TYPES.setLowballOfferDiscount
            }, payload));
            dispatch(_extends({
                type: ACTION_TYPES.updateContactFields
            }, payload));
        };
    },
    setPreAuthOfferLowball: function setPreAuthOfferLowball(isPreAuthOffer) {
        return {
            type: ACTION_TYPES.setPreAuthOfferLowball,
            flag: isPreAuthOffer
        };
    },
    submitMakeOffer: function submitMakeOffer(inputPayload) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function (dispatch, getState) {
            var copy = inputPayload.copy,
                currency = inputPayload.currency,
                priceValue = inputPayload.priceValue,
                isPricePerPiece = inputPayload.isPricePerPiece;
            var _getState$fields = getState().fields,
                messageFieldValue = _getState$fields.messageFieldValue,
                nameFieldValue = _getState$fields.nameFieldValue,
                offerFieldValue = _getState$fields.offerFieldValue;

            var messageValidation = Promise.resolve();
            if (messageFieldValue) {
                messageValidation = validateMessage({
                    validationPayload: { message: messageFieldValue },
                    options: { fields: ['message'] }
                });
            }

            var nameValidation = validateMessage({
                validationPayload: {
                    name: nameFieldValue
                },
                options: { fields: ['name'] }
            });

            return messageValidation.then(function () {
                return nameValidation;
            }).then(function () {
                return validateOffer({
                    validationPayload: {
                        offer: offerFieldValue,
                        relevantItemPrice: priceValue
                    },
                    options: options
                });
            }).then(function () {
                return postToCheckout(inputPayload);
            }).catch(function (errors) {
                dispatch(failedValidation(errors));
                if (errors.isShowLowBallWarning) {
                    var lowBallPayload = {
                        offerAmount: offerFieldValue,
                        currency: currency,
                        priceValue: priceValue,
                        isPricePerPiece: isPricePerPiece,
                        copy: copy
                    };
                    dispatch(initLowBallOptions(lowBallPayload));
                    dispatch(goToStep({ step: 'lowBall' }));
                }
            });
        };
    },
    submitPreAuthOffer: function submitPreAuthOffer(inputPayload) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function (dispatch) {
            var copy = inputPayload.copy,
                currency = inputPayload.currency,
                priceValue = inputPayload.priceValue,
                isPricePerPiece = inputPayload.isPricePerPiece,
                isUserInitiallyLoggedIn = inputPayload.isUserInitiallyLoggedIn,
                startAuth = inputPayload.startAuth,
                seller = inputPayload.seller,
                forceEnvironmentUpdate = inputPayload.forceEnvironmentUpdate,
                emailValue = inputPayload.emailValue,
                messageValue = inputPayload.messageValue,
                nameValue = inputPayload.nameValue,
                offerValue = inputPayload.offerValue,
                userId = inputPayload.userId,
                itemId = inputPayload.itemId,
                relay = inputPayload.relay,
                conversation = inputPayload.conversation,
                quantityValue = inputPayload.quantityValue,
                isAbandonCheckout = inputPayload.isAbandonCheckout,
                goToSuccess = inputPayload.goToSuccess,
                errorHandler = inputPayload.errorHandler,
                user = inputPayload.user,
                isUserNameSet = inputPayload.isUserNameSet,
                sendPreAuthOffer = inputPayload.sendPreAuthOffer,
                _inputPayload$onSucce = inputPayload.onSuccess,
                _onSuccess = _inputPayload$onSucce === undefined ? function () {} : _inputPayload$onSucce,
                authResultAction = inputPayload.authResultAction;

            var shouldValidateName = !isUserNameSet;

            var messageValidation = Promise.resolve();
            if (!isAbandonCheckout) {
                messageValidation = validateMessage({
                    validationPayload: {
                        message: messageValue,
                        name: shouldValidateName ? nameValue : undefined
                    },
                    options: { fields: ['message'].concat(shouldValidateName ? ['name'] : []) }
                });
            }

            var offerValidation = Promise.resolve();
            if (!isAbandonCheckout) {
                offerValidation = validateOffer({
                    validationPayload: {
                        offer: offerValue,
                        relevantItemPrice: priceValue
                    },
                    options: options
                });
            }

            return messageValidation.then(function () {
                return offerValidation;
            }).then(function () {
                var updateBuyerProfile = Promise.resolve();

                if (shouldValidateName) {
                    updateBuyerProfile = function updateBuyerProfile(payloadUser) {
                        return new Promise(function (resolve) {
                            inputPayload.updateBuyerProfile({
                                relay: relay,
                                user: payloadUser || user,
                                onSuccess: resolve,
                                onFailure: errorHandler
                            });
                        });
                    };
                }

                if (!isUserInitiallyLoggedIn) {
                    dispatch(hideModal());
                    return startAuth({
                        dealerName: get(seller, 'sellerProfile.displayName'),
                        action: AUTH_ACTIONS.LOGIN,
                        email: emailValue,
                        makeOffer: true,
                        ga: {
                            label: tracking.constants.authFlowParams.label
                        }
                    }).then(function (authLoaderPayload) {
                        if (!authLoaderPayload.err) {
                            var _userId = authLoaderPayload.user.userId;

                            return updateBuyerProfile({ serviceId: _userId, displayName: nameValue }).then(function () {
                                dispatch({
                                    type: ACTION_TYPES.setAuthResultAction,
                                    actionName: authLoaderPayload.newUser ? 'register' : 'login'
                                });
                                dispatch({
                                    type: ACTION_TYPES.setAuthWasMakeOffer
                                });
                                forceEnvironmentUpdate({ shouldFetchUser: true });
                            });
                        }
                    });
                }

                dispatch({ type: ACTION_TYPES.modalIsSending });

                var preAuthOfferPayload = {
                    relay: relay,
                    buyerId: userId,
                    itemId: itemId,
                    offerAmountPerItem: offerValue,
                    offerCurrency: currency,
                    messageContent: messageValue,
                    conversation: conversation,
                    quantity: parseInt(quantityValue, 10),
                    onSuccess: function onSuccess() {
                        dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.privateOffer }));
                        tracking.eventPreAuthOfferModalSubmitted(isAbandonCheckout);
                        _onSuccess();
                        return goToSuccess(inputPayload, { isPreAuthOffer: true });
                    },
                    onFailure: function onFailure() {
                        return dispatch(errorHandler());
                    }
                };

                if (authResultAction === 'register') {
                    dispatch(hideModal());
                }

                if (shouldValidateName) {
                    return updateBuyerProfile().then(function () {
                        return sendPreAuthOffer(preAuthOfferPayload);
                    });
                }
                return sendPreAuthOffer(preAuthOfferPayload);
            }).catch(function (errors) {
                dispatch(failedValidation(errors));
                if (errors.isShowLowBallWarning) {
                    var lowBallPayload = {
                        offerAmount: offerValue,
                        currency: currency,
                        priceValue: priceValue,
                        isPricePerPiece: isPricePerPiece,
                        copy: copy
                    };
                    dispatch(initLowBallOptions(lowBallPayload));
                    dispatch(goToStep({ step: 'lowBall' }));
                }
            });
        };
    }
};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var InputWrapper = __webpack_require__(18);
var InputError = __webpack_require__(36);
var css = __webpack_require__(132);
var componentCss = __webpack_require__(131);

function MessageField(_ref) {
    var messageValue = _ref.messageValue,
        messagePlaceholder = _ref.messagePlaceholder,
        onMessageChange = _ref.onMessageChange,
        errors = _ref.errors,
        copy = _ref.copy,
        hideLabel = _ref.hideLabel,
        labelText = _ref.labelText,
        descriptionText = _ref.descriptionText;

    var inputWrapperProps = hideLabel ? { className: css.messageWrapper } : { label: labelText || copy.get('labelMessage') };
    return React.createElement(
        InputWrapper,
        inputWrapperProps,
        React.createElement('textarea', {
            className: componentCss.textarea,
            'data-tn': 'message-input',
            defaultValue: messageValue,
            onChange: function onChange(e) {
                return onMessageChange({ field: 'message', value: e.target.value });
            },
            placeholder: messagePlaceholder,
            type: 'text'
        }),
        React.createElement(InputError, { error: errors.message }),
        React.createElement(
            'div',
            { className: css.description },
            descriptionText
        )
    );
}

MessageField.propTypes = {
    messageValue: PropTypes.string,
    messagePlaceholder: PropTypes.string,
    onMessageChange: PropTypes.func,
    errors: PropTypes.object,
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    hideLabel: PropTypes.bool,
    labelText: PropTypes.string,
    descriptionText: PropTypes.string
};

module.exports = MessageField;

/***/ },
/* 16 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-confirmation---container---1bVsM","successMessage":"src-scss-confirmation---successMessage---z7SEj","description":"src-scss-confirmation---description---BIMzR","secondaryContainer":"src-scss-confirmation---secondaryContainer---1qPdp","secondaryHeader":"src-scss-confirmation---secondaryHeader---3RDHA","primaryCta":"src-scss-confirmation---primaryCta---3DufF","secondaryCta":"src-scss-confirmation---secondaryCta---_2gny"};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var _require = __webpack_require__(149),
    Modal = _require.Modal,
    Header = _require.Header,
    Body = _require.Body;

var OverlaySpinner = __webpack_require__(70);
var composeClassNames = __webpack_require__(43);
var css = composeClassNames(__webpack_require__(134), __webpack_require__(133));
var copy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(28)));
__webpack_require__(151);
__webpack_require__(68);

var ModalWrapper = function (_Component) {
    _inherits(ModalWrapper, _Component);

    function ModalWrapper() {
        _classCallCheck(this, ModalWrapper);

        return _possibleConstructorReturn(this, (ModalWrapper.__proto__ || Object.getPrototypeOf(ModalWrapper)).apply(this, arguments));
    }

    _createClass(ModalWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                openOnRender = _props.openOnRender,
                openModal = _props.openModal;

            if (openOnRender && openModal) {
                openModal();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isLoading = _props2.isLoading,
                isOpened = _props2.isOpened,
                isError = _props2.isError,
                header = _props2.header,
                showHeaderBackLink = _props2.showHeaderBackLink,
                goToPrevStep = _props2.goToPrevStep,
                closeModal = _props2.closeModal,
                serviceErrorMsg = _props2.serviceErrorMsg,
                children = _props2.children;


            var backLink = showHeaderBackLink ? React.createElement(
                'span',
                { className: css.headerBackLink, onClick: goToPrevStep },
                '< Back'
            ) : null;

            var serviceError = React.createElement(
                'div',
                { className: css.serviceError },
                serviceErrorMsg ? serviceErrorMsg : copy.get('serviceError')
            );

            var bodyContent = children;
            if (isLoading) {
                bodyContent = React.createElement(OverlaySpinner, {
                    additionalWrapperClasses: css.spinnerWrapper,
                    additionalSpinnerClasses: css.centeredSpinner,
                    position: 'isAbsolute'
                });
            } else if (isError && children) {
                bodyContent = React.createElement(
                    'div',
                    null,
                    serviceError,
                    children
                );
            } else if (isError) {
                bodyContent = serviceError;
            }

            return React.createElement(
                Modal,
                {
                    isOpened: isOpened,
                    closeModal: closeModal
                },
                React.createElement(
                    Header,
                    { className: css.header },
                    backLink,
                    React.createElement(
                        'span',
                        { className: backLink ? css.headerTitle : "" },
                        isLoading ? copy.get('loading') : header
                    )
                ),
                React.createElement(
                    Body,
                    { bodyClass: css.body },
                    bodyContent
                )
            );
        }
    }]);

    return ModalWrapper;
}(Component);

ModalWrapper.propTypes = {
    modalType: PropTypes.string,
    showHeaderBackLink: PropTypes.bool,
    isOpened: PropTypes.bool,
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    header: PropTypes.string,
    modalContent: PropTypes.node,
    modalSteps: PropTypes.array,
    currentStep: PropTypes.string,
    closeModal: PropTypes.func,
    openModal: PropTypes.func,
    openOnRender: PropTypes.bool,
    goToPrevStep: PropTypes.func,
    serviceErrorMsg: PropTypes.string,
    children: PropTypes.node
};

module.exports = ModalWrapper;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(129);
var React = __webpack_require__(0);
var PropTypes = React.PropTypes;


function InputWrapper(_ref) {
    var label = _ref.label,
        children = _ref.children,
        className = _ref.className;

    var labelNode = void 0;
    if (label) {
        labelNode = React.createElement(
            'label',
            { className: css.label },
            label
        );
    }
    return React.createElement(
        'div',
        { className: className },
        labelNode,
        React.createElement(
            'div',
            null,
            children
        )
    );
}

InputWrapper.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node
};

InputWrapper.defaultProps = {
    className: css.wrapper
};

module.exports = InputWrapper;

/***/ },
/* 19 */
/***/ function(module, exports) {

module.exports = require("classnames");

/***/ },
/* 20 */
/***/ function(module, exports) {

module.exports = require("copy-text");

/***/ },
/* 21 */
/***/ function(module, exports) {

module.exports = require("react-redux");

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var BasicInput = __webpack_require__(54);

function NameField(_ref) {
    var isUserNameSet = _ref.isUserNameSet,
        errors = _ref.errors,
        copy = _ref.copy,
        onNameChange = _ref.onNameChange,
        nameValue = _ref.nameValue;

    if (!isUserNameSet) {
        return React.createElement(BasicInput, {
            label: copy.get('labelName'),
            field: 'name',
            error: errors.name,
            dataTn: 'contact-dealer-name',
            onFieldChanged: onNameChange,
            value: nameValue
        });
    }
    return null;
}

NameField.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    errors: PropTypes.object,
    isUserNameSet: PropTypes.bool,
    nameValue: PropTypes.string,
    onNameChange: PropTypes.func
};

module.exports = NameField;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(140);
var React = __webpack_require__(0);
var MinusIcon = __webpack_require__(154);
var PlusIcon = __webpack_require__(155);
var classNames = __webpack_require__(19);
var PropTypes = React.PropTypes;


function SectionToggle(props) {
    var onToggle = props.onToggle,
        isOpen = props.isOpen,
        children = props.children,
        toggleTn = props.toggleTn,
        toggleLabel = props.toggleLabel;

    return React.createElement(
        'div',
        { className: css.wrapper },
        React.createElement(
            'div',
            { className: css.toggle, onClick: onToggle, 'data-tn': toggleTn },
            React.createElement(
                'span',
                { className: css.label },
                toggleLabel
            ),
            React.createElement(MinusIcon, { className: classNames(css.icon, { 'is-hidden': !isOpen }) }),
            React.createElement(PlusIcon, { className: classNames(css.icon, { 'is-hidden': isOpen }) })
        ),
        isOpen ? children : ''
    );
}

SectionToggle.propTypes = {
    onToggle: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    children: PropTypes.node,
    toggleTn: PropTypes.string,
    toggleLabel: PropTypes.string
};

module.exports = SectionToggle;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _reactRelay = __webpack_require__(4);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _toClass = __webpack_require__(161);

var _toClass2 = _interopRequireDefault(_toClass);

var _createHelper = __webpack_require__(160);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createContainer = function createContainer(options) {
    return function (BaseComponent) {
        return _reactRelay2.default.createContainer((0, _toClass2.default)(BaseComponent), options);
    };
};

module.exports = (0, _createHelper2.default)(createContainer, 'createContainer', false);

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var FavoriteDealerMutation = function (_Relay$Mutation) {
    _inherits(FavoriteDealerMutation, _Relay$Mutation);

    function FavoriteDealerMutation() {
        _classCallCheck(this, FavoriteDealerMutation);

        return _possibleConstructorReturn(this, (FavoriteDealerMutation.__proto__ || Object.getPrototypeOf(FavoriteDealerMutation)).apply(this, arguments));
    }

    _createClass(FavoriteDealerMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'favoriteSeller',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'FavoriteSellerInput!'
                    },
                    name: 'FavoriteDealerMutation',
                    responseType: 'FavoriteSellerPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            return {
                userId: this.props.userId,
                sellerPk: this.props.seller.serviceId,
                favoriteId: this.props.favorite ? this.props.favorite.serviceId : null
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'FavoriteDealerMutationRelayQL',
                    type: 'FavoriteSellerPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { seller: this.props.seller.id }
            }];
        }
    }]);

    return FavoriteDealerMutation;
}(Relay.Mutation);

FavoriteDealerMutation.fragments = {
    seller: function seller() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'FavoriteDealerMutation_SellerRelayQL',
                type: 'Seller'
            };
        }();
    },
    favorite: function favorite() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'FavoriteDealerMutation_FavoriteRelayQL',
                type: 'Favorite'
            };
        }();
    }
};

module.exports = FavoriteDealerMutation;

/***/ },
/* 26 */
/***/ function(module, exports) {

module.exports = {
	"subjectItem": "1stdibs Item Inquiry",
	"subjectItemNetPrice": "1stdibs Net Price",
	"subjectDealer": "1stdibs.com Dealer Inquiry",
	"contactDealerHeader": "Contact {dealer}",
	"contactDealerHeader-placeOnHold": "Request to Hold Item",
	"contactDealerHeader-opop": "Request More Info from Seller",
	"contactDealerHeader-contact3": "Ask the Seller a Question",
	"contactDealerGuidedCopyHeader": "Contact {dealer}",
	"header": "Contact {dealer}",
	"messagePlaceholder": "Request more information about this item.",
	"messagePlaceholder-placeOnHold": " ",
	"messagePlaceholder-opop": "Request more information about this item.",
	"messagePlaceholder-contact3": "Ask the seller a question about this item.",
	"messagePlaceholderStorefront": "Ask the dealer a question.",
	"offerPerItem": "per item for",
	"labelOptIn": "Opt in to share your email address directly with {dealer}.",
	"optInInfo": "We keep your personal information private.",
	"labelEmail": "Your Email",
	"labelName": "Your Name",
	"labelMessage": "Your Message",
	"labelMessage-placeOnHold": "Include details on your hold request",
	"labelMessage-opop": "Your Message",
	"labelMessage-contact3": "Your Message",
	"descriptionText": " ",
	"descriptionText-placeOnHold": "Please indicate for how long you are requesting a hold. If approved, this piece will be placed on hold exclusively for you.",
	"descriptionText-opop": " ",
	"descriptionText-contact3": " ",
	"sendCta": "Send",
	"busyCta": "Sending...",
	"pretextPur": "I'm interested in this piece. Can you please confirm the price?",
	"errorPriceFormat": "Please enter a number in format ###,###",
	"errorPriceFormatEur": "Please enter a number in format ###.###",
	"errorPositiveNumber": "Please enter a value greater than zero",
	"errorUnderListPrice": "Please enter an offer below the list price",
	"errorSpecialCharacters": "May not contain special characters",
	"errorValidEmail": "Please enter a valid email address",
	"errorRequired": "This field is required",
	"successHeader": "Thank you!",
	"successMessageOffer": "Your offer has been submitted and the dealer has 3 days to respond. View your offer details in <a href='/my/orders/' class='bomtLink'>My Orders</a>.",
	"viewAllYourMessagesIn": "View all your messages in ",
	"myConversations": "My Conversations",
	"labelMessageToggle": "Include a Message",
	"offerLowballTitle": "Make an Offer",
	"makeOfferModalLinkPrompt": "Ready to negotiate? ",
	"makeOfferModalLinkCta": "Make an offer >",
	"holdRequestLabel": "Include a request to place this piece on hold",
	"holdRequestInfoChecked": "Please indicate for how long you are requesting a hold. If approved, this piece will be placed on hold exclusively for you."
};

/***/ },
/* 27 */
/***/ function(module, exports) {

module.exports = {
	"labelOffer": "Your offer",
	"continueCta": "Continue",
	"continueToCheckoutCta": "Continue to checkout",
	"sendMessageCta": "Send Message",
	"makeOfferHeader": "Make an Offer",
	"makeOfferHeader-placeOnHold": "Make an Offer",
	"makeOfferHeader-opop": "Make an Offer",
	"makeOfferHeader-contact3": "Make an Offer",
	"makeOfferPlaceholderPdp": "Let the dealer know why you are interested.",
	"offerSubmitLabel": "Next, you'll enter payment and shipping information, but will not be charged.",
	"lowBallHeader": "Make an Offer",
	"lowBallLabelHeading": "Warning: ",
	"lowBallLabel": "An offer significantly below the {type} price of {price} will likely be rejected. We recommend raising your offer.",
	"lowBallOtherOptionLabel": "Enter another offer",
	"lowBallOptionAmountOff": "{amountOff} off, {percentOff}% discount",
	"lowBallOriginalOffer": "(original offer)",
	"listPriceLabel": "List Price",
	"netPriceLabel": "Net Price",
	"salePriceLabel": "Sale Price",
	"perItemSuffix": " per item",
	"abandonMakeOfferHeader": "Send Offer Without Payment Info",
	"abandonMakeOfferContent": "You can still submit your offer of {offerPrice} for this piece as a message to a dealer. You will not be charged.",
	"abandonMakeOfferCta": "Submit",
	"abandonMakeOfferLeaveCta": "Cancel Offer",
	"abandonMakeOfferMessage": "Hi {dealerName},\n\nwill you consider {offerPrice} for this piece?\n\nThanks,\n{userDisplayName}"
};

/***/ },
/* 28 */
/***/ function(module, exports) {

module.exports = {
	"serviceError": "An error occurred while processing your request. Please try again later.",
	"loading": "Loading"
};

/***/ },
/* 29 */
/***/ function(module, exports) {

module.exports = {
	"contactDealer": "CONTACT_DEALER",
	"mcReply": "MC_REPLY",
	"netPrice": "NET_PRICE_REQUEST",
	"netPriceHoldRequest": "NET_PRICE_HOLD_REQUEST",
	"netPriceOffer": "NET_PRICE_OFFER",
	"privateOffer": "PRIVATE_OFFER",
	"requestHold": "HOLD_REQUEST"
};

/***/ },
/* 30 */
/***/ function(module, exports) {

module.exports = {
	"TYPE_NET": "NET",
	"TYPE_RETAIL": "RETAIL",
	"TYPE_SALE": "WEEKLY_SALE",
	"TYPE_PRE_AUTH_OFFER": "PRE_AUTH_OFFER",
	"STATUS_ACTIVE": "ACTIVE"
};

/***/ },
/* 31 */
/***/ function(module, exports) {

module.exports = require("dibs-currency-helpers/intelligentFormat");

/***/ },
/* 32 */
/***/ function(module, exports) {

module.exports = require("lodash.pick");

/***/ },
/* 33 */
/***/ function(module, exports) {

module.exports = require("qs");

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var classNames = __webpack_require__(19);
var css = __webpack_require__(6);
var PRICE_TYPES = __webpack_require__(30);

function DisplayPrice(_ref) {
    var formattedRetailPrice = _ref.formattedRetailPrice,
        formattedNetPrice = _ref.formattedNetPrice,
        formattedSalePrice = _ref.formattedSalePrice,
        formattedPreAuthOfferPrice = _ref.formattedPreAuthOfferPrice,
        priceType = _ref.priceType,
        className = _ref.className,
        copy = _ref.copy,
        isPricePerPiece = _ref.isPricePerPiece,
        showNetPrice = _ref.showNetPrice;

    var wrappingClass = classNames(css.priceInfo, className);
    var listPriceCopy = copy.get('listPriceLabel') + ' ' + formattedRetailPrice;
    var netPriceCopy = copy.get('netPriceLabel') + ' ' + formattedNetPrice;
    var salePriceCopy = copy.get('salePriceLabel') + ' ' + formattedSalePrice;
    var preAuthOfferPriceCopy = formattedPreAuthOfferPrice;

    if (isPricePerPiece) {
        var _map = [listPriceCopy, netPriceCopy, salePriceCopy, preAuthOfferPriceCopy].map(function (priceCopy) {
            return priceCopy + copy.get('perItemSuffix');
        });

        var _map2 = _slicedToArray(_map, 4);

        listPriceCopy = _map2[0];
        netPriceCopy = _map2[1];
        salePriceCopy = _map2[2];
        preAuthOfferPriceCopy = _map2[3];
    }

    if (priceType === PRICE_TYPES.TYPE_SALE) {
        return React.createElement(
            'p',
            { className: wrappingClass },
            salePriceCopy
        );
    }

    if (priceType === PRICE_TYPES.TYPE_NET && showNetPrice) {
        return React.createElement(
            'div',
            { className: wrappingClass },
            React.createElement(
                'p',
                null,
                netPriceCopy
            ),
            React.createElement(
                'p',
                { className: css.disabledPrice },
                listPriceCopy
            )
        );
    }

    if (priceType === PRICE_TYPES.TYPE_PRE_AUTH_OFFER) {
        return React.createElement(
            'p',
            { className: wrappingClass },
            React.createElement(
                'span',
                null,
                copy.get('preAuthOfferPriceLabel')
            ),
            React.createElement(
                'span',
                null,
                preAuthOfferPriceCopy
            )
        );
    }

    return React.createElement(
        'p',
        { className: wrappingClass },
        listPriceCopy
    );
}

DisplayPrice.propTypes = {
    className: PropTypes.string,
    copy: PropTypes.object.isRequired,
    formattedNetPrice: PropTypes.string.isRequired,
    formattedRetailPrice: PropTypes.string.isRequired,
    formattedSalePrice: PropTypes.string.isRequired,
    formattedPreAuthOfferPrice: PropTypes.string,
    priceType: PropTypes.string.isRequired,
    isPricePerPiece: PropTypes.bool,
    showNetPrice: PropTypes.bool
};

module.exports = DisplayPrice;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var css = __webpack_require__(128);

function HoldRequestInput(_ref) {
    var isChecked = _ref.isChecked,
        copyLabel = _ref.copyLabel,
        copyInfoChecked = _ref.copyInfoChecked,
        onChange = _ref.onChange;

    var checkedInfo = React.createElement(
        'p',
        { className: css.info },
        copyInfoChecked
    );
    return React.createElement(
        'div',
        { className: css.container },
        React.createElement(
            'p',
            { className: isChecked ? css.checkboxLabelChecked : css.checkboxLabel },
            React.createElement('input', {
                'data-tn': 'contact-dealer-hold-request-input',
                type: 'checkbox',
                id: 'holdRequest',
                checked: isChecked,
                onChange: onChange
            }),
            React.createElement(
                'label',
                { htmlFor: 'holdRequest' },
                copyLabel
            )
        ),
        isChecked ? checkedInfo : null
    );
}

HoldRequestInput.propTypes = {
    isChecked: PropTypes.bool,
    copyLabel: PropTypes.string,
    copyInfo: PropTypes.string,
    copyInfoChecked: PropTypes.string,
    onChange: PropTypes.func
};

module.exports = HoldRequestInput;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);
var classNames = __webpack_require__(19);
var formCss = __webpack_require__(6);
var PropTypes = React.PropTypes;


function InputError(_ref) {
    var error = _ref.error;

    var errorClasses = classNames(formCss['err-message'], _defineProperty({}, formCss.active, !!error));
    return React.createElement(
        'div',
        { className: errorClasses },
        error
    );
}

InputError.propTypes = {
    error: PropTypes.string
};

module.exports = InputError;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.daysSinceLastAppInstallView = daysSinceLastAppInstallView;
exports.recordAppInstallView = recordAppInstallView;
exports.persistNotTradeAnswer = persistNotTradeAnswer;
exports.userIndicatedNotTrade = userIndicatedNotTrade;

var _dibsBrowserStorage = __webpack_require__(148);

var appInstallPromptDate = 'app_install_last_prompt_date';
var userNotTradeKey = 'user_indicated_not_trade';

var millisecondsPerDay = 1000 * 60 * 60 * 24;

function daysSinceLastAppInstallView() {
    var timeStamp = Number(_dibsBrowserStorage.localStorage.getItem(appInstallPromptDate));

    if (!timeStamp) {
        return Number.MAX_SAFE_INTEGER;
    }

    var millisecondsSinceLastView = Date.now() - timeStamp;
    return Math.floor(millisecondsSinceLastView / millisecondsPerDay);
}

function recordAppInstallView() {
    _dibsBrowserStorage.localStorage.setItem(appInstallPromptDate, Date.now());
};

function persistNotTradeAnswer() {
    _dibsBrowserStorage.localStorage.setItem(userNotTradeKey, true);
};

function userIndicatedNotTrade() {
    return _dibsBrowserStorage.localStorage.getItem(userNotTradeKey);
};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);
var get = __webpack_require__(1);

var ContactDealerMutation = function (_Relay$Mutation) {
    _inherits(ContactDealerMutation, _Relay$Mutation);

    function ContactDealerMutation() {
        _classCallCheck(this, ContactDealerMutation);

        return _possibleConstructorReturn(this, (ContactDealerMutation.__proto__ || Object.getPrototypeOf(ContactDealerMutation)).apply(this, arguments));
    }

    _createClass(ContactDealerMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'contactDealer',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'ContactDealerInput!'
                    },
                    name: 'ContactDealerMutation',
                    responseType: 'ContactDealerPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            var _props = this.props,
                item = _props.item,
                seller = _props.seller,
                user = _props.user,
                messageValue = _props.messageValue,
                subject = _props.subject,
                isOptInChecked = _props.isOptInChecked,
                action = _props.action,
                context = _props.context;

            return {
                buyerId: get(user, 'serviceId'),
                itemPk: get(item, 'serviceId'),
                sellerPk: get(seller, 'serviceId'),
                messageContent: messageValue,
                isOptIn: isOptInChecked,
                pageContext: context,
                subject: subject,
                action: action
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'conversation',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Conversation'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ContactDealerMutationRelayQL',
                    type: 'ContactDealerPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: {
                    conversation: get(this.props, 'buyerItemConversation.id') }
            }];
        }
    }]);

    return ContactDealerMutation;
}(Relay.Mutation);

ContactDealerMutation.fragments = {
    seller: function seller() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'ContactDealerMutation_SellerRelayQL',
                type: 'Seller'
            };
        }();
    },
    user: function user() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'ContactDealerMutation_UserRelayQL',
                type: 'User'
            };
        }();
    },
    item: function item() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'ContactDealerMutation_ItemRelayQL',
                type: 'Item'
            };
        }();
    }
};

module.exports = ContactDealerMutation;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var HoldRequestMutation = function (_Relay$Mutation) {
    _inherits(HoldRequestMutation, _Relay$Mutation);

    function HoldRequestMutation() {
        _classCallCheck(this, HoldRequestMutation);

        return _possibleConstructorReturn(this, (HoldRequestMutation.__proto__ || Object.getPrototypeOf(HoldRequestMutation)).apply(this, arguments));
    }

    _createClass(HoldRequestMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'createHoldRequest',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'CreateHoldRequestInput!'
                    },
                    name: 'HoldRequestMutation',
                    responseType: 'CreateHoldRequestPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            var _props = this.props,
                item = _props.item,
                user = _props.user,
                seller = _props.seller;


            return {
                itemId: item.serviceId,
                userId: user.serviceId,
                sellerId: seller.serviceId,
                vertical: item.vertical
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'HoldRequestMutationRelayQL',
                    type: 'CreateHoldRequestPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { item: this.props.item.id }
            }];
        }
    }]);

    return HoldRequestMutation;
}(Relay.Mutation);

HoldRequestMutation.fragments = {
    user: function user() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'HoldRequestMutation_UserRelayQL',
                type: 'User'
            };
        }();
    },
    item: function item() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'vertical',
                    kind: 'Field',
                    metadata: {},
                    type: 'VerticalType'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'HoldRequestMutation_ItemRelayQL',
                type: 'Item'
            };
        }();
    },
    seller: function seller() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'HoldRequestMutation_SellerRelayQL',
                type: 'Seller'
            };
        }();
    }
};

module.exports = HoldRequestMutation;

/***/ },
/* 40 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-lowball---container---2PcjX","lowballHeader":"src-scss-lowball---lowballHeader---2RV9r","lowballHeaderWarning":"src-scss-lowball---lowballHeaderWarning---3CsBS","info":"src-scss-lowball---info---32Jfx","buttonContainer":"src-scss-lowball---buttonContainer---eQOmy","button-large":"src-scss-lowball---button-large---2pfoM","buttonLarge":"src-scss-lowball---button-large---2pfoM","lowballOptionLabel":"src-scss-lowball---lowballOptionLabel---KsnQa","lowballOptionContent":"src-scss-lowball---lowballOptionContent---2ZXNy","lowballOptionText":"src-scss-lowball---lowballOptionText---38Yez","lowballOfferField":"src-scss-lowball---lowballOfferField---M8Hzj","lowballOptionSubtext":"src-scss-lowball---lowballOptionSubtext---P30Jw","lowballOfferInput":"src-scss-lowball---lowballOfferInput---1UgP-","lowballOption":"src-scss-lowball---lowballOption---1X61Z"};

/***/ },
/* 41 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"info":"src-scss-offer---info---3sV4i","quantityLabel":"src-scss-offer---quantityLabel---_7nGU","quantityInput":"src-scss-offer---quantityInput---LRQdH","quantityInlinelabel":"src-scss-offer---quantityInlinelabel---24MQ6","inputRow":"src-scss-offer---inputRow---3q3nL","inputWrapper":"src-scss-offer---inputWrapper---28G_V","input":"src-scss-offer---input---Hxg4H","currency":"src-scss-offer---currency---27U7o"};

/***/ },
/* 42 */
/***/ function(module, exports) {

module.exports = {
	"makePreAuthOfferHeader": "Confirm Inquiry",
	"preAuthOfferSubmitLabel": "Not ready to enter payment information? Message the dealer to see if they are open to your offer first.",
	"preAuthOfferTriggerText": "Send Inquiry",
	"preAuthOfferInfo": "A message will be sent to the dealer with your inquiry.",
	"preAuthOfferInfoAbandonCheckout": "Not ready to complete your offer for {itemTitle}? Ask if the dealer is open to your price first.",
	"preAuthOfferPriceLabel": "Your Inquiry Amount",
	"preAuthOfferPricePerPiece": "{price} per item",
	"preAuthOfferMessagePlaceholder": "e.g., Would you be willing to accept {price}?",
	"preAuthOfferCta": "send",
	"preAuthOfferMessageLabel": "Include a Message",
	"preAuthOfferServiceError": "There was an error creating your inquiry"
};

/***/ },
/* 43 */
/***/ function(module, exports) {

module.exports = require("compose-class-names");

/***/ },
/* 44 */
/***/ function(module, exports) {

module.exports = require("dibs-currency-helpers/util");

/***/ },
/* 45 */
/***/ function(module, exports) {

module.exports = require("lodash.once");

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var get = __webpack_require__(1);

var _require = __webpack_require__(8),
    hideModal = _require.hideModal;

var _require2 = __webpack_require__(10),
    validateMessage = _require2.validateMessage,
    failedValidation = _require2.failedValidation;

var makeOfferActions = __webpack_require__(14);
var mutationActions = __webpack_require__(11);
var trackingHelpers = __webpack_require__(2);
var ACTION_TYPES = __webpack_require__(3);
var MC_CONTEXTS = __webpack_require__(67);
var MC_ACTIONS = __webpack_require__(29);
var AUTH_ACTIONS = {
    REGISTER: 'register',
    LOGIN: 'login'
};

var _sendMessage = function _sendMessage(inputPayload) {
    return function (dispatch, getState) {
        var item = inputPayload.item,
            copy = inputPayload.copy,
            holdRequestedFromConfirmationModal = inputPayload.holdRequestedFromConfirmationModal;
        var holdRequestFieldValue = getState().fields.holdRequestFieldValue;


        var mutationArgs = {
            action: holdRequestFieldValue ? MC_ACTIONS.requestHold : MC_ACTIONS.contactDealer,
            context: item ? MC_CONTEXTS.item : MC_CONTEXTS.seller,
            subject: item ? [copy.get('subjectItem'), item.title, item.dibsReference].join(' - ') : copy.get('subjectDealer')
        };

        if (holdRequestFieldValue) {
            dispatch(mutationActions.sendHoldRequest(_extends({
                onSuccess: function onSuccess() {
                    dispatch(mutationActions.sendContactMessage(_extends({
                        onSuccess: function onSuccess() {
                            dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.requestHold }));
                            dispatch(mutationActions.goToSuccess(inputPayload));
                        },
                        onFailure: function onFailure() {
                            return dispatch(mutationActions.errorHandler());
                        }
                    }, inputPayload), mutationArgs));

                    //this event tells tracking that the user requested a hold by clicking on "request a hold" in the confiramtion modal for a prior message
                    if (holdRequestedFromConfirmationModal) {
                        trackingHelpers.convertedHoldRequestFromConfirmationModal();
                    }
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload)));
        } else {
            dispatch(mutationActions.sendContactMessage(_extends({
                onSuccess: function onSuccess() {
                    dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.contactDealer }));
                    dispatch(mutationActions.goToSuccess(inputPayload));
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload), mutationArgs));
        }
    };
};

var _commitMutations = function _commitMutations(inputPayload) {
    return function (dispatch, getState) {
        var forceEnvironmentUpdate = inputPayload.forceEnvironmentUpdate,
            isUserInitiallyLoggedIn = inputPayload.isUserInitiallyLoggedIn,
            isUserNameSet = inputPayload.isUserNameSet,
            linkLocation = inputPayload.linkLocation,
            seller = inputPayload.seller,
            startAuth = inputPayload.startAuth,
            userExists = inputPayload.userExists;
        var emailFieldValue = getState().fields.emailFieldValue;


        dispatch({ type: ACTION_TYPES.modalIsSending });
        if (isUserInitiallyLoggedIn) {
            if (!isUserNameSet) {
                // logged in, profile needs update
                dispatch(mutationActions.updateBuyerProfile(_extends({
                    onSuccess: function onSuccess() {
                        return dispatch(_sendMessage(inputPayload));
                    },
                    onFailure: function onFailure() {
                        return dispatch(mutationActions.errorHandler());
                    }
                }, inputPayload)));
            } else {
                // no profile update needed, send the message right away
                dispatch(_sendMessage(inputPayload));
            }
        } else {
            dispatch(hideModal());
            startAuth({
                dealerName: get(seller, 'sellerProfile.displayName'),
                action: userExists ? AUTH_ACTIONS.LOGIN : AUTH_ACTIONS.REGISTER,
                email: emailFieldValue,
                linkLocation: linkLocation
            }).then(function (authLoaderPayload) {
                if (!authLoaderPayload.err) {
                    dispatch({
                        type: ACTION_TYPES.setAuthResultAction,
                        actionName: authLoaderPayload.newUser ? 'register' : 'login'
                    });
                    forceEnvironmentUpdate({ shouldFetchUser: true });
                }
            });
        }
    };
};

module.exports = {
    contactDataLoaded: function contactDataLoaded(payload) {
        return _extends({
            type: ACTION_TYPES.contactDataLoaded
        }, payload);
    },
    clearAuthResultAction: function clearAuthResultAction() {
        return {
            type: ACTION_TYPES.clearAuthResultAction
        };
    },
    setGuidedPromptSelection: function setGuidedPromptSelection(prompt) {
        return {
            type: ACTION_TYPES.setGuidedPromptSelection,
            prompt: prompt
        };
    },
    setGhostText: function setGhostText(ghostText) {
        return {
            type: ACTION_TYPES.setGhostText,
            ghostText: ghostText
        };
    },
    setHideBackLink: function setHideBackLink(hideBackLink) {
        return {
            type: ACTION_TYPES.setHideBackLink,
            hideBackLink: hideBackLink
        };
    },
    submitContactDealer: function submitContactDealer(inputPayload) {
        return function (dispatch, getState) {
            var user = inputPayload.user,
                isUserInitiallyLoggedIn = inputPayload.isUserInitiallyLoggedIn;
            var _getState$fields = getState().fields,
                nameFieldValue = _getState$fields.nameFieldValue,
                emailFieldValue = _getState$fields.emailFieldValue,
                messageFieldValue = _getState$fields.messageFieldValue;

            var messageValidation = validateMessage({
                validationPayload: {
                    email: emailFieldValue || get(user, 'profile.email'),
                    name: nameFieldValue || get(user, 'profile.firstName'),
                    message: messageFieldValue || undefined
                }
            });
            return messageValidation.then(function () {
                if (isUserInitiallyLoggedIn) {
                    dispatch(_commitMutations(inputPayload));
                } else {
                    dispatch(mutationActions.emailCheckAndAuth()).then(function (userExists) {
                        dispatch(_commitMutations(Object.assign({}, inputPayload, { userExists: userExists })));
                    });
                }
                return Promise.resolve();
            }).catch(function (_ref) {
                var messageErrors = _ref.messageErrors;
                return Promise.reject(dispatch(failedValidation({ messageErrors: messageErrors })));
            });
        };
    },
    holdFromConfirmationModal: function holdFromConfirmationModal() {
        return {
            type: ACTION_TYPES.holdFromConfirmationModal
        };
    }
};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = __webpack_require__(10),
    validateMessage = _require.validateMessage,
    failedValidation = _require.failedValidation;

var makeOfferActions = __webpack_require__(14);
var mutationActions = __webpack_require__(11);
var get = __webpack_require__(1);
var ACTION_TYPES = __webpack_require__(3);
var MC_CONTEXTS = __webpack_require__(67);
var MC_ACTIONS = __webpack_require__(29);

var _sendMessage = function _sendMessage(inputPayload) {
    return function (dispatch, getState) {
        var item = inputPayload.item,
            copy = inputPayload.copy;
        var holdRequestFieldValue = getState().fields.holdRequestFieldValue;


        var mutationArgs = {
            action: holdRequestFieldValue ? MC_ACTIONS.netPriceHoldRequest : MC_ACTIONS.netPrice,
            context: MC_CONTEXTS.itemNetPrice,
            subject: [copy.get('netPriceSubjectItem'), item.title, item.dibsReference].join(' - ')
        };

        if (holdRequestFieldValue) {
            dispatch(mutationActions.sendHoldRequest(_extends({
                onSuccess: function onSuccess() {
                    dispatch(mutationActions.sendContactMessage(_extends({
                        onSuccess: function onSuccess() {
                            dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.netPriceHoldRequest }));
                            dispatch(mutationActions.goToSuccess(inputPayload, { isNetPrice: true }));
                        },
                        onFailure: function onFailure() {
                            return dispatch(mutationActions.errorHandler());
                        }
                    }, inputPayload), mutationArgs));
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload)));
        } else {
            dispatch(mutationActions.sendContactMessage(_extends({
                onSuccess: function onSuccess() {
                    dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.netPrice }));
                    dispatch(mutationActions.goToSuccess(inputPayload, { isNetPrice: true }));
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload), mutationArgs));
        }
    };
};

var _commitMutations = function _commitMutations(inputPayload) {
    return function (dispatch) {
        var isUserNameSet = inputPayload.isUserNameSet;


        dispatch({ type: ACTION_TYPES.modalIsSending });
        if (!isUserNameSet) {
            // logged in, profile needs update
            dispatch(mutationActions.updateBuyerProfile(_extends({
                onSuccess: function onSuccess() {
                    return dispatch(_sendMessage(inputPayload));
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload)));
        } else {
            // no profile update needed, send the message right away
            dispatch(_sendMessage(inputPayload));
        }
    };
};

module.exports = {
    contactDataLoaded: function contactDataLoaded(payload) {
        return _extends({
            type: ACTION_TYPES.contactDataLoaded
        }, payload);
    },
    submitNetPriceRequest: function submitNetPriceRequest(inputPayload) {
        return function (dispatch, getState) {
            var isUserNameSet = inputPayload.isUserNameSet,
                user = inputPayload.user;
            var _getState$fields = getState().fields,
                messageFieldValue = _getState$fields.messageFieldValue,
                nameFieldValue = _getState$fields.nameFieldValue,
                holdRequestFieldValue = _getState$fields.holdRequestFieldValue;

            // for net price requests, a message is only required if a hold request is included
            // but if a message has been entered, we should validate it

            var skipMessageValidation = isUserNameSet && !holdRequestFieldValue && messageFieldValue === '';
            var messagePayload = {
                validationPayload: {
                    name: nameFieldValue || get(user, 'profile.displayName'),
                    message: messageFieldValue || undefined
                },
                options: {
                    fields: skipMessageValidation ? ['name'] : ['name', 'message']
                }
            };

            return validateMessage(messagePayload).then(function () {
                return dispatch(_commitMutations(inputPayload));
            }).catch(function (_ref) {
                var messageErrors = _ref.messageErrors;
                return dispatch(failedValidation({ messageErrors: messageErrors }));
            });
        };
    }
};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _secondaryMessageComp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var tokenReplace = __webpack_require__(5);

var _require = __webpack_require__(37),
    daysSinceLastAppInstallView = _require.daysSinceLastAppInstallView,
    userIndicatedNotTrade = _require.userIndicatedNotTrade;

var _require2 = __webpack_require__(118),
    isAppleMobileDevice = _require2.isAppleMobileDevice;

var trackingHelpers = __webpack_require__(2);

var secondaryMessages = {
    appInstall: 'app install',
    favoriteDealer: 'follow dealer',
    holdRequest: 'place hold',
    makeOffer: 'make offer',
    tradePrompt: 'join trade'
};

var secondaryMessageComponentsKey = (_secondaryMessageComp = {}, _defineProperty(_secondaryMessageComp, secondaryMessages.appInstall, __webpack_require__(106)), _defineProperty(_secondaryMessageComp, secondaryMessages.favoriteDealer, __webpack_require__(107)), _defineProperty(_secondaryMessageComp, secondaryMessages.holdRequest, __webpack_require__(108)), _defineProperty(_secondaryMessageComp, secondaryMessages.makeOffer, __webpack_require__(112)), _defineProperty(_secondaryMessageComp, secondaryMessages.tradePrompt, __webpack_require__(114)), _secondaryMessageComp);

var MC_ACTIONS = __webpack_require__(29);
var css = __webpack_require__(16);
var copy = __webpack_require__(7);

var Confirmation = function (_Component) {
    _inherits(Confirmation, _Component);

    function Confirmation(props) {
        _classCallCheck(this, Confirmation);

        var _this = _possibleConstructorReturn(this, (Confirmation.__proto__ || Object.getPrototypeOf(Confirmation)).call(this, props));

        _this.canShowMakeOfferMessage = _this.canShowMakeOfferMessage.bind(_this);
        _this.getSecondaryMessage = _this.getSecondaryMessage.bind(_this);
        _this.successMessageSection = _this.successMessageSection.bind(_this);
        return _this;
    }

    _createClass(Confirmation, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            trackingHelpers.confirmationEntry({ secondaryMessage: this.getSecondaryMessage() });
        }
    }, {
        key: 'canShowMakeOfferMessage',
        value: function canShowMakeOfferMessage() {
            var _props = this.props,
                item = _props.item,
                messagesSent = _props.messagesSent,
                transaction = _props.transaction;

            var userCanMakeOffer = get(item, 'canBuyerMakeOffer');
            var offerMadeDuringCurrentSesssion = messagesSent.indexOf(MC_ACTIONS.privateOffer) > -1;
            var userHasActiveOffer = !!transaction && !get(transaction, 'isCanceled') && !!transaction.mostRecentOffer && get(transaction, 'mostRecentOffer.status') !== 'NEW';

            return userCanMakeOffer && !offerMadeDuringCurrentSesssion && !userHasActiveOffer;
        }
    }, {
        key: 'getSecondaryMessage',
        value: function getSecondaryMessage() {
            if (this.props.isNetPrice) {
                return secondaryMessages.favoriteDealer;
            }
            if (this.props.user.verifiedTradeStatus === 'SUSPECTED' && !userIndicatedNotTrade()) {
                return secondaryMessages.tradePrompt;
            }
            if (isAppleMobileDevice() && daysSinceLastAppInstallView() > 30) {
                return secondaryMessages.appInstall;
            }
            if (this.canShowMakeOfferMessage()) {
                return secondaryMessages.makeOffer;
            }
            if (this.props.isShowHoldRequest) {
                return secondaryMessages.holdRequest;
            }
            if (this.props.seller.favoritesByUser.length < 1 && !!this.props.favoriteDealer) {
                return secondaryMessages.favoriteDealer;
            }

            return '';
        }
    }, {
        key: 'successMessageSection',
        value: function successMessageSection() {
            var _props2 = this.props,
                messagesSent = _props2.messagesSent,
                isNetPrice = _props2.isNetPrice;


            var messageTemplate = void 0;
            if (isNetPrice) {
                messageTemplate = get(copy, 'successMessageNetPrice');
            } else {
                var mostRecentMessageType = messagesSent[0];
                switch (mostRecentMessageType) {
                    case MC_ACTIONS.requestHold:
                        messageTemplate = get(copy, 'successMessageHold');
                        break;
                    case MC_ACTIONS.privateOffer:
                        messageTemplate = get(copy, 'successMessagePrivateOffer');
                        break;
                    default:
                        messageTemplate = get(copy, 'successMessage');
                }
            }

            var dealerName = get(this.props.seller, 'sellerProfile.company');
            var message = tokenReplace(messageTemplate, { dealerName: dealerName });
            return React.createElement('p', { className: css.successMessage, dangerouslySetInnerHTML: { __html: message } });
        }
    }, {
        key: 'render',
        value: function render() {
            var SecondaryMessageComponent = secondaryMessageComponentsKey[this.getSecondaryMessage()];
            return React.createElement(
                'div',
                { className: css.container },
                this.successMessageSection(),
                SecondaryMessageComponent ? React.createElement(SecondaryMessageComponent, this.props) : false
            );
        }
    }]);

    return Confirmation;
}(Component);

Confirmation.propTypes = {
    closeModal: PropTypes.func,
    favoriteDealer: PropTypes.func,
    favoriteItem: PropTypes.func,
    isNetPrice: PropTypes.bool,
    isShowHoldRequest: PropTypes.bool,
    item: PropTypes.object,
    messagesSent: PropTypes.array,
    modalKey: PropTypes.string,
    relay: PropTypes.object,
    seller: PropTypes.shape({
        favoritesByUser: PropTypes.array,
        sellerProfile: PropTypes.shape({
            company: PropTypes.string,
            type: PropTypes.string
        })
    }),
    transaction: PropTypes.object,
    updateTradeStatus: PropTypes.func,
    user: PropTypes.object
};

Confirmation.defaultProps = {
    isNetPrice: false,
    messagesSent: [],
    modalKey: 'confirmation'
};

module.exports = Confirmation;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

/**
    This input component is meant to be used in place of the default
    React input component. Use this if the input's cursor jumps to the
    end when trying to type somewhere other than the end.

    You'll probably need this when using a controlled input (where you
    provide the `value` prop) and you're either a) transforming user input
    (i.e. stripping all non-numbers or adding spaces for credit card #s)
    or b) you're updating `value` asynchronously (which is typical if
    you're calling executeAction).
*/

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(159);

var CursorInput = function (_React$Component) {
    _inherits(CursorInput, _React$Component);

    function CursorInput() {
        _classCallCheck(this, CursorInput);

        return _possibleConstructorReturn(this, (CursorInput.__proto__ || Object.getPrototypeOf(CursorInput)).apply(this, arguments));
    }

    _createClass(CursorInput, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var node = ReactDOM.findDOMNode(this);
            if (document && document.activeElement === node) {
                var oldLength = node.value.length;
                var oldIdx = node.selectionStart;
                node.value = this.props.value || '';
                var newIdx = Math.max(0, node.value.length - oldLength + oldIdx);
                node.selectionStart = node.selectionEnd = newIdx;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement('input', this.props);
        }
    }]);

    return CursorInput;
}(React.Component);

CursorInput.propTypes = {
    value: React.PropTypes.any
};

module.exports = CursorInput;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var BasicInput = __webpack_require__(54);

function EmailField(_ref) {
    var onEmailChange = _ref.onEmailChange,
        isUserInitiallyLoggedIn = _ref.isUserInitiallyLoggedIn,
        errors = _ref.errors,
        copy = _ref.copy,
        emailValue = _ref.emailValue;

    if (!isUserInitiallyLoggedIn) {
        return React.createElement(BasicInput, {
            onFieldChanged: onEmailChange,
            label: copy.get('labelEmail'),
            field: 'email',
            error: errors.email,
            value: emailValue,
            dataTn: 'contact-dealer-email'
        });
    }
    return null;
}

EmailField.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    emailValue: PropTypes.string,
    errors: PropTypes.object,
    isUserInitiallyLoggedIn: PropTypes.bool.isRequired,
    onEmailChange: PropTypes.func
};

module.exports = EmailField;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var HoldRequestInput = __webpack_require__(35);
var MessageField = __webpack_require__(15);
var NameField = __webpack_require__(22);
var Confirmation = __webpack_require__(48);
var SectionToggle = __webpack_require__(23);
var Submit = __webpack_require__(12);
var css = __webpack_require__(135);
var formCss = __webpack_require__(6);
var contactModalTracking = __webpack_require__(2);

var NetPrice = function (_Component) {
    _inherits(NetPrice, _Component);

    function NetPrice(props) {
        _classCallCheck(this, NetPrice);

        var _this = _possibleConstructorReturn(this, (NetPrice.__proto__ || Object.getPrototypeOf(NetPrice)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onHoldRequestChange = _this.onHoldRequestChange.bind(_this);
        _this.onUpdateMessageField = _this.onUpdateTextFields.bind(_this, 'message');
        _this.onUpdateNameField = _this.onUpdateTextFields.bind(_this, 'name');
        return _this;
    }

    _createClass(NetPrice, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                isShowHoldRequest = _props.isShowHoldRequest,
                trackingModalName = _props.trackingModalName;

            if (isShowHoldRequest) {
                contactModalTracking.eventHoldRequestDisplayed({ sourceModal: trackingModalName });
            }
        }
    }, {
        key: 'onUpdateTextFields',
        value: function onUpdateTextFields(fieldKey, fieldAndValue) {
            var updateContactModalFields = this.props.updateContactModalFields;

            updateContactModalFields({
                field: fieldKey,
                value: fieldAndValue.value
            });
        }
    }, {
        key: 'onHoldRequestChange',
        value: function onHoldRequestChange(e) {
            var _props2 = this.props,
                updateContactModalFields = _props2.updateContactModalFields,
                trackingModalName = _props2.trackingModalName;

            if (e.target.checked) {
                contactModalTracking.eventHoldRequestEnabled({ sourceModal: trackingModalName });
            }
            updateContactModalFields({
                field: 'holdRequest',
                value: e.target.checked
            });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            this.props.submitNetPriceRequest(this.props);
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.currentStep === 'confirmation') {
                return React.createElement(Confirmation, _extends({}, this.props, { isNetPrice: true }));
            }

            var _props3 = this.props,
                copy = _props3.copy,
                errors = _props3.errors,
                isHoldRequestChecked = _props3.isHoldRequestChecked,
                isMessageFieldOpen = _props3.isMessageFieldOpen,
                isSending = _props3.isSending,
                isShowHoldRequest = _props3.isShowHoldRequest,
                isUserNameSet = _props3.isUserNameSet,
                nameValue = _props3.nameValue,
                toggleMessage = _props3.toggleMessage;


            var messagePlaceholder = this.props.copy.get('messagePlaceholder');

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: formCss.mainFormContainer + ' ' + css.container },
                    React.createElement(
                        'p',
                        null,
                        copy.get('netPriceSubheader')
                    ),
                    React.createElement(NameField, {
                        copy: copy,
                        errors: errors,
                        isUserNameSet: isUserNameSet,
                        nameValue: nameValue,
                        onNameChange: this.onUpdateNameField
                    }),
                    isShowHoldRequest ? React.createElement(HoldRequestInput, {
                        copyInfoChecked: copy.get('netPriceHoldInfoChecked'),
                        copyLabel: copy.get('holdRequestLabel'),
                        isChecked: isHoldRequestChecked,
                        onChange: this.onHoldRequestChange
                    }) : false,
                    React.createElement(
                        SectionToggle,
                        {
                            isOpen: !!isMessageFieldOpen,
                            onToggle: toggleMessage.bind(this),
                            toggleLabel: copy.get('labelMessageToggle'),
                            toggleTn: 'send-message-toggle'
                        },
                        React.createElement(MessageField, _extends({}, this.props, {
                            hideLabel: true,
                            messagePlaceholder: messagePlaceholder,
                            onMessageChange: this.onUpdateMessageField
                        }))
                    ),
                    React.createElement(Submit, {
                        copyCta: copy.get('sendRequestCta'),
                        copyCtaBusy: copy.get('busyCta'),
                        dataTn: 'contact-dealer-submit',
                        isBusy: isSending,
                        isDisabled: isSending
                    })
                )
            );
        }
    }]);

    return NetPrice;
}(Component);

NetPrice.propTypes = {
    closeModal: PropTypes.func,
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currentStep: PropTypes.string,
    isHoldRequestChecked: PropTypes.bool,
    isMessageFieldOpen: PropTypes.bool,
    isSending: PropTypes.bool,
    isShowHoldRequest: PropTypes.bool,
    isUserNameSet: PropTypes.bool,
    item: PropTypes.object,
    messageValue: PropTypes.string,
    seller: PropTypes.object,
    submitNetPriceRequest: PropTypes.func,
    toggleMessage: PropTypes.func,
    updateContactModalFields: PropTypes.func,
    trackingModalName: PropTypes.string,
    errors: PropTypes.object,
    nameValue: PropTypes.string
};

NetPrice.defaultProps = {
    trackingModalName: 'net price modal'
};

module.exports = NetPrice;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var InputWrapper = __webpack_require__(18);
var OfferRow = __webpack_require__(55);

function OfferField(_ref) {
    var copy = _ref.copy,
        currencySymbol = _ref.currencySymbol,
        errors = _ref.errors,
        hideQuantity = _ref.hideQuantity,
        isPricePerPiece = _ref.isPricePerPiece,
        offerValue = _ref.offerValue,
        onOfferChange = _ref.onOfferChange,
        pieces = _ref.pieces,
        quantityValue = _ref.quantityValue;

    var offerFieldLabel = copy.get('labelOffer');
    if (isPricePerPiece) {
        offerFieldLabel = '' + offerFieldLabel + copy.get('perItemSuffix');
    }
    return React.createElement(
        InputWrapper,
        { label: offerFieldLabel },
        React.createElement(OfferRow, {
            onFieldChanged: onOfferChange,
            isPricePerPiece: typeof hideQuantity === "boolean" ? !hideQuantity : isPricePerPiece,
            pieces: pieces,
            field: 'offer',
            value: offerValue,
            quantityField: 'quantity',
            quantityValue: quantityValue,
            error: errors.offer,
            currencySymbol: currencySymbol,
            copy: copy
        })
    );
}

OfferField.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currencySymbol: PropTypes.string.isRequired,
    errors: PropTypes.object,
    hideQuantity: PropTypes.bool,
    isPricePerPiece: PropTypes.bool.isRequired,
    offerValue: PropTypes.string,
    onOfferChange: PropTypes.func,
    pieces: PropTypes.number.isRequired,
    quantityValue: PropTypes.string
};

module.exports = OfferField;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(137);
var React = __webpack_require__(0);
var PropTypes = React.PropTypes;


function OptInInput(_ref) {
    var isChecked = _ref.isChecked,
        copyLabel = _ref.copyLabel,
        copyInfo = _ref.copyInfo,
        onChange = _ref.onChange;

    return React.createElement(
        'div',
        { className: css.container },
        React.createElement(
            'p',
            null,
            copyInfo
        ),
        React.createElement(
            'p',
            { className: css.checkboxLabel },
            React.createElement('input', {
                type: 'checkbox',
                id: 'optIn',
                checked: isChecked,
                onChange: onChange,
                dataTn: 'make-offer-opt-in'
            }),
            React.createElement(
                'label',
                { htmlFor: 'optIn' },
                copyLabel
            )
        )
    );
}

OptInInput.propTypes = {
    isChecked: PropTypes.bool,
    copyLabel: PropTypes.string,
    copyInfo: PropTypes.string,
    onChange: PropTypes.func
};

module.exports = OptInInput;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var formCss = __webpack_require__(6);
var inputCss = __webpack_require__(130);
var React = __webpack_require__(0);
var InputWrapper = __webpack_require__(18);
var InputError = __webpack_require__(36);
var PropTypes = React.PropTypes;


function BasicInput(_ref) {
    var label = _ref.label,
        field = _ref.field,
        placeholder = _ref.placeholder,
        error = _ref.error,
        dataTn = _ref.dataTn,
        onFieldChanged = _ref.onFieldChanged,
        value = _ref.value,
        css = _ref.css;

    return React.createElement(
        InputWrapper,
        { label: label },
        React.createElement('input', {
            className: formCss['form-input'] + ' ' + inputCss.input,
            onChange: function onChange(e) {
                return onFieldChanged({ field: field, value: e.target.value });
            },
            placeholder: placeholder,
            type: 'text',
            value: value,
            'data-tn': dataTn
        }),
        React.createElement(InputError, { error: error })
    );
}

BasicInput.propTypes = {
    label: PropTypes.string,
    field: PropTypes.string.isRequired,
    onFieldChanged: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    dataTn: PropTypes.string,
    value: PropTypes.string
};

module.exports = BasicInput;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var css = __webpack_require__(41);
var React = __webpack_require__(0);
var OfferInput = __webpack_require__(113);
var QuantityInput = __webpack_require__(57);
var InputError = __webpack_require__(36);
var PropTypes = React.PropTypes;


function OfferRow(props) {
    var className = props.className,
        isPricePerPiece = props.isPricePerPiece,
        error = props.error,
        copy = props.copy,
        quantityField = props.quantityField,
        quantityValue = props.quantityValue;

    var quantityLabel = void 0;
    var quantityInput = void 0;
    if (isPricePerPiece) {
        quantityLabel = React.createElement(
            'div',
            { className: css.quantityLabel },
            copy.get('offerPerItem')
        );
        quantityInput = React.createElement(QuantityInput, _extends({}, props, {
            field: quantityField,
            value: quantityValue
        }));
    }
    return React.createElement(
        'div',
        { className: className },
        React.createElement(
            'div',
            { className: css.inputRow },
            React.createElement(OfferInput, props),
            quantityLabel,
            quantityInput
        ),
        React.createElement(InputError, { error: error })
    );
}

OfferRow.propTypes = {
    className: PropTypes.string,
    isPricePerPiece: PropTypes.bool,
    pieces: PropTypes.number,
    quantityField: PropTypes.string,
    quantityValue: PropTypes.string,
    onFieldChanged: PropTypes.func.isRequired,
    error: PropTypes.string,
    currencySymbol: PropTypes.string,
    displayPrice: PropTypes.string,
    value: PropTypes.string,
    field: PropTypes.string,
    isOfferFocus: PropTypes.bool,
    copy: PropTypes.shape({
        get: PropTypes.func.isRequired
    })
};

module.exports = OfferRow;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var InputWrapper = __webpack_require__(18);
var QuantityInput = __webpack_require__(57);
var css = __webpack_require__(41);

function QuantityField(_ref) {
    var quantityValue = _ref.quantityValue,
        isPricePerPiece = _ref.isPricePerPiece,
        pieces = _ref.pieces,
        copy = _ref.copy,
        onOfferChange = _ref.onOfferChange;

    if (!isPricePerPiece || typeof quantityValue === 'undefined') {
        return null;
    }
    return React.createElement(
        InputWrapper,
        { label: copy.get('Quantity') },
        React.createElement(QuantityInput, {
            className: css.quantityInput,
            field: 'quantity',
            value: quantityValue,
            pieces: pieces,
            onFieldChanged: onOfferChange
        })
    );
}

QuantityField.propTypes = {
    quantityValue: PropTypes.string,
    isPricePerPiece: PropTypes.bool.isRequired,
    pieces: PropTypes.number.isRequired,
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    onOfferChange: PropTypes.func
};

module.exports = QuantityField;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var formCss = __webpack_require__(6);

function QuantityInput(props) {
    var className = props.className,
        value = props.value,
        pieces = props.pieces,
        field = props.field,
        onFieldChanged = props.onFieldChanged;

    var options = [];
    for (var i = 1; i <= pieces; i++) {
        options.push(React.createElement(
            'option',
            { key: i, value: i },
            i
        ));
    }
    var selectProps = {
        className: formCss['form-input'],
        onChange: function onChange(e) {
            return onFieldChanged({ field: field, value: e.target.value });
        },
        value: value
    };
    return React.createElement(
        'span',
        { className: formCss['form-select'] + ' ' + (className || '') },
        React.createElement(
            'span',
            { className: formCss['form-display-value'] },
            value
        ),
        React.createElement(
            'select',
            selectProps,
            options
        )
    );
};

QuantityInput.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string.isRequired,
    pieces: PropTypes.number.isRequired,
    field: PropTypes.string.isRequired,
    onFieldChanged: PropTypes.func.isRequired
};

module.exports = QuantityInput;

/***/ },
/* 58 */
/***/ function(module, exports) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var canMakePreAuthOffer = exports.canMakePreAuthOffer = function canMakePreAuthOffer(_ref) {
    var transaction = _ref.transaction;
    return !(transaction && !transaction.isCanceled && (transaction.hasCompletedCheckout || transaction.mostRecentOffer));
};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var get = __webpack_require__(1);
var verticals = __webpack_require__(72);

var shouldModalShowHoldRequestInput = exports.shouldModalShowHoldRequestInput = function shouldModalShowHoldRequestInput(item, user) {
    return !!item && !get(item, 'hasRequestedHoldForBuyer') && !get(item, 'isPriceUponRequest') && !get(item, 'isOnHold') && !get(item, 'isSold') && !get(item, 'attributes.customizable[0].value') && get(user, 'canUseNetPrice') && get(item, 'vertical').toLowerCase() === verticals.furniture;
};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var BuyerProfileMutation = function (_Relay$Mutation) {
    _inherits(BuyerProfileMutation, _Relay$Mutation);

    function BuyerProfileMutation() {
        _classCallCheck(this, BuyerProfileMutation);

        return _possibleConstructorReturn(this, (BuyerProfileMutation.__proto__ || Object.getPrototypeOf(BuyerProfileMutation)).apply(this, arguments));
    }

    _createClass(BuyerProfileMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'updateBuyerProfileName',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'UpdateBuyerProfileNameInput!'
                    },
                    name: 'BuyerProfileMutation',
                    responseType: 'UpdateBuyerProfileNamePayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            var _props = this.props,
                user = _props.user,
                displayName = _props.displayName;


            return {
                userServiceId: user.serviceId,
                displayName: displayName
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            children: [{
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'firstName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'lastName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'BuyerProfileMutationRelayQL',
                    type: 'UpdateBuyerProfileNamePayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { user: this.props.user.id }
            }];
        }
    }]);

    return BuyerProfileMutation;
}(Relay.Mutation);

BuyerProfileMutation.fragments = {
    user: function user() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    children: [{
                        fieldName: 'displayName',
                        kind: 'Field',
                        metadata: {},
                        type: 'String'
                    }],
                    fieldName: 'profile',
                    kind: 'Field',
                    metadata: {
                        canHaveSubselections: true
                    },
                    type: 'Profile'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'BuyerProfileMutation_UserRelayQL',
                type: 'User'
            };
        }();
    }
};

module.exports = BuyerProfileMutation;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var FavoriteItemMutation = function (_Relay$Mutation) {
    _inherits(FavoriteItemMutation, _Relay$Mutation);

    function FavoriteItemMutation() {
        _classCallCheck(this, FavoriteItemMutation);

        return _possibleConstructorReturn(this, (FavoriteItemMutation.__proto__ || Object.getPrototypeOf(FavoriteItemMutation)).apply(this, arguments));
    }

    _createClass(FavoriteItemMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'favoriteItem',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'FavoriteItemInput!'
                    },
                    name: 'FavoriteItemMutation',
                    responseType: 'FavoriteItemPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            return {
                action: this.props.action,
                userId: this.props.userId,
                itemId: this.props.item.serviceId,
                portfolioId: this.props.portfolioId
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'FavoriteItemMutationRelayQL',
                    type: 'FavoriteItemPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { item: this.props.item.id }
            }];
        }
    }]);

    return FavoriteItemMutation;
}(Relay.Mutation);

FavoriteItemMutation.fragments = {
    item: function item() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'FavoriteItemMutation_ItemRelayQL',
                type: 'Item'
            };
        }();
    }
};

module.exports = FavoriteItemMutation;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var TradeStatusMutation = function (_Relay$Mutation) {
    _inherits(TradeStatusMutation, _Relay$Mutation);

    function TradeStatusMutation() {
        _classCallCheck(this, TradeStatusMutation);

        return _possibleConstructorReturn(this, (TradeStatusMutation.__proto__ || Object.getPrototypeOf(TradeStatusMutation)).apply(this, arguments));
    }

    _createClass(TradeStatusMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'editVerifiedTradeMutation',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'EditVerifiedTradeInput!'
                    },
                    name: 'TradeStatusMutation',
                    responseType: 'EditVerifiedTradePayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            return {
                userId: this.props.user.serviceId,
                verifiedTradeStatus: this.props.tradeStatus
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'TradeStatusMutationRelayQL',
                    type: 'EditVerifiedTradePayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { user: this.props.user.id }
            }];
        }
    }]);

    return TradeStatusMutation;
}(Relay.Mutation);

TradeStatusMutation.fragments = {
    user: function user() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'verifiedTradeStatus',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'TradeStatusMutation_UserRelayQL',
                type: 'User'
            };
        }();
    }
};

module.exports = TradeStatusMutation;

/***/ },
/* 63 */
/***/ function(module, exports) {

"use strict";
'use strict';

module.exports = {
    getFailsMaxLengthFunc: function getFailsMaxLengthFunc(length) {
        return function (str) {
            return str.length > length;
        };
    },
    getMatchesRegexFunc: function getMatchesRegexFunc(regex) {
        return function (str) {
            return !!str.match(regex);
        };
    },
    getFailsRequiredFunc: function getFailsRequiredFunc() {
        return function (str) {
            return !str;
        };
    },
    getMaxLengthError: function getMaxLengthError(lengthLimit) {
        return 'Please enter a maximum of ' + lengthLimit + ' characters.';
    },
    sharedRegex: {
        specialChars: /[!@#$%^&*()+=><?]+/ig,
        validEmail: /^\S+@\S+\.\S+$/i
    }
};

/***/ },
/* 64 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainFormContainer":"src-scss-abTests-modal-sidebar---mainFormContainer---w7WCf","formWrapper":"src-scss-abTests-modal-sidebar---formWrapper---33Mz7","makeOfferModalLink":"src-scss-abTests-modal-sidebar---makeOfferModalLink---1VRLD","sidebarWrapper":"src-scss-abTests-modal-sidebar---sidebarWrapper---1UtYZ","desktopPromptList":"src-scss-abTests-modal-sidebar---desktopPromptList---2H5eR","prompt":"src-scss-abTests-modal-sidebar---prompt---20slK","mobilePrompt":"src-scss-abTests-modal-sidebar---mobilePrompt---226YT"};

/***/ },
/* 65 */
/***/ function(module, exports) {

module.exports = {
	"successGenericHeader": "Success",
	"successMsg": "Your {successType} was sent successfully!",
	"viewRequest": "You can view your request at any time in ",
	"myConversations": "My Conversations"
};

/***/ },
/* 66 */
/***/ function(module, exports) {

module.exports = {
	"isRequired": "This field is required.",
	"invalidEmail": "Please enter a valid email address.",
	"specialChars": "This field may not contain special characters.",
	"positiveNumber": "Please enter a value greater than zero.",
	"underListPrice": "Please enter an offer below the list price.",
	"lowBallErrorLabel": "offer below {threshold}"
};

/***/ },
/* 67 */
/***/ function(module, exports) {

module.exports = {
	"item": "CONTACT_SELLER_PDP",
	"itemNetPrice": "CONTACT_SELLER_NET_PRICE",
	"seller": "CONTACT_SELLER_STOREFRONT"
};

/***/ },
/* 68 */
/***/ function(module, exports) {

module.exports = require("dibs-com-modal/dist/styles.css");

/***/ },
/* 69 */
/***/ function(module, exports) {

module.exports = require("dibs-currency-helpers");

/***/ },
/* 70 */
/***/ function(module, exports) {

module.exports = require("dibs-overlay-spinner");

/***/ },
/* 71 */
/***/ function(module, exports) {

module.exports = require("dibs-tracking");

/***/ },
/* 72 */
/***/ function(module, exports) {

module.exports = require("dibs-vertical-helpers");

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var ContactDealerModal = __webpack_require__(93);

var _require = __webpack_require__(9),
    hoistStatics = _require.hoistStatics,
    compose = _require.compose;

var redux = __webpack_require__(94);
var relay = __webpack_require__(95);

module.exports = hoistStatics(compose(relay, redux))(ContactDealerModal);

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var MakeOfferModal = __webpack_require__(96);

var _require = __webpack_require__(9),
    hoistStatics = _require.hoistStatics,
    compose = _require.compose;

var redux = __webpack_require__(97);
var relay = __webpack_require__(98);

module.exports = hoistStatics(compose(relay, redux))(MakeOfferModal);

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var MakePreAuthOfferModal = __webpack_require__(99);

var _require = __webpack_require__(9),
    hoistStatics = _require.hoistStatics,
    compose = _require.compose;

var redux = __webpack_require__(100);
var relay = __webpack_require__(101);

module.exports = hoistStatics(compose(relay, redux))(MakePreAuthOfferModal);

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _require = __webpack_require__(9),
    compose = _require.compose;

var redux = __webpack_require__(102);
var ModalWrapper = __webpack_require__(17);

module.exports = compose(redux)(ModalWrapper);

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var NetPriceModal = __webpack_require__(103);

var _require = __webpack_require__(9),
    hoistStatics = _require.hoistStatics,
    compose = _require.compose;

var redux = __webpack_require__(104);
var relay = __webpack_require__(105);

module.exports = hoistStatics(compose(relay, redux))(NetPriceModal);

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(68);

var React = __webpack_require__(0);
var tokenReplace = __webpack_require__(5);
var intelligentFormat = __webpack_require__(31);
var get = __webpack_require__(1);
var Component = React.Component,
    PropTypes = React.PropTypes;


var tracking = __webpack_require__(2);

var _require = __webpack_require__(58),
    canMakePreAuthOffer = _require.canMakePreAuthOffer;

var Submit = __webpack_require__(12);

var style = __webpack_require__(124);

var AbandonMakeOffer = function (_Component) {
    _inherits(AbandonMakeOffer, _Component);

    function AbandonMakeOffer(props) {
        _classCallCheck(this, AbandonMakeOffer);

        var _this = _possibleConstructorReturn(this, (AbandonMakeOffer.__proto__ || Object.getPrototypeOf(AbandonMakeOffer)).call(this, props));

        _this.onSubmitPreAuthOffer = _this.onSubmitPreAuthOffer.bind(_this);
        return _this;
    }

    _createClass(AbandonMakeOffer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                authResultAction = _props.authResultAction,
                authWasMakeOffer = _props.authWasMakeOffer;


            if (authResultAction && authWasMakeOffer && canMakePreAuthOffer(this.props)) {
                this.makeSubmitPreAuthOffer();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            tracking.abandonOfferEntry();
        }
    }, {
        key: 'getOfferMessage',
        value: function getOfferMessage() {
            var _props2 = this.props,
                seller = _props2.seller,
                messageValue = _props2.messageValue,
                nameValue = _props2.nameValue,
                copy = _props2.copy;


            return messageValue || tokenReplace(copy.get('abandonMakeOfferMessage'), {
                dealerName: get(seller, 'sellerProfile.company'),
                userDisplayName: nameValue,
                offerPrice: this.getOfferPrice()
            });
        }
    }, {
        key: 'getOfferPrice',
        value: function getOfferPrice() {
            var _props3 = this.props,
                currency = _props3.currency,
                offerValue = _props3.offerValue;

            return intelligentFormat(offerValue, currency);
        }
    }, {
        key: 'makeSubmitPreAuthOffer',
        value: function makeSubmitPreAuthOffer(messageValue) {
            var _props4 = this.props,
                submitPreAuthOffer = _props4.submitPreAuthOffer,
                onAbandonMakeOfferSuccess = _props4.onAbandonMakeOfferSuccess;


            submitPreAuthOffer(_extends({}, this.props, {
                isAbandonCheckout: true,
                messageValue: messageValue,
                onSuccess: function onSuccess() {
                    onAbandonMakeOfferSuccess();
                    tracking.abandonOfferSubmitted();
                }
            }));
        }
    }, {
        key: 'onSubmitPreAuthOffer',
        value: function onSubmitPreAuthOffer(e) {
            e.preventDefault();
            this.makeSubmitPreAuthOffer(this.getOfferMessage());
        }
    }, {
        key: 'render',
        value: function render() {
            var _props5 = this.props,
                isSending = _props5.isSending,
                copy = _props5.copy,
                onLeaveAbandonMakeOffer = _props5.onLeaveAbandonMakeOffer;

            return React.createElement(
                'form',
                { onSubmit: this.onSubmitPreAuthOffer, className: style.container },
                React.createElement(
                    'p',
                    { className: style.description },
                    tokenReplace(copy.get('abandonMakeOfferContent'), {
                        offerPrice: this.getOfferPrice()
                    })
                ),
                React.createElement(Submit, {
                    className: style.cta + ' button-medium button-primary',
                    copyCta: copy.get('abandonMakeOfferCta'),
                    isDisabled: isSending,
                    copyCtaBusy: copy.get('busyCta'),
                    isBusy: isSending
                }),
                React.createElement(
                    'a',
                    { href: '/',
                        onClick: onLeaveAbandonMakeOffer,
                        className: style.cta
                    },
                    copy.get('abandonMakeOfferLeaveCta')
                )
            );
        }
    }]);

    return AbandonMakeOffer;
}(Component);

AbandonMakeOffer.defaultProps = {
    modalKey: 'abandonMakeOffer',
    onAbandonMakeOfferSuccess: function onAbandonMakeOfferSuccess() {},
    onLeaveAbandonMakeOffer: function onLeaveAbandonMakeOffer() {}
};

AbandonMakeOffer.propTypes = {
    onAbandonMakeOfferSuccess: PropTypes.func,
    onLeaveAbandonMakeOffer: PropTypes.func
};

module.exports = AbandonMakeOffer;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var ModalSidebar = __webpack_require__(116);
var EmailField = __webpack_require__(50);
var HoldRequestInput = __webpack_require__(35);
var MessageField = __webpack_require__(15);
var NameField = __webpack_require__(22);
var OptInInput = __webpack_require__(53);
var Submit = __webpack_require__(12);
var get = __webpack_require__(1);
var contactModalTracking = __webpack_require__(2);
var composeClassNames = __webpack_require__(43);
var sidebarStyles = __webpack_require__(64);
var baseStyles = composeClassNames(__webpack_require__(6), __webpack_require__(127));
var css = void 0;

var ContactDealer = function (_Component) {
    _inherits(ContactDealer, _Component);

    function ContactDealer(props) {
        _classCallCheck(this, ContactDealer);

        var _this = _possibleConstructorReturn(this, (ContactDealer.__proto__ || Object.getPrototypeOf(ContactDealer)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onGoToMakeOffer = _this.onGoToMakeOffer.bind(_this);
        _this.onOptInChange = _this.onCheckboxChange.bind(_this, 'optIn');
        _this.onHoldRequestChange = _this.onCheckboxChange.bind(_this, 'holdRequest');

        if (get(props, 'item') && props.optimizelyVariant === 'contactDealerSidebar' && !props.userHasEverLoggedIn) {
            css = composeClassNames(baseStyles, sidebarStyles);
        } else {
            css = baseStyles;
        }
        return _this;
    }

    _createClass(ContactDealer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                authResultAction = _props.authResultAction,
                clearAuthResultAction = _props.clearAuthResultAction,
                hideModal = _props.hideModal,
                submitContactDealer = _props.submitContactDealer,
                optimizelyVariant = _props.optimizelyVariant,
                copy = _props.copy,
                setGhostText = _props.setGhostText,
                authWasMakeOffer = _props.authWasMakeOffer,
                modalContentData = _props.modalContentData;

            if (optimizelyVariant === 'contactDealerSidebar') {
                setGhostText(copy.get('modalSidebarGhostText'));
            }

            if (modalContentData && modalContentData.isHoldRequestChecked) {
                this.onHoldRequestChange({ target: { checked: true } });
            }

            if (authResultAction && !authWasMakeOffer) {
                Promise.resolve(submitContactDealer(this.props)).catch(function () {});
                if (authResultAction === 'register') {
                    hideModal();
                }
                clearAuthResultAction();
                return;
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props2 = this.props,
                isShowHoldRequest = _props2.isShowHoldRequest,
                trackingModalName = _props2.trackingModalName;

            if (isShowHoldRequest) {
                contactModalTracking.eventHoldRequestDisplayed({ sourceModal: trackingModalName });
            }
        }
    }, {
        key: 'onCheckboxChange',
        value: function onCheckboxChange(checkboxField, e) {
            var _props3 = this.props,
                trackingModalName = _props3.trackingModalName,
                updateContactModalFields = _props3.updateContactModalFields,
                holdRequestedFromConfirmationModal = _props3.holdRequestedFromConfirmationModal;

            var checkboxValue = e.target.checked;

            var sourceModal = '';
            if (holdRequestedFromConfirmationModal) {
                sourceModal = 'contact dealer confirmation modal';
            } else {
                sourceModal = trackingModalName;
            }

            if (checkboxField === 'holdRequest' && checkboxValue) {
                contactModalTracking.eventHoldRequestEnabled({ sourceModal: sourceModal });
            }
            updateContactModalFields({
                field: checkboxField,
                value: checkboxValue
            });
        }
    }, {
        key: 'onGoToMakeOffer',
        value: function onGoToMakeOffer() {
            var _props4 = this.props,
                goToStep = _props4.goToStep,
                isMessageFieldOpen = _props4.isMessageFieldOpen,
                item = _props4.item,
                messageValue = _props4.messageValue,
                priceType = _props4.priceType,
                seller = _props4.seller,
                toggleMessage = _props4.toggleMessage,
                trackingParams = _props4.trackingParams,
                user = _props4.user;


            if (messageValue && !isMessageFieldOpen) {
                toggleMessage();
            }
            contactModalTracking.eventOfferEnable(Object.assign({}, trackingParams, { user: user, seller: seller, item: item, priceType: priceType }));
            goToStep({ step: 'makeOffer' });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            var _props5 = this.props,
                guidedPromptSelection = _props5.guidedPromptSelection,
                item = _props5.item,
                optimizelyVariant = _props5.optimizelyVariant,
                submitContactDealer = _props5.submitContactDealer,
                trackingParams = _props5.trackingParams,
                userHasEverLoggedIn = _props5.userHasEverLoggedIn;


            Promise.resolve(submitContactDealer(this.props)).then(function () {
                contactModalTracking.eventSend(Object.assign({}, trackingParams, {
                    trackVariant: optimizelyVariant && item && !userHasEverLoggedIn,
                    guidedPromptSelection: guidedPromptSelection,
                    optimizelyVariant: optimizelyVariant
                }));
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props6 = this.props,
                copy = _props6.copy,
                emailValue = _props6.emailValue,
                errors = _props6.errors,
                userHasEverLoggedIn = _props6.userHasEverLoggedIn,
                guidedGhostText = _props6.guidedGhostText,
                isHoldRequestChecked = _props6.isHoldRequestChecked,
                isOptInChecked = _props6.isOptInChecked,
                isSending = _props6.isSending,
                isShowHoldRequest = _props6.isShowHoldRequest,
                isShowOptIn = _props6.isShowOptIn,
                item = _props6.item,
                messageValue = _props6.messageValue,
                nameValue = _props6.nameValue,
                optInLabel = _props6.optInLabel,
                optimizelyVariant = _props6.optimizelyVariant,
                updateContactModalFields = _props6.updateContactModalFields,
                isUserNameSet = _props6.isUserNameSet,
                isUserInitiallyLoggedIn = _props6.isUserInitiallyLoggedIn,
                modalContentData = _props6.modalContentData;


            var onUpdateTextFields = updateContactModalFields.bind(this);
            var copySuffix = get(modalContentData, 'copySuffix');
            copySuffix = copySuffix ? '-' + copySuffix : '';
            var messagePlaceholder = copy.get(item ? 'messagePlaceholder' + copySuffix : 'messagePlaceholderStorefront');
            var labelText = copy.get('labelMessage' + copySuffix);
            var descriptionText = copy.get('descriptionText' + copySuffix);

            var showSidebar = !!item && !userHasEverLoggedIn && optimizelyVariant === 'contactDealerSidebar';

            var messageField = React.createElement(MessageField, {
                copy: copy,
                errors: errors,
                messagePlaceholder: guidedGhostText ? guidedGhostText : messagePlaceholder,
                messageValue: messageValue,
                onMessageChange: onUpdateTextFields,
                labelText: labelText,
                descriptionText: descriptionText
            });

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: css.mainFormContainer },
                    showSidebar ? React.createElement(ModalSidebar, { item: item, copy: copy }) : false,
                    React.createElement(
                        'div',
                        { className: showSidebar ? css.formWrapper : null },
                        guidedGhostText ? messageField : false,
                        React.createElement(NameField, {
                            isUserNameSet: isUserNameSet,
                            errors: errors,
                            copy: copy,
                            onNameChange: onUpdateTextFields,
                            nameValue: nameValue
                        }),
                        React.createElement(EmailField, {
                            copy: copy,
                            emailValue: emailValue,
                            errors: errors,
                            isUserInitiallyLoggedIn: isUserInitiallyLoggedIn,
                            onEmailChange: onUpdateTextFields
                        }),
                        guidedGhostText ? false : messageField,
                        isShowHoldRequest ? React.createElement(HoldRequestInput, {
                            isChecked: isHoldRequestChecked,
                            copyLabel: copy.get('holdRequestLabel'),
                            copyInfoChecked: copy.get('holdRequestInfoChecked'),
                            onChange: this.onHoldRequestChange
                        }) : false,
                        React.createElement(Submit, {
                            isDisabled: isSending,
                            copyCta: copy.get('sendCta'),
                            copyCtaBusy: copy.get('busyCta'),
                            isBusy: isSending,
                            dataTn: 'contact-dealer-submit'
                        }),
                        isShowOptIn ? React.createElement(OptInInput, {
                            isChecked: isOptInChecked,
                            copyLabel: optInLabel,
                            copyInfo: copy.get('optInInfo'),
                            onChange: this.onOptInChange
                        }) : false,
                        get(item, 'canBuyerMakeOffer') ? React.createElement(
                            'div',
                            {
                                'data-tn': 'contact-dealer-make-offer',
                                onClick: this.onGoToMakeOffer,
                                className: css.makeOfferModalLink
                            },
                            React.createElement(
                                'span',
                                null,
                                copy.get('makeOfferModalLinkPrompt')
                            ),
                            React.createElement(
                                'span',
                                { className: css.makeOfferModalLinkCta },
                                copy.get('makeOfferModalLinkCta')
                            )
                        ) : false
                    )
                )
            );
        }
    }]);

    return ContactDealer;
}(Component);

ContactDealer.propTypes = {
    authResultAction: PropTypes.string,
    clearAuthResultAction: PropTypes.func,
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    userHasEverLoggedIn: PropTypes.bool,
    emailValue: PropTypes.string,
    errors: PropTypes.object,
    goToStep: PropTypes.func,
    guidedGhostText: PropTypes.string,
    guidedPromptSelection: PropTypes.string,
    hideModal: PropTypes.func,
    isHoldRequestChecked: PropTypes.bool,
    isMessageFieldOpen: PropTypes.bool,
    isOptInChecked: PropTypes.bool,
    isSending: PropTypes.bool,
    isShowHoldRequest: PropTypes.bool,
    isShowOptIn: PropTypes.bool,
    item: PropTypes.object,
    messageValue: PropTypes.string,
    nameValue: PropTypes.string,
    onSubmit: PropTypes.func,
    optInLabel: PropTypes.string,
    optimizelyVariant: PropTypes.string,
    priceType: PropTypes.string,
    relay: PropTypes.object,
    seller: PropTypes.object,
    setOptIn: PropTypes.func,
    setGhostText: PropTypes.func,
    isUserInitiallyLoggedIn: PropTypes.bool,
    isUserNameSet: PropTypes.bool,
    submitContactDealer: PropTypes.func,
    toggleMessage: PropTypes.func,
    trackingModalName: PropTypes.string,
    trackingParams: PropTypes.shape({
        isItem: PropTypes.bool,
        item: PropTypes.object,
        linkLocation: PropTypes.string,
        purchaseStatus: PropTypes.string,
        vpvParams: PropTypes.object,
        vpvParamsQuery: PropTypes.string
    }),
    updateContactModalFields: PropTypes.func,
    user: PropTypes.object,
    authWasMakeOffer: PropTypes.bool,
    holdRequestedFromConfirmationModal: PropTypes.bool,
    modalContentData: PropTypes.object
};

ContactDealer.defaultProps = {
    modalKey: 'contactDealer',
    trackingModalName: 'contact dealer modal'
};

module.exports = ContactDealer;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes,
    Component = React.Component;

var SectionToggle = __webpack_require__(23);
var MessageField = __webpack_require__(15);
var Submit = __webpack_require__(12);
var LowBallOptionList = __webpack_require__(111);
var css = __webpack_require__(6);

var LowBall = function (_Component) {
    _inherits(LowBall, _Component);

    function LowBall(props) {
        _classCallCheck(this, LowBall);

        var _this = _possibleConstructorReturn(this, (LowBall.__proto__ || Object.getPrototypeOf(LowBall)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onOfferChange = _this.onOfferChange.bind(_this);
        return _this;
    }

    _createClass(LowBall, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var messageErrors = nextProps.messageErrors,
                isMessageFieldOpen = nextProps.isMessageFieldOpen,
                toggleMessage = nextProps.toggleMessage;

            if (messageErrors && Object.keys(messageErrors).length && !isMessageFieldOpen) {
                toggleMessage();
            }
        }
    }, {
        key: 'onOfferChange',
        value: function onOfferChange(fieldAndValue) {
            var _props = this.props,
                setLowBallOfferDiscount = _props.setLowBallOfferDiscount,
                copy = _props.copy,
                currency = _props.currency,
                priceValue = _props.priceValue;


            setLowBallOfferDiscount(Object.assign({}, _extends({
                priceValue: priceValue,
                copy: copy,
                currency: currency
            }, fieldAndValue)));
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            var _props2 = this.props,
                submitPreAuthOffer = _props2.submitPreAuthOffer,
                submitMakeOffer = _props2.submitMakeOffer,
                isPreAuthOfferLowball = _props2.isPreAuthOfferLowball;

            if (isPreAuthOfferLowball) {
                submitPreAuthOffer(this.props, { bypassLowball: true });
            } else {
                submitMakeOffer(this.props, { bypassLowball: true });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                copy = _props3.copy,
                errors = _props3.errors,
                isMessageFieldOpen = _props3.isMessageFieldOpen,
                isSending = _props3.isSending,
                lowBallOptions = _props3.lowBallOptions,
                messageValue = _props3.messageValue,
                submitDisabled = _props3.submitDisabled,
                toggleMessage = _props3.toggleMessage,
                updateContactModalFields = _props3.updateContactModalFields;

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: css.mainFormContainer },
                    React.createElement(LowBallOptionList, _extends({}, this.props, {
                        onOfferChange: this.onOfferChange,
                        onQuantityChange: updateContactModalFields.bind(this),
                        options: lowBallOptions
                    })),
                    React.createElement(
                        SectionToggle,
                        {
                            onToggle: toggleMessage.bind(this),
                            isOpen: isMessageFieldOpen,
                            toggleTn: 'send-message-toggle',
                            toggleLabel: copy.get('labelMessageToggle')
                        },
                        React.createElement(MessageField, {
                            errors: errors,
                            copy: copy,
                            onMessageChange: updateContactModalFields.bind(this),
                            messagePlaceholder: copy.get('messagePlaceholder'),
                            messageValue: messageValue,
                            hideLabel: true
                        })
                    ),
                    React.createElement(Submit, {
                        isDisabled: isSending || submitDisabled,
                        copyCta: copy.get('continueCta'),
                        copyCtaBusy: copy.get('busyCta'),
                        isBusy: isSending,
                        dataTn: 'contact-dealer-submit'
                    })
                )
            );
        }
    }]);

    return LowBall;
}(Component);

LowBall.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    errors: PropTypes.object,
    isSending: PropTypes.bool,
    isMessageFieldOpen: PropTypes.bool,
    isPricePerPiece: PropTypes.bool,
    lowBallOptions: PropTypes.object,
    messageValue: PropTypes.string,
    offerValue: PropTypes.string,
    onMessageChange: PropTypes.func,
    onNameChange: PropTypes.func,
    onSubmit: PropTypes.func,
    pieces: PropTypes.number,
    quantityValue: PropTypes.string,
    setLowBallOfferDiscount: PropTypes.func,
    state: PropTypes.shape({
        priceValue: PropTypes.number.isRequired
    }),
    submitDisabled: PropTypes.bool,
    submitMakeOffer: PropTypes.func,
    toggleMessage: PropTypes.func,
    updateContactModalFields: PropTypes.func,
    currency: PropTypes.string,
    priceValue: PropTypes.number,
    submitPreAuthOffer: PropTypes.func,
    isPreAuthOfferLowball: PropTypes.bool
};

LowBall.defaultProps = {
    modalKey: 'lowBall'
};

module.exports = LowBall;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var OverlaySpinner = __webpack_require__(70);
var SectionToggle = __webpack_require__(23);
var MessageField = __webpack_require__(15);
var NameField = __webpack_require__(22);
var OfferField = __webpack_require__(52);
var QuantityField = __webpack_require__(56);
var DisplayPrice = __webpack_require__(34);
var Submit = __webpack_require__(12);
var OfferGuarantee = __webpack_require__(117);
var css = __webpack_require__(6);
var makeOfferTestHelper = __webpack_require__(119);
var tracking = __webpack_require__(2);

var _require = __webpack_require__(58),
    canMakePreAuthOffer = _require.canMakePreAuthOffer;

var pdpDisplayHelper = __webpack_require__(150).default;
var get = __webpack_require__(1);

var isTestVariant = function isTestVariant(_ref) {
    var optimizelyVariant = _ref.optimizelyVariant;
    return makeOfferTestHelper.isTestVariant(optimizelyVariant);
};
var isAutoSubmit = function isAutoSubmit(props) {
    return props.authResultAction && props.authWasMakeOffer && canMakePreAuthOffer(props);
};

var MakeOffer = function (_Component) {
    _inherits(MakeOffer, _Component);

    function MakeOffer(props) {
        _classCallCheck(this, MakeOffer);

        var _this = _possibleConstructorReturn(this, (MakeOffer.__proto__ || Object.getPrototypeOf(MakeOffer)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSubmitPreAuthOffer = _this.onSubmitPreAuthOffer.bind(_this);
        _this.onOfferGuaranteeChange = _this.onOfferGuaranteeChange.bind(_this);

        _this.state = {
            isOfferGuaranteeChecked: makeOfferTestHelper.isCheckboxChecked(props.optimizelyVariant),
            shouldShowMakeOfferCheckbox: isTestVariant(props) && canMakePreAuthOffer(props)
        };
        return _this;
    }

    _createClass(MakeOffer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (isAutoSubmit(this.props)) {
                this.props.submitPreAuthOffer(this.props);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                user = _props.user,
                updateContactModalFields = _props.updateContactModalFields;

            updateContactModalFields({
                field: 'name',
                value: get(user, 'profile.displayName') || ''
            });

            this.trackOfferInquiry();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var messageErrors = nextProps.messageErrors,
                isMessageFieldOpen = nextProps.isMessageFieldOpen,
                toggleMessage = nextProps.toggleMessage;

            if (messageErrors && messageErrors.message && !isMessageFieldOpen) {
                toggleMessage();
            }

            if (!this.props.transaction && nextProps.transaction) {
                this.setState({
                    shouldShowMakeOfferCheckbox: isTestVariant(nextProps) && canMakePreAuthOffer(nextProps)
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var isOfferGuaranteeChecked = this.state.isOfferGuaranteeChecked;

            if (prevState.isOfferGuaranteeChecked !== isOfferGuaranteeChecked) {
                this.trackOfferInquiry();
            }
        }
    }, {
        key: 'trackOfferInquiry',
        value: function trackOfferInquiry() {
            var _state = this.state,
                shouldShowMakeOfferCheckbox = _state.shouldShowMakeOfferCheckbox,
                isOfferGuaranteeChecked = _state.isOfferGuaranteeChecked;

            // Offer test is running and checkobox is not checked - dealer message will be sent

            if (shouldShowMakeOfferCheckbox && !isOfferGuaranteeChecked && !isAutoSubmit(this.props)) {
                tracking.offerInquiryEntry();
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            var _state2 = this.state,
                shouldShowMakeOfferCheckbox = _state2.shouldShowMakeOfferCheckbox,
                isOfferGuaranteeChecked = _state2.isOfferGuaranteeChecked;


            if (!shouldShowMakeOfferCheckbox || shouldShowMakeOfferCheckbox && isOfferGuaranteeChecked) {
                var submitMakeOffer = this.props.submitMakeOffer;

                submitMakeOffer(this.props);
            } else if (shouldShowMakeOfferCheckbox) {
                this.onSubmitPreAuthOffer(e);
            }
        }
    }, {
        key: 'onSubmitPreAuthOffer',
        value: function onSubmitPreAuthOffer(e) {
            e.preventDefault();
            var _props2 = this.props,
                submitPreAuthOffer = _props2.submitPreAuthOffer,
                setPreAuthOfferLowball = _props2.setPreAuthOfferLowball;

            setPreAuthOfferLowball(true);
            submitPreAuthOffer(this.props);
        }
    }, {
        key: 'onOfferGuaranteeChange',
        value: function onOfferGuaranteeChange(isOfferGuaranteeChecked) {
            this.setState({ isOfferGuaranteeChecked: isOfferGuaranteeChecked });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                copy = _props3.copy,
                currencySymbol = _props3.currencySymbol,
                errors = _props3.errors,
                formattedNetPrice = _props3.formattedNetPrice,
                formattedRetailPrice = _props3.formattedRetailPrice,
                formattedSalePrice = _props3.formattedSalePrice,
                isMessageFieldOpen = _props3.isMessageFieldOpen,
                isPricePerPiece = _props3.isPricePerPiece,
                isSending = _props3.isSending,
                messageValue = _props3.messageValue,
                offerValue = _props3.offerValue,
                pieces = _props3.pieces,
                priceType = _props3.priceType,
                quantityValue = _props3.quantityValue,
                toggleMessage = _props3.toggleMessage,
                updateContactModalFields = _props3.updateContactModalFields,
                nameValue = _props3.nameValue,
                authResultAction = _props3.authResultAction,
                authWasMakeOffer = _props3.authWasMakeOffer,
                item = _props3.item,
                user = _props3.user;

            var displayData = pdpDisplayHelper({
                item: item,
                buyerId: get(user, 'serviceId'),
                buyerHasTradePermission: get(user, 'isVerifiedTrade')
            }).getShowPrices();
            var showNetPrice = displayData.showNetPrice;
            var _state3 = this.state,
                shouldShowMakeOfferCheckbox = _state3.shouldShowMakeOfferCheckbox,
                isOfferGuaranteeChecked = _state3.isOfferGuaranteeChecked;

            var onUpdateTextFields = updateContactModalFields.bind(this);
            var messagePlaceholder = copy.get('messagePlaceholder');
            var submitButtonCopy = copy.get('continueCta');

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: css.mainFormContainer },
                    React.createElement(DisplayPrice, {
                        className: css.offerInfo,
                        formattedNetPrice: formattedNetPrice,
                        formattedRetailPrice: formattedRetailPrice,
                        formattedSalePrice: formattedSalePrice,
                        isPricePerPiece: isPricePerPiece,
                        priceType: priceType,
                        copy: copy,
                        showNetPrice: showNetPrice
                    }),
                    React.createElement(OfferField, {
                        copy: copy,
                        currencySymbol: currencySymbol,
                        errors: errors,
                        hideQuantity: true,
                        isPricePerPiece: isPricePerPiece,
                        offerValue: offerValue,
                        onOfferChange: onUpdateTextFields,
                        pieces: pieces,
                        quantityValue: quantityValue
                    }),
                    React.createElement(QuantityField, {
                        copy: copy,
                        isPricePerPiece: isPricePerPiece,
                        onOfferChange: onUpdateTextFields,
                        pieces: pieces,
                        quantityValue: quantityValue
                    }),
                    React.createElement(NameField, {
                        errors: errors,
                        copy: copy,
                        onNameChange: onUpdateTextFields,
                        nameValue: nameValue
                    }),
                    React.createElement(
                        SectionToggle,
                        {
                            isOpen: !!isMessageFieldOpen,
                            onToggle: toggleMessage.bind(this),
                            toggleLabel: copy.get('labelMessageToggle'),
                            toggleTn: 'send-message-toggle'
                        },
                        React.createElement(MessageField, {
                            copy: copy,
                            errors: errors,
                            hideLabel: true,
                            messagePlaceholder: messagePlaceholder,
                            messageValue: messageValue,
                            onMessageChange: onUpdateTextFields
                        })
                    ),
                    shouldShowMakeOfferCheckbox && React.createElement(OfferGuarantee, {
                        onChange: this.onOfferGuaranteeChange,
                        checked: isOfferGuaranteeChecked
                    }),
                    !shouldShowMakeOfferCheckbox && React.createElement(
                        'div',
                        { className: css.offerSubmitLabel },
                        copy.get('offerSubmitLabel')
                    ),
                    React.createElement(Submit, {
                        copyCta: submitButtonCopy,
                        dataTn: 'contact-dealer-submit',
                        isDisabled: isSending,
                        copyCtaBusy: copy.get('busyCta'),
                        isBusy: isSending
                    })
                ),
                authResultAction && authWasMakeOffer && isSending && React.createElement(OverlaySpinner, {
                    additionalWrapperClasses: css.spinnerWrapper,
                    additionalSpinnerClasses: css.centeredSpinner,
                    position: 'isAbsolute'
                })
            );
        }
    }]);

    return MakeOffer;
}(Component);

;

MakeOffer.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currencySymbol: PropTypes.string,
    errors: PropTypes.object,
    formattedNetPrice: PropTypes.string,
    formattedRetailPrice: PropTypes.string,
    formattedSalePrice: PropTypes.string,
    isMessageFieldOpen: PropTypes.bool,
    isPricePerPiece: PropTypes.bool,
    isUserNameSet: PropTypes.bool,
    isSending: PropTypes.bool,
    item: PropTypes.object,
    messageValue: PropTypes.string,
    nameValue: PropTypes.string,
    offerValue: PropTypes.string,
    pieces: PropTypes.number,
    priceType: PropTypes.string,
    quantityValue: PropTypes.string,
    seller: PropTypes.object,
    submitMakeOffer: PropTypes.func,
    submitPreAuthOffer: PropTypes.func,
    setPreAuthOfferLowball: PropTypes.func,
    toggleMessage: PropTypes.func,
    updateContactModalFields: PropTypes.func,
    user: PropTypes.object,
    transaction: PropTypes.object,
    optimizelyVariant: PropTypes.string,
    authResultAction: PropTypes.bool,
    authWasMakeOffer: PropTypes.bool
};

MakeOffer.defaultProps = {
    modalKey: 'makeOffer'
};

module.exports = MakeOffer;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes,
    Component = React.Component;

var MessageField = __webpack_require__(15);
var DisplayPrice = __webpack_require__(34);
var Submit = __webpack_require__(12);
var css = __webpack_require__(138);

var _require = __webpack_require__(69),
    intelligentFormat = _require.intelligentFormat;

var tokenReplace = __webpack_require__(5);
var get = __webpack_require__(1);
var tracking = __webpack_require__(2);

var MakePreAuthOffer = function (_Component) {
    _inherits(MakePreAuthOffer, _Component);

    function MakePreAuthOffer(props) {
        _classCallCheck(this, MakePreAuthOffer);

        var _this = _possibleConstructorReturn(this, (MakePreAuthOffer.__proto__ || Object.getPrototypeOf(MakePreAuthOffer)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }

    _createClass(MakePreAuthOffer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            tracking.eventPreAuthOfferModalShown(this.props.isAbandonCheckout);
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            this.props.submitPreAuthOffer(this.props);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                copy = _props.copy,
                errors = _props.errors,
                isSending = _props.isSending,
                messageValue = _props.messageValue,
                submitDisabled = _props.submitDisabled,
                updateContactModalFields = _props.updateContactModalFields,
                currency = _props.currency,
                offerValue = _props.offerValue,
                isAbandonCheckout = _props.isAbandonCheckout,
                item = _props.item;


            var isPricePerPiece = get(item, 'pricing.pricePerPiece');
            var formattedPreAuthOfferPrice = intelligentFormat(offerValue, currency, { showDecimal: true });

            var infoCopy = copy.get('preAuthOfferInfo');
            if (isAbandonCheckout) {
                infoCopy = tokenReplace(copy.get('preAuthOfferInfoAbandonCheckout'), {
                    itemTitle: get(item, 'title')
                });
            }

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: css.mainFormContainer },
                    React.createElement(
                        'p',
                        { className: css.preAuthOfferInfo },
                        infoCopy
                    ),
                    React.createElement(DisplayPrice, {
                        copy: copy,
                        priceType: 'PRE_AUTH_OFFER',
                        formattedPreAuthOfferPrice: formattedPreAuthOfferPrice,
                        formattedNetPrice: '',
                        formattedRetailPrice: '',
                        formattedSalePrice: '',
                        isPricePerPiece: isPricePerPiece,
                        className: css.preAuthOfferDisplayPrice
                    }),
                    React.createElement(MessageField, {
                        errors: errors,
                        copy: copy,
                        onMessageChange: updateContactModalFields,
                        messagePlaceholder: tokenReplace(copy.get('preAuthOfferMessagePlaceholder'), {
                            price: formattedPreAuthOfferPrice
                        }),
                        messageValue: messageValue,
                        labelText: copy.get('preAuthOfferMessageLabel')
                    }),
                    React.createElement(Submit, {
                        isDisabled: isSending || submitDisabled || !messageValue,
                        copyCta: copy.get('preAuthOfferCta'),
                        copyCtaBusy: copy.get('busyCta'),
                        isBusy: isSending,
                        dataTn: 'pre-auth-offer-submit'
                    })
                )
            );
        }
    }]);

    return MakePreAuthOffer;
}(Component);

MakePreAuthOffer.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currency: PropTypes.string,
    isSending: PropTypes.bool,
    isPricePerPiece: PropTypes.bool,
    messageValue: PropTypes.string,
    offerValue: PropTypes.string,
    onMessageChange: PropTypes.func,
    onSubmit: PropTypes.func,
    submitDisabled: PropTypes.bool,
    submitPreAuthOffer: PropTypes.func,
    errors: PropTypes.object,
    goToSuccess: PropTypes.func,
    goToStep: PropTypes.func,
    updateContactModalFields: PropTypes.func,
    isAbandonCheckout: PropTypes.bool,
    item: PropTypes.object
};

MakePreAuthOffer.defaultProps = {
    modalKey: 'makePreAuthOffer'
};

module.exports = MakePreAuthOffer;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var get = __webpack_require__(1);
var tracking = __webpack_require__(71);
var Component = React.Component,
    PropTypes = React.PropTypes;


var ViewInvoiceLink = __webpack_require__(115);
var style = __webpack_require__(139);

var trackCTA = function trackCTA(selection) {
    tracking.trackEvent({
        label: 'contact link in PDP - sidebar|pre-populated submitted:' + selection,
        category: 'contact dealer',
        action: 'contact dealer guided selection submitted'
    });
};

var PreContactDealer = function (_Component) {
    _inherits(PreContactDealer, _Component);

    function PreContactDealer() {
        _classCallCheck(this, PreContactDealer);

        var _this = _possibleConstructorReturn(this, (PreContactDealer.__proto__ || Object.getPrototypeOf(PreContactDealer)).call(this));

        _this.onViewInvoiceClick = _this.onViewInvoiceClick.bind(_this);
        _this.makeOffer = _this.goToStep.bind(_this, {
            step: 'makeOffer',
            selection: 'make offer'
        });
        _this.placeOnHold = _this.goToStep.bind(_this, {
            step: 'contactDealer',
            selection: 'place item on hold',
            modalContentData: {
                isShowHoldRequest: false,
                isHoldRequestChecked: true,
                copySuffix: 'placeOnHold'
            }
        });
        _this.askQuestion = _this.goToStep.bind(_this, {
            step: 'contactDealer',
            selection: 'ask a question',
            modalContentData: { isShowHoldRequest: false }
        });

        _this.openShippingQuoteModal = _this.handleCtaClick.bind(_this, {
            action: 'openShippingQuoteModal',
            selection: 'ask about shipping'
        });
        _this.openConditionReportModal = _this.handleCtaClick.bind(_this, {
            action: 'openConditionReportModal',
            selection: 'request condition report'
        });
        return _this;
    }

    _createClass(PreContactDealer, [{
        key: 'goToStep',
        value: function goToStep(payload, event) {
            event.preventDefault();
            var goToStep = this.props.goToStep;

            goToStep(payload);
            trackCTA(payload.selection);
        }
    }, {
        key: 'handleCtaClick',
        value: function handleCtaClick(payload, event) {
            event.preventDefault();
            var _props = this.props,
                hideModal = _props.hideModal,
                handleCtaClick = _props.handleCtaClick;

            hideModal();

            // Set timeout needed so that `openShippingQuoteModal` is called asynchronously from `hideModal`,
            // and `overflow: hidden` is not removed while modal is open
            setTimeout(function () {
                return handleCtaClick(payload);
            }, 0);
            trackCTA(payload.selection);
        }
    }, {
        key: 'onViewInvoiceClick',
        value: function onViewInvoiceClick(payload) {
            trackCTA('view invoice');
            this.props.onViewInvoiceClick(payload);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isShowHoldRequest = _props2.isShowHoldRequest,
                viewer = _props2.viewer,
                item = _props2.item,
                user = _props2.user,
                copy = _props2.copy;


            return React.createElement(
                'div',
                { className: style.body },
                React.createElement(
                    'div',
                    { className: style.question },
                    copy.get('preContactDealerSubtitle')
                ),
                React.createElement(
                    'a',
                    { href: '#0', onClick: this.openShippingQuoteModal, className: style.button },
                    copy.get('requestShippingQuote')
                ),
                React.createElement(
                    'a',
                    { href: '#0', onClick: this.openConditionReportModal, className: style.button },
                    copy.get('requestConditionReport')
                ),
                isShowHoldRequest && React.createElement(
                    'a',
                    { href: '#0', onClick: this.placeOnHold, className: style.button },
                    copy.get('requestToHoldItem')
                ),
                React.createElement(ViewInvoiceLink, {
                    viewer: viewer,
                    onClick: this.onViewInvoiceClick,
                    className: style.button,
                    children: copy.get('viewInvoice')
                }),
                React.createElement(
                    'a',
                    { href: '#0', onClick: this.askQuestion, className: style.button },
                    copy.get('askAQuestionCta')
                )
            );
        }
    }]);

    return PreContactDealer;
}(Component);

PreContactDealer.defaultProps = {
    modalKey: 'preContactDealer',
    onViewInvoiceClick: function onViewInvoiceClick() {},
    handleCtaClick: function handleCtaClick() {}
};

PreContactDealer.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    isShowHoldRequest: PropTypes.bool,
    viewer: PropTypes.object,
    item: PropTypes.object,
    goToStep: PropTypes.func,
    hideModal: PropTypes.func,
    onViewInvoiceClick: PropTypes.func,
    handleCtaClick: PropTypes.func
};

module.exports = PreContactDealer;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var css = __webpack_require__(142);
var tokenReplace = __webpack_require__(5);
var RightArrow = __webpack_require__(152);

var SuccessGeneric = function SuccessGeneric(_ref) {
    var copy = _ref.copy,
        successType = _ref.successType;
    return React.createElement(
        'div',
        { className: css.successContainer },
        React.createElement(
            'p',
            { className: css.message },
            tokenReplace(copy.get('successMsg'), { successType: successType })
        ),
        React.createElement(
            'p',
            { className: css.message },
            copy.get('viewRequest'),
            React.createElement(
                'a',
                { href: '/my/conversations/' },
                copy.get('myConversations'),
                React.createElement(RightArrow, { className: css.ctaArrow })
            )
        )
    );
};

SuccessGeneric.propTypes = {
    successType: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired
};

SuccessGeneric.defaultProps = {
    modalKey: 'successGeneric'
};

module.exports = SuccessGeneric;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var tracking = __webpack_require__(2);
var composeClassNames = __webpack_require__(43);
var css = composeClassNames(__webpack_require__(6), __webpack_require__(125));
// TODO: if this variant becomes canon, rename copy keys to be more descriptive

var GuidedCopy = function (_Component) {
    _inherits(GuidedCopy, _Component);

    function GuidedCopy() {
        _classCallCheck(this, GuidedCopy);

        return _possibleConstructorReturn(this, (GuidedCopy.__proto__ || Object.getPrototypeOf(GuidedCopy)).apply(this, arguments));
    }

    _createClass(GuidedCopy, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                guidedPromptSelection = _props.guidedPromptSelection,
                setGuidedPromptSelection = _props.setGuidedPromptSelection;

            if (guidedPromptSelection !== '') {
                setGuidedPromptSelection('');
            }
        }
    }, {
        key: 'onSelectOption',
        value: function onSelectOption(selectedOption, nextModalStep) {
            var _props2 = this.props,
                copy = _props2.copy,
                goToStep = _props2.goToStep,
                setGuidedPromptSelection = _props2.setGuidedPromptSelection,
                setGhostText = _props2.setGhostText;

            var isMakeOffer = selectedOption === 'makeAnOffer';
            var selectedOptionCopy = copy.get('' + selectedOption).toLowerCase();

            setGhostText(copy.get(isMakeOffer ? 'messagePlaceholder' : selectedOption + 'GhostText'));
            setGuidedPromptSelection(selectedOptionCopy);
            tracking.eventGuidedPromptSelected(selectedOptionCopy);
            goToStep({ step: nextModalStep });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                copy = _props3.copy,
                item = _props3.item;


            var guidedOptions = [];

            var addGuidedOption = function addGuidedOption(optionName, modalStepName) {
                return guidedOptions.push(React.createElement(
                    'div',
                    {
                        onClick: _this2.onSelectOption.bind(_this2, optionName, modalStepName),
                        className: css.guidedOptionWrapper,
                        key: optionName
                    },
                    React.createElement(
                        'span',
                        null,
                        copy.get('' + optionName)
                    ),
                    React.createElement(
                        'span',
                        null,
                        '>'
                    )
                ));
            };

            addGuidedOption('askAboutShipping', 'contactDealer');
            addGuidedOption('requestItemDetails', 'contactDealer');
            if (get(item, 'pricing.negotiable')) {
                addGuidedOption('makeAnOffer', 'makeOffer');
            }
            addGuidedOption('askAQuestion', 'contactDealer');

            return React.createElement(
                'div',
                { className: css.mainFormContainer },
                React.createElement(
                    'div',
                    { className: css.guidedPromptsContainer },
                    React.createElement(
                        'div',
                        { className: css.guidedCopySubtitle },
                        copy.get('guidedCopySubtitle')
                    ),
                    guidedOptions
                )
            );
        }
    }]);

    return GuidedCopy;
}(Component);

GuidedCopy.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    goToStep: PropTypes.func,
    item: PropTypes.object,
    setGhostText: PropTypes.func,
    guidedPromptSelection: PropTypes.string,
    setGuidedPromptSelection: PropTypes.func
};

GuidedCopy.defaultProps = {
    modalKey: 'contactDealerGuidedCopy'
};

module.exports = GuidedCopy;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ACTION_TYPES = __webpack_require__(3);
var defaultState = {
    authWasMakeOffer: false,
    authResultAction: null,
    didEmailCheck: false,
    guidedGhostText: '',
    messagesSent: [],
    holdRequestedFromConfirmationModal: false
};

// todo: remove authResultAction functionality once we can login through graphql

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case ACTION_TYPES.setAuthResultAction:
            return Object.assign({}, state, { authResultAction: action.actionName });
        case ACTION_TYPES.clearAuthResultAction:
            return Object.assign({}, state, { authResultAction: null });
        case ACTION_TYPES.resetContactData:
            /* reset everything except messagesSent, because the confirmation modal
            needs to know what types of messages have already been sent to display
            the right secondary message (eg, if the user has submitted a hold requestHold,
            it doesn't make sense to show the hold request prompt) */
            return _extends({}, defaultState, { messagesSent: state.messagesSent });
        case ACTION_TYPES.setGhostText:
            return Object.assign({}, state, { guidedGhostText: action.ghostText });
        case ACTION_TYPES.closeModal:
            return Object.assign({}, state, {
                guidedGhostText: defaultState.guidedGhostText
            });
        case ACTION_TYPES.setAuthWasMakeOffer:
            return Object.assign({}, state, { authWasMakeOffer: true });
        case ACTION_TYPES.messageSuccess:
            var messageType = action.messageType;

            return Object.assign({}, state, { messagesSent: [messageType].concat(_toConsumableArray(state.messagesSent)) });
        case ACTION_TYPES.holdFromConfirmationModal:
            return _extends({}, state, { holdRequestedFromConfirmationModal: true });
        default:
            return state;
    }
};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ACTION_TYPES = __webpack_require__(3);
var currencyUtil = __webpack_require__(44);
var defaultState = {
    emailFieldValue: '',
    messageFieldValue: '',
    nameFieldValue: '',
    offerFieldValue: '',
    quantityFieldValue: '1',
    optInFieldValue: false,
    holdRequestFieldValue: false,
    isMessageFieldOpen: false
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case ACTION_TYPES.updateContactFields:
            var updatedValue = action.value;
            if (action.field === 'offer') {
                // to prevent rounding errors only allow offers < 1 quadrillion (sorry Mr. Monopoly)
                if (updatedValue.length > 15) {
                    return state;
                }
                var parsedValue = currencyUtil.parseFloat(updatedValue);
                updatedValue = parsedValue ? parsedValue + '' : '';
            }
            return Object.assign({}, state, _defineProperty({}, action.field + 'FieldValue', updatedValue));
        case ACTION_TYPES.resetContactField:
            var stateKey = action.fieldKey + 'FieldValue';
            return Object.assign({}, state, _defineProperty({}, stateKey, defaultState[stateKey]));
        case ACTION_TYPES.toggleMessage:
            return Object.assign({}, state, { isMessageFieldOpen: !state.isMessageFieldOpen });
        case ACTION_TYPES.openModal:
            return Object.assign({}, state, { isMessageFieldOpen: !!state.messageFieldValue });
        case ACTION_TYPES.resetContactData:
            return defaultState;
        default:
            return state;
    }
};

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var ACTION_TYPES = __webpack_require__(3);
var currencyUtil = __webpack_require__(44);
var intelligentFormat = __webpack_require__(31);
var tokenReplace = __webpack_require__(5);
var findKey = __webpack_require__(157);
var fivePercent = 0.05;
var tenPercent = 0.1;

var defaultState = {
    isPreAuthOfferLowball: false,
    selectedLowBallOption: '',
    fivePercent: {
        labelSubtext: undefined,
        percentOff: fivePercent * 100,
        checked: false,
        value: undefined,
        label: undefined
    },
    tenPercent: {
        labelSubtext: undefined,
        percentOff: tenPercent * 100,
        checked: false,
        value: undefined,
        label: undefined
    },
    originalOffer: {
        labelSubtext: undefined,
        percentOff: undefined,
        checked: false,
        value: undefined,
        label: undefined,
        isOriginalOffer: true
    },
    other: {
        labelSubtext: undefined,
        percentOff: undefined,
        checked: false,
        value: 'other',
        label: undefined,
        isOther: true
    }
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    var newState = {};
    var newLowBallSelectionKey = void 0;
    var prevLowBallOption = void 0;
    switch (action.type) {
        case ACTION_TYPES.initLowballOptions:
            var offerAmount = action.offerAmount,
                priceValue = action.priceValue,
                currency = action.currency,
                isPricePerPiece = action.isPricePerPiece,
                copy = action.copy;


            var priceFivePercentOff = currencyUtil.round(priceValue * (1 - fivePercent), 0);
            var priceTenPercentOff = currencyUtil.round(priceValue * (1 - tenPercent), 0);
            var perItem = isPricePerPiece ? copy.get(' per item') : '';

            // Value is what gets set on the offer model and label is visually displayed
            newState.fivePercent = Object.assign({}, state.fivePercent, {
                value: '' + priceFivePercentOff,
                label: intelligentFormat(priceFivePercentOff, currency) + perItem,
                labelSubtext: tokenReplace(copy.get('lowBallOptionAmountOff'), {
                    amountOff: intelligentFormat(priceValue - priceFivePercentOff, currency),
                    percentOff: state.fivePercent.percentOff
                })
            });
            newState.tenPercent = Object.assign({}, state.tenPercent, {
                value: '' + priceTenPercentOff,
                label: intelligentFormat(priceTenPercentOff, currency) + perItem,
                labelSubtext: tokenReplace(copy.get('lowBallOptionAmountOff'), {
                    amountOff: intelligentFormat(priceValue - priceTenPercentOff, currency),
                    percentOff: state.tenPercent.percentOff
                })
            });

            if (offerAmount) {
                var _offerValue = currencyUtil.parseFloat(offerAmount);
                var _amountOffValue = priceValue - _offerValue;
                var percentOff = _amountOffValue / priceValue * 100;
                newState.originalOffer = Object.assign({}, state.originalOffer, {
                    value: offerAmount,
                    label: intelligentFormat(_offerValue, currency) + perItem + ' ' + copy.get('lowBallOriginalOffer'),
                    percentOff: percentOff,
                    labelSubtext: tokenReplace(copy.get('lowBallOptionAmountOff'), {
                        amountOff: intelligentFormat(_amountOffValue, currency),
                        percentOff: currencyUtil.format(percentOff, 0)
                    })
                });
            }
            if (!state.other.label) {
                newState.other = Object.assign({}, state.other, {
                    label: copy.get('lowBallOtherOptionLabel')
                });
            }

            // reset selected lowball option
            prevLowBallOption = state[state.selectedLowBallOption];
            if (prevLowBallOption) {
                var updatedOptionProps = { checked: false };
                if (prevLowBallOption.isOther) {
                    updatedOptionProps.labelSubtext = undefined;
                }
                newState[state.selectedLowBallOption] = Object.assign({}, prevLowBallOption, updatedOptionProps);
            }
            newState.selectedLowBallOption = '';

            return Object.assign({}, state, newState);
        case ACTION_TYPES.setLowballOption:
            newLowBallSelectionKey = findKey(state, function (opt) {
                return opt.value === action.value;
            });

            if (state[newLowBallSelectionKey].checked) {
                return state;
            }

            newState[newLowBallSelectionKey] = Object.assign({}, state[newLowBallSelectionKey], { checked: true });
            newState.selectedLowBallOption = newLowBallSelectionKey;

            prevLowBallOption = state[state.selectedLowBallOption];
            if (prevLowBallOption) {
                var _updatedOptionProps = { checked: false };
                if (prevLowBallOption.isOther) {
                    _updatedOptionProps.labelSubtext = undefined;
                }
                newState[state.selectedLowBallOption] = Object.assign({}, prevLowBallOption, _updatedOptionProps);
            }
            return Object.assign({}, state, newState);
        case ACTION_TYPES.setLowballOfferDiscount:
            var updatedOther = {};
            var offerValue = currencyUtil.parseFloat(action.value);
            var amountOffValue = action.priceValue - offerValue;
            if (amountOffValue <= 0 || amountOffValue >= action.priceValue) {
                updatedOther.percentOff = null;
                updatedOther.labelSubtext = null;
            } else {
                var _percentOff = amountOffValue / action.priceValue * 100;
                updatedOther.percentOff = _percentOff;
                updatedOther.labelSubtext = tokenReplace(action.copy.get('lowBallOptionAmountOff'), {
                    amountOff: intelligentFormat(amountOffValue, action.currency),
                    percentOff: currencyUtil.format(_percentOff, 0)
                });
            }
            updatedOther = Object.assign({}, state.other, updatedOther);
            return Object.assign({}, state, { other: updatedOther });
        case ACTION_TYPES.setPreAuthOfferLowball:
            return Object.assign({}, state, { isPreAuthOfferLowball: action.flag });
        case ACTION_TYPES.closeModal:
            return Object.assign({}, state, { isPreAuthOfferLowball: false });
        default:
            return state;
    }
};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ACTION_TYPES = __webpack_require__(3);
var defaultState = {
    activeModal: '',
    isOpened: false,
    isError: false,
    isSending: false,
    submitDisabled: false,
    currentStep: '',
    backLinkTargets: {},
    modalContentData: null
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case ACTION_TYPES.setServiceError:
            return Object.assign({}, state, {
                isError: true,
                submitDisabled: false,
                isSending: false,
                isOpened: true
            });
        case ACTION_TYPES.openModal:
            return Object.assign({}, state, { isOpened: true, activeModal: action.activeModal });

        case ACTION_TYPES.closeModal:
            return defaultState;

        case ACTION_TYPES.hideActiveModal:
            return Object.assign({}, state, { isOpened: false });

        case ACTION_TYPES.showActiveModal:
            return Object.assign({}, state, {
                isOpened: true
            });

        case ACTION_TYPES.gotoModalStep:
            var updatedBackLinkTargets = Object.assign({}, state.backLinkTargets, action.isBackLink ? {} : _defineProperty({}, action.currentStep, state.currentStep));
            return Object.assign({}, state, {
                currentStep: action.currentStep,
                backLinkTargets: updatedBackLinkTargets,
                modalContentData: action.modalContentData
            });

        case ACTION_TYPES.initLowballOptions:
            return Object.assign({}, state, { submitDisabled: true, isError: false });

        case ACTION_TYPES.setLowballOption:
            return Object.assign({}, state, { submitDisabled: action.value === 'other' });
        case ACTION_TYPES.setLowballOfferDiscount:
            return Object.assign({}, state, { submitDisabled: action.value === '' });

        case ACTION_TYPES.modalIsSending:
            return Object.assign({}, state, { isSending: true, isError: false });
        case ACTION_TYPES.messageSuccess:
            return Object.assign({}, state, { isSending: false });
        default:
            return state;
    }
};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _require = __webpack_require__(69),
    constants = _require.constants,
    intelligentFormat = _require.intelligentFormat;

var verticals = __webpack_require__(72);
var get = __webpack_require__(1);
var PRICE_TYPES = __webpack_require__(30);
var ACTION_TYPES = __webpack_require__(3);

var defaultState = {
    currencySymbol: '',
    formattedNetPrice: '',
    formattedRetailPrice: '',
    formattedSalePrice: '',
    isPricePerPiece: false,
    pieces: 1,
    priceType: '',
    priceValue: ''
};

var _getPriceInCurrency = function _getPriceInCurrency(prices, type, currency) {
    var price = prices.find(function (p) {
        return p.status === PRICE_TYPES.STATUS_ACTIVE && p.type === type;
    });
    if (price && price.amount && price.amount.convertedAmountList) {
        return price.amount.convertedAmountList.find(function (o) {
            return o.currency === currency;
        });
    }
    return null;
};

var _getPriceValues = function _getPriceValues(options) {
    var showNetPrice = options.showNetPrice,
        prices = options.prices,
        currency = options.currency;

    var pricesInCurrency = [PRICE_TYPES.TYPE_RETAIL, PRICE_TYPES.TYPE_NET, PRICE_TYPES.TYPE_SALE].map(function (type) {
        return _getPriceInCurrency(prices, type, currency);
    });
    return {
        retailPrice: pricesInCurrency[0],
        netPrice: showNetPrice ? pricesInCurrency[1] : null,
        salePrice: pricesInCurrency[2]
    };
};

var _getFormattedPrices = function _getFormattedPrices(pricesObj) {
    return {
        formattedRetailPrice: pricesObj.retailPrice ? intelligentFormat(pricesObj.retailPrice.amount, pricesObj.retailPrice.currency, { showDecimal: true }) : '',
        formattedNetPrice: pricesObj.netPrice ? intelligentFormat(pricesObj.netPrice.amount, pricesObj.netPrice.currency, { showDecimal: true }) : '',
        formattedSalePrice: pricesObj.salePrice ? intelligentFormat(pricesObj.salePrice.amount, pricesObj.salePrice.currency, { showDecimal: true }) : ''
    };
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (action.type === ACTION_TYPES.contactDataLoaded && action.item) {
        var item = action.item,
            user = action.user,
            pageCurrency = action.pageCurrency;

        var userIsLoggedIn = !!user;
        var userCurrency = pageCurrency || get(user, 'profile.currency') || constants.currencies.CURRENCY_USD;

        var showNetPrice = false;
        if (userIsLoggedIn) {
            showNetPrice = item.vertical === verticals.VERTICAL_FURNITURE && user.canUseNetPrice;
        }
        var prices = _getPriceValues({
            showNetPrice: showNetPrice,
            prices: get(item, 'pricing.prices'),
            currency: userCurrency
        });

        var formattedPrices = _getFormattedPrices(prices);

        var priceType = void 0;
        var priceValue = void 0;

        if (!item.isPriceUponRequest) {
            if (formattedPrices.formattedSalePrice) {
                priceType = PRICE_TYPES.TYPE_SALE;
                priceValue = prices.salePrice.amount;
            } else if (formattedPrices.formattedNetPrice) {
                priceType = PRICE_TYPES.TYPE_NET;
                priceValue = prices.netPrice.amount;
            } else {
                priceType = PRICE_TYPES.TYPE_RETAIL;
                priceValue = prices.retailPrice.amount;
            }
        }

        return Object.assign({}, state, {
            priceType: priceType,
            priceValue: priceValue,
            isPricePerPiece: item.pricing.pricePerPiece,
            pieces: item.pieces,
            currency: userCurrency,
            currencySymbol: constants.symbols[userCurrency]
        }, formattedPrices);
    };
    return state;
};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var get = __webpack_require__(1);
var pick = __webpack_require__(32);
var qs = __webpack_require__(33);
var ACTION_TYPES = __webpack_require__(3);
var defaultState = {
    guidedPromptSelection: '',
    isItem: false,
    item: {},
    linkLocation: '',
    purchaseStatus: '',
    vpvParams: {},
    vpvParamsQuery: ''
};
var yesNo = function yesNo(predicate) {
    return predicate ? 'y' : 'n';
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (action.type === ACTION_TYPES.contactDataLoaded) {
        // constructVpvParams
        var seller = action.seller,
            item = action.item,
            linkLocation = action.linkLocation;

        var isPdp = linkLocation === 'pdp';
        var newState = { linkLocation: linkLocation };

        newState.vpvParams = {
            dd: get(seller, 'serviceId'),
            dn: get(seller, 'sellerProfile.company')
        };

        newState.purchaseStatus = '';

        if (item) {
            newState.item = item;
            newState.isItem = true;

            var status = 'Available-Price';
            if (get(seller, 'isSuspended') || get(item, 'isDeleted')) {
                status = 'Suspended';
            } else if (get(item, 'isOnHold')) {
                status = 'Hold';
            } else if (get(item, 'isSold')) {
                status = 'Sold';
            } else if (get(item, 'pricing.hidePrice')) {
                status = 'Available-No Price';
            }
            Object.assign(newState.vpvParams, {
                id: get(item, 'serviceId'),
                status: 'PDP-' + status,
                pur: yesNo(get(item, 'canMakePurchase')),
                neg: yesNo(get(item, isPdp ? 'canBuyerMakeOffer' : 'pricing.negotiable')),
                ship: yesNo(!get(item, 'hasPreQuotedShipping')),
                ret: yesNo(get(item, 'returnPolicy.accept'))
            });
            newState.purchaseStatus = qs.stringify(pick(newState.vpvParams, 'neg', 'ship', 'ret'), {
                delimiter: '|'
            });
        }

        newState.vpvParamsQuery = decodeURIComponent(qs.stringify(newState.vpvParams).toLowerCase());
        return Object.assign({}, state, newState);
    } else if (action.type === ACTION_TYPES.setGuidedPromptSelection) {
        return Object.assign({}, state, { guidedPromptSelection: action.prompt });
    }
    return state;
};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var ACTION_TYPES = __webpack_require__(3);
var defaultState = {
    messageErrors: {},
    offerErrors: {}
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    var newState = {};
    switch (action.type) {
        case ACTION_TYPES.failedValidation:
            return Object.assign({}, state, {
                messageErrors: action.messageErrors,
                offerErrors: action.offerErrors
            });
        case ACTION_TYPES.updateContactFields:
            if (action.field === 'holdRequest' && !action.value) {
                newState.messageErrors = {};
            }
            return Object.assign({}, state, newState);
        case ACTION_TYPES.closeModal:
        case ACTION_TYPES.clearValidationErrors:
            return defaultState;
        default:
            return state;
    }
};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes,
    Children = React.Children;

var tokenReplace = __webpack_require__(5);
var ModalWrapper = __webpack_require__(17);
var contactModalTracking = __webpack_require__(2);
var get = __webpack_require__(1);
var once = __webpack_require__(45);
var defaultCopy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(28), __webpack_require__(147), __webpack_require__(26), __webpack_require__(7), __webpack_require__(27), __webpack_require__(42), __webpack_require__(143), __webpack_require__(144)));

var ContactDealerModal = function (_React$Component) {
    _inherits(ContactDealerModal, _React$Component);

    function ContactDealerModal() {
        _classCallCheck(this, ContactDealerModal);

        return _possibleConstructorReturn(this, (ContactDealerModal.__proto__ || Object.getPrototypeOf(ContactDealerModal)).apply(this, arguments));
    }

    _createClass(ContactDealerModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                authResultAction = _props.authResultAction,
                authWasMakeOffer = _props.authWasMakeOffer,
                contactDataLoaded = _props.contactDataLoaded,
                goToStep = _props.goToStep,
                item = _props.item,
                linkLocation = _props.linkLocation,
                openModal = _props.openModal,
                openOnRender = _props.openOnRender,
                optimizelyVariant = _props.optimizelyVariant,
                pageCurrency = _props.pageCurrency,
                seller = _props.seller,
                user = _props.user,
                userHasEverLoggedIn = _props.userHasEverLoggedIn,
                isPriceUponRequest = _props.isPriceUponRequest,
                updateContactModalFields = _props.updateContactModalFields,
                messageValue = _props.messageValue,
                copy = _props.copy;

            if (isPriceUponRequest && messageValue.length === 0) {
                updateContactModalFields({ field: 'message', value: copy.get('pretextPur') });
            }

            this.chatCloseModalOnce = once(this.chatCloseModal.bind(this));

            contactDataLoaded({ seller: seller, item: item, user: user, pageCurrency: pageCurrency, linkLocation: linkLocation });

            var displayGuidedStep = !!item && !get(item, 'pricing.hidePrice') && optimizelyVariant === 'contactDealerGuidedCopy' && !userHasEverLoggedIn && !authResultAction;

            if (item && !userHasEverLoggedIn && optimizelyVariant && !authResultAction) {
                contactModalTracking.eventVariantDisplayed(optimizelyVariant);

                // for A/B guided flow test MCPERSON-2909 & MCPERSON-2910
                // because the relay renderer and userHasEverLoggedIn are reset immediately
                // after authentication, we need to store the user's initial userHasEverLoggedIn value
                // in order to know whether to include the test variant in the
                // tracking.eventSubmitted call after successful message submission

                if (typeof Storage !== "undefined") {
                    sessionStorage.setItem('trackVariantAfterSubmission', true);
                }
            }

            var currentStep = this.props.currentStep;
            if (authResultAction && authWasMakeOffer) {
                currentStep = 'makeOffer';
            }

            goToStep({ step: displayGuidedStep ? optimizelyVariant : currentStep || 'contactDealer' });

            if (openOnRender) {
                openModal('contactDealer');
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.isOpened && nextProps.isOpened) {

                if (!this.props.authResultAction) {
                    contactModalTracking.eventLaunch(nextProps.trackingParams);
                }
            } else if (this.props.isOpened && !nextProps.isOpened) {
                contactModalTracking.resetPage();
            }
        }
    }, {
        key: 'chatCloseModal',
        value: function chatCloseModal() {
            var _props2 = this.props,
                closeModal = _props2.closeModal,
                chatAbandonTag = _props2.chatAbandonTag,
                chatTracking = _props2.chatTracking;

            var trackChatEvent = chatTracking ? chatTracking[chatAbandonTag] : false;
            if (trackChatEvent) {
                trackChatEvent();
            }
            closeModal();
        }
    }, {
        key: 'goToPrevStep',
        value: function goToPrevStep() {
            var _props3 = this.props,
                resetContactModalField = _props3.resetContactModalField,
                goToStep = _props3.goToStep,
                prevStep = _props3.prevStep,
                currentStep = _props3.currentStep;

            if (currentStep === 'makeOffer') {
                resetContactModalField('offer');
            }
            return goToStep({ step: prevStep, isBackLink: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                children = _props4.children,
                copy = _props4.copy,
                currentStep = _props4.currentStep,
                guidedGhostText = _props4.guidedGhostText,
                isError = _props4.isError,
                isOpened = _props4.isOpened,
                item = _props4.item,
                seller = _props4.seller,
                state = _props4.state,
                optimizelyVariant = _props4.optimizelyVariant,
                userHasEverLoggedIn = _props4.userHasEverLoggedIn,
                modalContentData = _props4.modalContentData;

            // if one child is passed, props.children is a single component instance instead of an Array

            var CurrentModalStep = Children.toArray(children).filter(function (c) {
                return c.props.modalKey === (currentStep ? currentStep : 'contactDealer');
            })[0];
            var modalProps = Object.assign({}, this.props, {
                closeModal: this.chatCloseModalOnce,
                state: state
            });
            var copySuffix = get(modalContentData, 'copySuffix');
            var headerSuffix = copySuffix ? '-' + copySuffix : '';
            var headerText = tokenReplace(copy.get(currentStep + 'Header' + headerSuffix), {
                dealer: get(seller, 'sellerProfile.company')
            });
            var showHeaderBackLink = !!item && !userHasEverLoggedIn && currentStep !== 'contactDealerGuidedCopy' && (currentStep === 'makeOffer' || optimizelyVariant === 'contactDealerGuidedCopy');
            return React.createElement(
                ModalWrapper,
                {
                    modalType: 'contactDealer',
                    currentStep: currentStep,
                    isOpened: isOpened,
                    isError: isError,
                    header: headerText,
                    closeModal: modalProps.closeModal,
                    goToPrevStep: this.goToPrevStep.bind(this),
                    showHeaderBackLink: showHeaderBackLink,
                    guidedGhostText: guidedGhostText
                },
                React.cloneElement(CurrentModalStep, _extends({}, modalProps))
            );
        }
    }]);

    return ContactDealerModal;
}(React.Component);

;

ContactDealerModal.propTypes = {
    children: PropTypes.node.isRequired,
    closeModal: PropTypes.func.isRequired,
    contactDataLoaded: PropTypes.func,
    copy: PropTypes.object,
    currentStep: PropTypes.string,
    userHasEverLoggedIn: PropTypes.bool,
    emailValue: PropTypes.string,
    goToStep: PropTypes.func.isRequired,
    guidedGhostText: PropTypes.string,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    isOpened: PropTypes.bool.isRequired,
    item: PropTypes.object,
    linkLocation: PropTypes.string,
    messageValue: PropTypes.string,
    modalContentData: PropTypes.object,
    nameValue: PropTypes.string,
    offerValue: PropTypes.string,
    openModal: PropTypes.func.isRequired,
    openOnRender: PropTypes.bool,
    prevStep: PropTypes.string,
    relay: PropTypes.object,
    resetContactModalField: PropTypes.func,
    seller: PropTypes.object,
    state: PropTypes.shape({
        priceType: PropTypes.string,
        priceValue: PropTypes.number,
        isPricePerPiece: PropTypes.bool,
        pieces: PropTypes.number,
        currency: PropTypes.string,
        currencySymbol: PropTypes.string,
        formattedPrices: PropTypes.shape({
            formattedSalePrice: PropTypes.string,
            formattedNetPrice: PropTypes.string,
            formattedRetailPrice: PropTypes.string
        })
    }),
    trackingParams: PropTypes.shape({
        isItem: PropTypes.bool,
        item: PropTypes.object,
        linkLocation: PropTypes.string,
        purchaseStatus: PropTypes.string,
        vpvParams: PropTypes.object,
        vpvParamsQuery: PropTypes.string
    }),
    updateContactModalFields: PropTypes.func,
    user: PropTypes.object,
    chatAbandonTag: PropTypes.string,
    chatSuccessTag: PropTypes.string,
    chatTracking: PropTypes.object,
    authResultAction: PropTypes.string,
    optimizelyVariant: PropTypes.string,
    pageCurrency: PropTypes.string,
    isPriceUponRequest: PropTypes.bool,
    setPreAuthOfferLowball: PropTypes.func,
    holdRequestedFromConfirmationModal: PropTypes.bool.isRequired,
    authWasMakeOffer: PropTypes.bool
};

ContactDealerModal.defaultProps = {
    currentStep: 'contactDealer',
    chatAbandonTag: 'abandonContactDealer',
    chatSuccessTag: 'contactDealer',
    copy: defaultCopy,
    openOnRender: true
};

module.exports = ContactDealerModal;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);
var validationActions = __webpack_require__(10);
var fieldsActions = __webpack_require__(13);
var contactDealerActions = __webpack_require__(46);
var makeOfferActions = __webpack_require__(14);
var mutationActions = __webpack_require__(11);

var _require = __webpack_require__(21),
    connect = _require.connect;

var mapStateToProps = function mapStateToProps(_ref) {
    var contactDealer = _ref.contactDealer,
        fields = _ref.fields,
        lowBall = _ref.lowBall,
        modalWrapper = _ref.modalWrapper,
        price = _ref.price,
        tracking = _ref.tracking,
        validation = _ref.validation;

    return {
        currentStep: modalWrapper.currentStep,
        prevStep: modalWrapper.backLinkTargets[modalWrapper.currentStep],
        guidedGhostText: contactDealer.guidedGhostText,
        guidedPromptSelection: tracking.guidedPromptSelection,
        isError: modalWrapper.isError,
        isOpened: modalWrapper.isOpened,
        isShowOptIn: contactDealer.isShowOptIn,
        isSending: modalWrapper.isSending,
        submitDisabled: modalWrapper.submitDisabled,
        modalContentData: modalWrapper.modalContentData,
        nameValue: fields.nameFieldValue,
        emailValue: fields.emailFieldValue,
        messagesSent: contactDealer.messagesSent,
        holdRequestedFromConfirmationModal: contactDealer.holdRequestedFromConfirmationModal,
        messageValue: fields.messageFieldValue,
        offerValue: fields.offerFieldValue,
        quantityValue: fields.quantityFieldValue,
        isOptInChecked: fields.optInFieldValue,
        isHoldRequestChecked: fields.holdRequestFieldValue,
        isMessageFieldOpen: fields.isMessageFieldOpen,
        authResultAction: contactDealer.authResultAction,
        authWasMakeOffer: contactDealer.authWasMakeOffer,
        messageErrors: validation.messageErrors,
        errors: Object.assign({}, validation.messageErrors, validation.offerErrors),
        lowBallOptions: lowBall,
        isPreAuthOfferLowball: lowBall.isPreAuthOfferLowball,
        trackingParams: tracking,

        currency: price.currency,
        currencySymbol: price.currencySymbol,
        formattedNetPrice: price.formattedNetPrice,
        formattedRetailPrice: price.formattedRetailPrice,
        formattedSalePrice: price.formattedSalePrice,
        isPricePerPiece: price.isPricePerPiece,
        pieces: price.pieces,
        priceType: price.priceType,
        priceValue: price.priceValue
    };
};

function getHoldRequestVisible(modalContentData) {
    return !modalContentData.hasOwnProperty('isShowHoldRequest') || modalContentData.isShowHoldRequest;
}

module.exports = connect(mapStateToProps, Object.assign({}, contactDealerActions, fieldsActions, makeOfferActions, modalWrapperActions, validationActions, mutationActions), function (stateProps, dispatchProps, ownProps) {
    var isHoldRequestVisible = getHoldRequestVisible(Object.assign({}, ownProps.modalContentData, stateProps.modalContentData));
    return Object.assign({}, ownProps, stateProps, dispatchProps, {
        currentStep: stateProps.currentStep || ownProps.currentStep,
        isShowHoldRequest: isHoldRequestVisible && ownProps.isShowHoldRequest,
        modalContentData: stateProps.modalContentData || ownProps.modalContentData
    });
});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Relay = __webpack_require__(4);
var createRelayContainer = __webpack_require__(24);

var _require = __webpack_require__(9),
    compose = _require.compose,
    hoistStatics = _require.hoistStatics,
    flattenProp = _require.flattenProp,
    withProps = _require.withProps;

var BuyerProfileMutation = __webpack_require__(60);
var ContactDealerMutation = __webpack_require__(38);
var HoldRequestMutation = __webpack_require__(39);
var FavoriteDealerMutation = __webpack_require__(25);
var FavoriteItemMutation = __webpack_require__(61);
var TradeStatusMutation = __webpack_require__(62);
var get = __webpack_require__(1);

var _require2 = __webpack_require__(59),
    shouldModalShowHoldRequestInput = _require2.shouldModalShowHoldRequestInput;

var query = {
    initialVariables: {
        sellerId: null,
        itemId: null,
        userId: null,
        emailValue: null,
        shouldFetchItem: false,
        shouldFetchImage: false,
        shouldFetchUser: false,
        shouldFetchUserAndItem: false,
        shouldFetchBuyerItemConv: false,
        shouldCheckEmailExists: false
    },
    prepareVariables: function prepareVariables(prevVariables) {
        var shouldFetchItem = prevVariables.shouldFetchItem,
            shouldFetchUser = prevVariables.shouldFetchUser;

        return Object.assign({}, prevVariables, {
            shouldFetchUserAndItem: shouldFetchItem && shouldFetchUser
        });
    },
    fragments: {
        viewer: function viewer() {
            return function (RQL_0, RQL_1, RQL_2, RQL_3, RQL_4, RQL_5, RQL_6, RQL_7, RQL_8, RQL_9, RQL_10) {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'sellerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'sellerId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'company',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerProfile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerProfile'
                        }, {
                            children: [{
                                fieldName: 'urlLabel',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerPreferences',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerPreferences'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userIds',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, Relay.QL.__frag(RQL_0)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'shouldFetchUser'
                                    }
                                }]
                            }],
                            fieldName: 'favoritesByUser',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'Favorite'
                        }, {
                            fieldName: 'isPolicyOpop',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isSuspended',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            alias: 'isOnPreAuthOfferWhitelist',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'listName',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'ALLOW_PREAUTH_OFFERS'
                                }
                            }],
                            fieldName: 'isWhitelisted',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2), Relay.QL.__frag(RQL_3)]),
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'first',
                            value: {
                                kind: 'CallValue',
                                callValue: 1
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'sort',
                            value: {
                                kind: 'CallValue',
                                callValue: 'createdDate desc'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [{
                                    fieldName: 'isCanceled',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'hasCompletedCheckout',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    children: [{
                                        fieldName: 'serviceId',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'ID'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'mostRecentOffer',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id'
                                    },
                                    type: 'Offer'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'Transaction'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'TransactionEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchUserAndItem'
                                }
                            }]
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        alias: 'preInvoiceTransactions',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'viewName',
                            value: {
                                kind: 'CallValue',
                                callValue: 'buyer.buyerPreInvoiceFilter'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'totalResults',
                            kind: 'Field',
                            metadata: {},
                            type: 'Int'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchUserAndItem'
                                }
                            }]
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isRequisite: true
                            },
                            type: 'ID'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'value',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'customizable',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'AttributeValue'
                            }],
                            fieldName: 'attributes',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemAttributes'
                        }, {
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'title',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'vertical',
                            kind: 'Field',
                            metadata: {},
                            type: 'VerticalType'
                        }, {
                            fieldName: 'dibsReference',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'pieces',
                            kind: 'Field',
                            metadata: {},
                            type: 'Int'
                        }, {
                            children: [{
                                fieldName: 'hidePrice',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                fieldName: 'negotiable',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                fieldName: 'pricePerPiece',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                children: [{
                                    children: [{
                                        children: [{
                                            fieldName: 'amount',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Float'
                                        }, {
                                            fieldName: 'currency',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Currency'
                                        }],
                                        fieldName: 'convertedAmountList',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            isPlural: true
                                        },
                                        type: 'ConvertedAmountList'
                                    }],
                                    fieldName: 'amount',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'FinancialAmount'
                                }, {
                                    fieldName: 'status',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    fieldName: 'type',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'PriceType'
                                }],
                                fieldName: 'prices',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'Price'
                            }],
                            fieldName: 'pricing',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemPricing'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {
                                    type: 'ImageVersionTypeName!'
                                },
                                name: 'size',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'small'
                                }
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'shouldFetchImage'
                                    }
                                }]
                            }],
                            fieldName: 'firstPhotoWebPath',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            children: [{
                                children: [{
                                    children: [{
                                        fieldName: 'browseUrl',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'category',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'Category'
                                }],
                                fieldName: 'categories',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'ItemCategory'
                            }],
                            fieldName: 'classification',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemClassification'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            fieldName: 'canBuyerMakeOffer',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'canMakePurchase',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isPriceUponRequest',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isDeleted',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isOnHold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isSold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'hasPreQuotedShipping',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'shouldFetchUser'
                                    }
                                }]
                            }],
                            fieldName: 'hasRequestedHoldForBuyer',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                fieldName: 'accept',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'returnPolicy',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'ReturnPolicy'
                        }, {
                            children: [{
                                fieldName: 'serviceId',
                                kind: 'Field',
                                metadata: {},
                                type: 'ID'
                            }, {
                                children: [{
                                    fieldName: 'company',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'sellerProfile',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'SellerProfile'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'seller',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'Seller'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'shouldFetchUser'
                                    }
                                }]
                            }],
                            fieldName: 'isFavorite',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, Relay.QL.__frag(RQL_4), Relay.QL.__frag(RQL_5), Relay.QL.__frag(RQL_6)]),
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchItem'
                                }
                            }]
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'userId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }, {
                                calls: [{
                                    kind: 'Call',
                                    metadata: {},
                                    name: 'preventEmailFallback',
                                    value: {
                                        kind: 'CallValue',
                                        callValue: false
                                    }
                                }],
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'firstName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'lastName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'email',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            alias: 'canSeeInvoice',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_INVOICE'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            alias: 'canUseNetPrice',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_NET_PRICE'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'verifiedTradeStatus',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'isVerifiedTrade',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_7), Relay.QL.__frag(RQL_8), Relay.QL.__frag(RQL_9), Relay.QL.__frag(RQL_10)]),
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchUser'
                                }
                            }]
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchBuyerItemConv'
                                }
                            }]
                        }],
                        fieldName: 'buyerItemConversation',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Conversation'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(FavoriteDealerMutation.getFragment('favorite'), ContactDealerMutation.getFragment('seller'), HoldRequestMutation.getFragment('seller'), FavoriteDealerMutation.getFragment('seller'), ContactDealerMutation.getFragment('item'), HoldRequestMutation.getFragment('item'), FavoriteItemMutation.getFragment('item'), BuyerProfileMutation.getFragment('user'), ContactDealerMutation.getFragment('user'), HoldRequestMutation.getFragment('user'), TradeStatusMutation.getFragment('user'));
        }
    }
};

module.exports = function (Component) {
    return hoistStatics(compose(createRelayContainer(query), flattenProp('viewer'), withProps(function (_ref) {
        var user = _ref.user,
            item = _ref.item,
            seller = _ref.seller,
            buyerItemConversation = _ref.buyerItemConversation,
            transactions = _ref.transactions;

        var isShowOptIn = !get(seller, 'isAnchorListMember') || !!user || !!item || !buyerItemConversation;

        return {
            isUserInitiallyLoggedIn: !!user,
            isUserNameSet: !!get(user, 'profile.firstName'),
            isShowOptIn: isShowOptIn,
            isShowHoldRequest: shouldModalShowHoldRequestInput(item, user),
            isPriceUponRequest: get(item, 'isPriceUponRequest'),
            transaction: get(transactions, 'edges[0].node')
        };
    })))(Component);
};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var tokenReplace = __webpack_require__(5);
var get = __webpack_require__(1);
var once = __webpack_require__(45);
var ModalWrapper = __webpack_require__(17);
var defaultCopy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(28), __webpack_require__(26), __webpack_require__(27), __webpack_require__(7), __webpack_require__(65), __webpack_require__(42)));

var MakeOfferModal = function (_React$Component) {
    _inherits(MakeOfferModal, _React$Component);

    function MakeOfferModal() {
        _classCallCheck(this, MakeOfferModal);

        return _possibleConstructorReturn(this, (MakeOfferModal.__proto__ || Object.getPrototypeOf(MakeOfferModal)).apply(this, arguments));
    }

    _createClass(MakeOfferModal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                contactDataLoaded = _props.contactDataLoaded,
                goToStep = _props.goToStep,
                item = _props.item,
                linkLocation = _props.linkLocation,
                openOnRender = _props.openOnRender,
                openModal = _props.openModal,
                pageCurrency = _props.pageCurrency,
                seller = _props.seller,
                user = _props.user,
                currentStep = _props.currentStep;


            this.chatCloseModalOnce = once(this.chatCloseModal.bind(this));

            contactDataLoaded({ seller: seller, item: item, user: user, pageCurrency: pageCurrency, linkLocation: linkLocation });
            goToStep({ step: currentStep || 'makeOffer' });

            if (openOnRender) {
                openModal(currentStep || 'makeOffer');
            }
        }
    }, {
        key: 'chatCloseModal',
        value: function chatCloseModal() {
            var _props2 = this.props,
                closeModal = _props2.closeModal,
                chatAbandonTag = _props2.chatAbandonTag,
                chatTracking = _props2.chatTracking;

            var trackChatEvent = chatTracking ? chatTracking[chatAbandonTag] : false;
            if (trackChatEvent) {
                trackChatEvent();
            }
            closeModal();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                children = _props3.children,
                copy = _props3.copy,
                currentStep = _props3.currentStep,
                isLoading = _props3.isLoading,
                isMC = _props3.isMC,
                isOpened = _props3.isOpened,
                seller = _props3.seller;

            // if one child is passed, props.children is a single component instance instead of an Array

            var CurrentModalStep = React.Children.toArray(children).filter(function (c) {
                return c.props.modalKey === (currentStep || 'makeOffer');
            })[0];

            var modalProps = Object.assign({}, this.props, {
                closeModal: isMC ? this.props.closeModal : this.chatCloseModalOnce
            });

            var headerText = tokenReplace(copy.get((currentStep || 'makeOffer') + 'Header'), {
                dealer: get(seller, 'sellerProfile.company')
            });

            return React.createElement(
                ModalWrapper,
                {
                    modalType: 'makeOffer',
                    currentStep: currentStep,
                    isOpened: isOpened,
                    closeModal: modalProps.closeModal,
                    header: headerText
                },
                !isLoading && React.cloneElement(CurrentModalStep, _extends({}, modalProps))
            );
        }
    }]);

    return MakeOfferModal;
}(React.Component);

;

MakeOfferModal.propTypes = {
    children: PropTypes.node.isRequired,
    closeModal: PropTypes.func.isRequired,
    contactDataLoaded: PropTypes.func,
    copy: PropTypes.object,
    currency: PropTypes.string,
    currentStep: PropTypes.string,
    emailValue: PropTypes.string,
    goToStep: PropTypes.func,
    prevStep: PropTypes.string,
    isLoading: PropTypes.bool,
    isOpened: PropTypes.bool.isRequired,
    item: PropTypes.object,
    linkLocation: PropTypes.string,
    messageValue: PropTypes.string,
    offerValue: PropTypes.string,
    openModal: PropTypes.func.isRequired,
    openOnRender: PropTypes.bool,
    relay: PropTypes.object,
    seller: PropTypes.object,
    user: PropTypes.object,
    chatAbandonTag: PropTypes.string,
    chatSuccessTag: PropTypes.string,
    chatTracking: PropTypes.object,
    pageCurrency: PropTypes.string,
    setPreAuthOfferLowball: PropTypes.func,
    isMC: PropTypes.bool
};

MakeOfferModal.defaultProps = {
    currentStep: 'makeOffer',
    chatAbandonTag: 'abandonMakeOffer',
    chatSuccessTag: 'makeOffer',
    copy: defaultCopy,
    openOnRender: true
};

module.exports = MakeOfferModal;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);
var validationActions = __webpack_require__(10);
var fieldsActions = __webpack_require__(13);
var makeOfferActions = __webpack_require__(14);
var mutationActions = __webpack_require__(11);

var _require = __webpack_require__(21),
    connect = _require.connect;

var mapStateToProps = function mapStateToProps(_ref) {
    var contactDealer = _ref.contactDealer,
        modalWrapper = _ref.modalWrapper,
        fields = _ref.fields,
        lowBall = _ref.lowBall,
        validation = _ref.validation,
        tracking = _ref.tracking,
        price = _ref.price;

    return {
        currentStep: modalWrapper.currentStep,
        prevStep: modalWrapper.backLinkTargets[modalWrapper.currentStep],
        isError: modalWrapper.isError,
        isOpened: modalWrapper.isOpened,
        isSending: modalWrapper.isSending,
        submitDisabled: modalWrapper.submitDisabled,
        offerValue: fields.offerFieldValue,
        quantityValue: fields.quantityFieldValue,
        nameValue: fields.nameFieldValue,
        messageValue: fields.messageFieldValue,
        isMessageFieldOpen: fields.isMessageFieldOpen,
        messageErrors: validation.messageErrors,
        errors: Object.assign({}, validation.messageErrors, validation.offerErrors),
        lowBallOptions: lowBall,
        isPreAuthOfferLowball: lowBall.isPreAuthOfferLowball,
        trackingParams: tracking,

        authResultAction: contactDealer.authResultAction,
        authWasMakeOffer: contactDealer.authWasMakeOffer,

        currency: price.currency,
        currencySymbol: price.currencySymbol,
        formattedNetPrice: price.formattedNetPrice,
        formattedRetailPrice: price.formattedRetailPrice,
        formattedSalePrice: price.formattedSalePrice,
        isPricePerPiece: price.isPricePerPiece,
        pieces: price.pieces,
        priceType: price.priceType,
        priceValue: price.priceValue
    };
};

module.exports = connect(mapStateToProps, Object.assign({}, makeOfferActions, modalWrapperActions, fieldsActions, validationActions, mutationActions), function (stateProps, dispatchProps, ownProps) {
    return Object.assign({}, ownProps, stateProps, dispatchProps, {
        currentStep: stateProps.currentStep || ownProps.currentStep
    });
});

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Relay = __webpack_require__(4);
var createRelayContainer = __webpack_require__(24);
var FavoriteDealerMutation = __webpack_require__(25);

var _require = __webpack_require__(9),
    compose = _require.compose,
    hoistStatics = _require.hoistStatics,
    flattenProp = _require.flattenProp,
    withProps = _require.withProps;

var get = __webpack_require__(1);

var sellerFragment = function (RQL_0, RQL_1) {
    return {
        children: [].concat.apply([], [{
            alias: 'isOnPreAuthOfferWhitelist',
            calls: [{
                kind: 'Call',
                metadata: {},
                name: 'listName',
                value: {
                    kind: 'CallValue',
                    callValue: 'ALLOW_PREAUTH_OFFERS'
                }
            }],
            fieldName: 'isWhitelisted',
            kind: 'Field',
            metadata: {},
            type: 'Boolean'
        }, {
            fieldName: 'serviceId',
            kind: 'Field',
            metadata: {},
            type: 'ID'
        }, {
            fieldName: 'isPolicyOpop',
            kind: 'Field',
            metadata: {},
            type: 'Boolean'
        }, {
            children: [{
                fieldName: 'displayName',
                kind: 'Field',
                metadata: {},
                type: 'String'
            }, {
                fieldName: 'company',
                kind: 'Field',
                metadata: {},
                type: 'String'
            }],
            fieldName: 'sellerProfile',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true
            },
            type: 'SellerProfile'
        }, {
            children: [{
                fieldName: 'urlLabel',
                kind: 'Field',
                metadata: {},
                type: 'String'
            }],
            fieldName: 'sellerPreferences',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true
            },
            type: 'SellerPreferences'
        }, {
            calls: [{
                kind: 'Call',
                metadata: {},
                name: 'userIds',
                value: {
                    kind: 'CallVariable',
                    callVariableName: 'userId'
                }
            }],
            children: [].concat.apply([], [{
                fieldName: 'id',
                kind: 'Field',
                metadata: {
                    isGenerated: true,
                    isRequisite: true
                },
                type: 'ID'
            }, Relay.QL.__frag(RQL_0)]),
            directives: [{
                kind: 'Directive',
                name: 'include',
                args: [{
                    name: 'if',
                    value: {
                        kind: 'CallVariable',
                        callVariableName: 'shouldFetchUser'
                    }
                }]
            }],
            fieldName: 'favoritesByUser',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true,
                inferredRootCallName: 'node',
                inferredPrimaryKey: 'id',
                isPlural: true
            },
            type: 'Favorite'
        }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
                isGenerated: true,
                isRequisite: true
            },
            type: 'ID'
        }, Relay.QL.__frag(RQL_1)]),
        id: Relay.QL.__id(),
        kind: 'Fragment',
        metadata: {},
        name: 'RelayRelayQL',
        type: 'Seller'
    };
}(FavoriteDealerMutation.getFragment('favorite'), FavoriteDealerMutation.getFragment('seller'));

var itemFragment = function () {
    return {
        children: [{
            fieldName: 'title',
            kind: 'Field',
            metadata: {},
            type: 'String'
        }, {
            fieldName: 'vertical',
            kind: 'Field',
            metadata: {},
            type: 'VerticalType'
        }, {
            fieldName: 'pieces',
            kind: 'Field',
            metadata: {},
            type: 'Int'
        }, {
            fieldName: 'unavailableReasonCode',
            kind: 'Field',
            metadata: {},
            type: 'String'
        }, {
            fieldName: 'status',
            kind: 'Field',
            metadata: {},
            type: 'String'
        }, {
            children: [{
                fieldName: 'hidePrice',
                kind: 'Field',
                metadata: {},
                type: 'YesNo'
            }, {
                fieldName: 'pricePerPiece',
                kind: 'Field',
                metadata: {},
                type: 'YesNo'
            }, {
                children: [{
                    children: [{
                        children: [{
                            fieldName: 'amount',
                            kind: 'Field',
                            metadata: {},
                            type: 'Float'
                        }, {
                            fieldName: 'currency',
                            kind: 'Field',
                            metadata: {},
                            type: 'Currency'
                        }],
                        fieldName: 'convertedAmountList',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isPlural: true
                        },
                        type: 'ConvertedAmountList'
                    }],
                    fieldName: 'amount',
                    kind: 'Field',
                    metadata: {
                        canHaveSubselections: true
                    },
                    type: 'FinancialAmount'
                }, {
                    fieldName: 'status',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                }, {
                    fieldName: 'type',
                    kind: 'Field',
                    metadata: {},
                    type: 'PriceType'
                }, {
                    fieldName: 'hidePrice',
                    kind: 'Field',
                    metadata: {},
                    type: 'YesNo'
                }],
                fieldName: 'prices',
                kind: 'Field',
                metadata: {
                    canHaveSubselections: true,
                    isPlural: true
                },
                type: 'Price'
            }],
            fieldName: 'pricing',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true
            },
            type: 'ItemPricing'
        }, {
            fieldName: 'serviceId',
            kind: 'Field',
            metadata: {},
            type: 'ID'
        }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
                isGenerated: true,
                isRequisite: true
            },
            type: 'ID'
        }],
        id: Relay.QL.__id(),
        kind: 'Fragment',
        metadata: {},
        name: 'RelayRelayQL',
        type: 'Item'
    };
}();

var transactionFragment = function () {
    return {
        children: [{
            fieldName: 'isCanceled',
            kind: 'Field',
            metadata: {},
            type: 'Boolean'
        }, {
            fieldName: 'hasCompletedCheckout',
            kind: 'Field',
            metadata: {},
            type: 'Boolean'
        }, {
            children: [{
                fieldName: 'serviceId',
                kind: 'Field',
                metadata: {},
                type: 'ID'
            }, {
                fieldName: 'id',
                kind: 'Field',
                metadata: {
                    isGenerated: true,
                    isRequisite: true
                },
                type: 'ID'
            }],
            fieldName: 'mostRecentOffer',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true,
                inferredRootCallName: 'node',
                inferredPrimaryKey: 'id'
            },
            type: 'Offer'
        }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
                isGenerated: true,
                isRequisite: true
            },
            type: 'ID'
        }],
        id: Relay.QL.__id(),
        kind: 'Fragment',
        metadata: {},
        name: 'RelayRelayQL',
        type: 'Transaction'
    };
}();

var query = {
    initialVariables: {
        sellerId: null,
        itemId: null,
        userId: null,
        shouldFetchUser: false,
        shouldFetchTransaction: false,
        isMC: false
    },
    prepareVariables: function prepareVariables(prevVariables) {
        var isMC = prevVariables.isMC,
            shouldFetchUser = prevVariables.shouldFetchUser;

        return Object.assign({}, prevVariables, {
            shouldFetchTransaction: shouldFetchUser && !isMC
        });
    },
    fragments: {
        conversation: function conversation() {
            return function (RQL_0, RQL_1) {
                return {
                    children: [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isRequisite: true
                        },
                        type: 'ID'
                    }, {
                        children: [{
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, Relay.QL.__frag(RQL_0)]),
                            fieldName: 'seller',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'Seller'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'originalSeller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'ConversationMember'
                    }, {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_1)]),
                        fieldName: 'transaction',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Transaction'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ConversationRelayQL',
                    type: 'Conversation'
                };
            }(sellerFragment, transactionFragment);
        },
        item: function item() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ItemRelayQL',
                    type: 'Item'
                };
            }(itemFragment);
        },
        viewer: function viewer() {
            return function (RQL_0, RQL_1, RQL_2) {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'sellerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'sellerId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_0)]),
                        directives: [{
                            kind: 'Directive',
                            name: 'skip',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'isMC'
                                }
                            }]
                        }],
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_1)]),
                        directives: [{
                            kind: 'Directive',
                            name: 'skip',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'isMC'
                                }
                            }]
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'userId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }, {
                                calls: [{
                                    kind: 'Call',
                                    metadata: {},
                                    name: 'preventEmailFallback',
                                    value: {
                                        kind: 'CallValue',
                                        callValue: true
                                    }
                                }],
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'firstName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'lastName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'email',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            alias: 'canUseNetPrice',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_NET_PRICE'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isVerifiedTrade',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchUser'
                                }
                            }]
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'first',
                            value: {
                                kind: 'CallValue',
                                callValue: 1
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'sort',
                            value: {
                                kind: 'CallValue',
                                callValue: 'createdDate desc'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [].concat.apply([], [{
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }, Relay.QL.__frag(RQL_2)]),
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'Transaction'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'TransactionEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchTransaction'
                                }
                            }]
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(sellerFragment, itemFragment, transactionFragment);
        }
    }
};

module.exports = function (Component) {
    return hoistStatics(compose(createRelayContainer(query), flattenProp('viewer'), withProps(function (_ref) {
        var conversation = _ref.conversation,
            transactions = _ref.transactions,
            user = _ref.user;

        var sharedProps = {
            isUserInitiallyLoggedIn: !!user
        };

        if (conversation) {
            return Object.assign({}, sharedProps, {
                seller: get(conversation, 'originalSeller.seller'),
                transaction: get(conversation, 'transaction')
            });
        }
        return Object.assign({}, sharedProps, {
            transaction: get(transactions, 'edges[0].node')
        });
    })))(Component);
};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var ModalWrapper = __webpack_require__(17);
var defaultCopy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(26), __webpack_require__(27), __webpack_require__(42), __webpack_require__(27), __webpack_require__(65), __webpack_require__(7)));

var PreAuthOfferModal = function (_React$Component) {
    _inherits(PreAuthOfferModal, _React$Component);

    function PreAuthOfferModal() {
        _classCallCheck(this, PreAuthOfferModal);

        return _possibleConstructorReturn(this, (PreAuthOfferModal.__proto__ || Object.getPrototypeOf(PreAuthOfferModal)).apply(this, arguments));
    }

    _createClass(PreAuthOfferModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                goToStep = _props.goToStep,
                openModal = _props.openModal,
                openOnRender = _props.openOnRender,
                defaultMessageValue = _props.defaultMessageValue,
                updateContactModalFields = _props.updateContactModalFields;


            if (defaultMessageValue) {
                updateContactModalFields({ field: 'message', value: defaultMessageValue });
            }

            goToStep({ step: 'makePreAuthOffer' });
            if (openOnRender) {
                openModal('makePreAuthOffer');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                copy = _props2.copy,
                isError = _props2.isError,
                isOpened = _props2.isOpened,
                currentStep = _props2.currentStep;


            var headerText = copy.get(currentStep + 'Header');

            var CurrentModalStep = React.Children.toArray(children).filter(function (c) {
                return c.props.modalKey === (currentStep ? currentStep : 'makePreAuthOffer');
            })[0];

            return React.createElement(
                ModalWrapper,
                {
                    modalType: 'makePreAuthOffer',
                    isOpened: isOpened,
                    isError: isError,
                    header: headerText,
                    closeModal: this.props.closeModal
                },
                React.cloneElement(CurrentModalStep, _extends({}, this.props))
            );
        }
    }]);

    return PreAuthOfferModal;
}(React.Component);

;

PreAuthOfferModal.propTypes = {
    relay: PropTypes.object,
    isOpened: PropTypes.bool.isRequired,
    isError: PropTypes.bool,
    closeModal: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    openOnRender: PropTypes.bool,
    goToStep: PropTypes.func.isRequired,
    currentStep: PropTypes.string,
    copy: PropTypes.object,
    children: PropTypes.node.isRequired,
    defaultMessageValue: PropTypes.string,
    updateContactModalFields: PropTypes.func
};

PreAuthOfferModal.defaultProps = {
    copy: defaultCopy,
    openOnRender: true
};

module.exports = PreAuthOfferModal;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);
var validationActions = __webpack_require__(10);
var fieldsActions = __webpack_require__(13);
var mutationActions = __webpack_require__(11);
var makeOfferActions = __webpack_require__(14);

var _require = __webpack_require__(21),
    connect = _require.connect;

var mapStateToProps = function mapStateToProps(_ref, ownProps) {
    var modalWrapper = _ref.modalWrapper,
        validation = _ref.validation,
        fields = _ref.fields;

    return {
        isError: modalWrapper.isError,
        isOpened: modalWrapper.isOpened,
        isSending: modalWrapper.isSending,
        currentStep: modalWrapper.currentStep,
        messageValue: fields.messageFieldValue,
        defaultMessageValue: ownProps.messageValue,
        isMessageValidated: validation.isMessageValidated,
        errors: validation.messageErrors
    };
};

module.exports = connect(mapStateToProps, Object.assign({}, makeOfferActions, fieldsActions, modalWrapperActions, mutationActions, validationActions, makeOfferActions));

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Relay = __webpack_require__(4);
var createRelayContainer = __webpack_require__(24);

var _require = __webpack_require__(9),
    compose = _require.compose,
    hoistStatics = _require.hoistStatics,
    flattenProp = _require.flattenProp;

var query = {
    initialVariables: {
        itemId: null
    },
    fragments: {
        viewer: function viewer() {
            return function () {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'title',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            children: [{
                                fieldName: 'pricePerPiece',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }],
                            fieldName: 'pricing',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemPricing'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ViewerRelayQL',
                    type: 'Viewer'
                };
            }();
        }
    }
};

module.exports = hoistStatics(compose(createRelayContainer(query), flattenProp('viewer')));

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);

var _require = __webpack_require__(21),
    connect = _require.connect;

// shell modal wrapper used for loading and error messages


var mapStateToProps = function mapStateToProps(_ref) {
    var modalWrapper = _ref.modalWrapper;

    return {
        isOpened: modalWrapper.isOpened
    };
};

module.exports = connect(mapStateToProps, Object.assign({}, modalWrapperActions));

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var ModalWrapper = __webpack_require__(17);
var NetPriceComponent = __webpack_require__(51);
var contactModalTracking = __webpack_require__(2);
var get = __webpack_require__(1);
var once = __webpack_require__(45);
var defaultCopy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(28), __webpack_require__(26), __webpack_require__(146), __webpack_require__(7)));

var NetPriceModal = function (_React$Component) {
    _inherits(NetPriceModal, _React$Component);

    function NetPriceModal() {
        _classCallCheck(this, NetPriceModal);

        return _possibleConstructorReturn(this, (NetPriceModal.__proto__ || Object.getPrototypeOf(NetPriceModal)).apply(this, arguments));
    }

    _createClass(NetPriceModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                buyerItemConversation = _props.buyerItemConversation,
                contactDataLoaded = _props.contactDataLoaded,
                goToStep = _props.goToStep,
                item = _props.item,
                linkLocation = _props.linkLocation,
                openModal = _props.openModal,
                openOnRender = _props.openOnRender,
                redirectToMessageCenter = _props.redirectToMessageCenter,
                redirectToOrderManager = _props.redirectToOrderManager,
                transaction = _props.transaction,
                seller = _props.seller;


            this.chatCloseModalOnce = once(this.chatCloseModal.bind(this));

            var hasRelevantTransaction = transaction && !get(transaction, 'isCanceled') && get(transaction, 'mostRecentOffer') && get(transaction, 'mostRecentOffer.status') !== 'NEW';
            // a relevant transaction is
            // - active (i.e. not canceled)
            // - not a custom shipping quote request (where there is no offer)
            // - not a pre-checkout invoice (where offer has status 'NEW')

            if (redirectToMessageCenter) {
                window.location.href = '/my/conversations/' + get(buyerItemConversation, 'serviceId');
            } else if (hasRelevantTransaction) {
                window.location.href = '/my/orders/order/' + get(transaction, 'serviceId');
            }

            contactDataLoaded({ seller: seller, item: item, linkLocation: linkLocation });
            goToStep({ step: 'netPrice' });
            if (openOnRender) {
                openModal('netPrice');
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.isOpened && !nextProps.isOpened) {
                contactModalTracking.resetPage();
            }
        }
    }, {
        key: 'chatCloseModal',
        value: function chatCloseModal() {
            var _props2 = this.props,
                closeModal = _props2.closeModal,
                chatAbandonTag = _props2.chatAbandonTag,
                chatTracking = _props2.chatTracking;

            var trackChatEvent = chatTracking ? chatTracking[chatAbandonTag] : false;
            if (trackChatEvent) {
                trackChatEvent();
            }
            closeModal();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                copy = _props3.copy,
                isError = _props3.isError,
                isOpened = _props3.isOpened;


            var headerText = copy.get('netPriceHeader');

            var props = Object.assign({}, this.props, {
                closeModal: this.chatCloseModalOnce
            });

            return React.createElement(
                ModalWrapper,
                {
                    modalType: 'netPrice',
                    isOpened: isOpened,
                    isError: isError,
                    header: headerText,
                    closeModal: props.closeModal
                },
                React.createElement(NetPriceComponent, props)
            );
        }
    }]);

    return NetPriceModal;
}(React.Component);

;

NetPriceModal.propTypes = {
    relay: PropTypes.object,
    isOpened: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    closeModal: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    openOnRender: PropTypes.bool,
    goToStep: PropTypes.func.isRequired,
    contactDataLoaded: PropTypes.func,
    messageValue: PropTypes.string,
    item: PropTypes.object,
    seller: PropTypes.object,
    user: PropTypes.object,
    copy: PropTypes.object,
    linkLocation: PropTypes.string,
    buyerItemConversation: PropTypes.object,
    redirectToMessageCenter: PropTypes.bool,
    transaction: PropTypes.shape({
        isCanceled: PropTypes.bool,
        serviceId: PropTypes.string,
        mostRecentOffer: PropTypes.shape({
            status: PropTypes.string
        })
    }),
    trackingParams: PropTypes.shape({
        isItem: PropTypes.bool,
        item: PropTypes.object,
        linkLocation: PropTypes.string,
        purchaseStatus: PropTypes.string,
        vpvParams: PropTypes.object,
        vpvParamsQuery: PropTypes.string
    }),
    chatAbandonTag: PropTypes.string,
    chatSuccessTag: PropTypes.string,
    chatTracking: PropTypes.object
};

NetPriceModal.defaultProps = {
    chatAbandonTag: 'abandonRequestNetPrice',
    chatSuccessTag: 'requestNetPrice',
    copy: defaultCopy,
    openOnRender: true
};

module.exports = NetPriceModal;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);
var validationActions = __webpack_require__(10);
var netPriceActions = __webpack_require__(47);
var fieldsActions = __webpack_require__(13);
var mutationActions = __webpack_require__(11);

var _require = __webpack_require__(21),
    connect = _require.connect;

var mapStateToProps = function mapStateToProps(_ref) {
    var modalWrapper = _ref.modalWrapper,
        fields = _ref.fields,
        tracking = _ref.tracking,
        validation = _ref.validation;

    return {
        currentStep: modalWrapper.currentStep,
        isError: modalWrapper.isError,
        isOpened: modalWrapper.isOpened,
        isSending: modalWrapper.isSending,
        submitDisabled: modalWrapper.submitDisabled,
        messageValue: fields.messageFieldValue,
        nameValue: fields.nameFieldValue,
        isMessageFieldOpen: fields.isMessageFieldOpen,
        isHoldRequestChecked: fields.holdRequestFieldValue,
        isMessageValidated: validation.isMessageValidated,
        errors: validation.messageErrors,
        trackingParams: tracking
    };
};

module.exports = connect(mapStateToProps, Object.assign({}, fieldsActions, modalWrapperActions, mutationActions, netPriceActions, validationActions));

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Relay = __webpack_require__(4);
var createRelayContainer = __webpack_require__(24);

var _require = __webpack_require__(9),
    compose = _require.compose,
    hoistStatics = _require.hoistStatics,
    flattenProp = _require.flattenProp,
    withProps = _require.withProps;

var ContactDealerMutation = __webpack_require__(38);
var HoldRequestMutation = __webpack_require__(39);
var FavoriteDealerMutation = __webpack_require__(25);
var get = __webpack_require__(1);

var _require2 = __webpack_require__(59),
    shouldModalShowHoldRequestInput = _require2.shouldModalShowHoldRequestInput;

var query = {
    initialVariables: {
        sellerId: null,
        itemId: null,
        userId: null
    },
    fragments: {
        viewer: function viewer() {
            return function (RQL_0, RQL_1, RQL_2, RQL_3, RQL_4, RQL_5, RQL_6, RQL_7) {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'sellerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'sellerId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'company',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerProfile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerProfile'
                        }, {
                            children: [{
                                fieldName: 'urlLabel',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerPreferences',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerPreferences'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userIds',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, Relay.QL.__frag(RQL_0)]),
                            fieldName: 'favoritesByUser',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'Favorite'
                        }, {
                            fieldName: 'isSuspended',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2), Relay.QL.__frag(RQL_3)]),
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isRequisite: true
                            },
                            type: 'ID'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'value',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'customizable',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'AttributeValue'
                            }],
                            fieldName: 'attributes',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemAttributes'
                        }, {
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'title',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'vertical',
                            kind: 'Field',
                            metadata: {},
                            type: 'VerticalType'
                        }, {
                            fieldName: 'dibsReference',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            children: [{
                                fieldName: 'negotiable',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }],
                            fieldName: 'pricing',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemPricing'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'amount',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Float'
                                }],
                                fieldName: 'totalAmount',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'FinancialAmount'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'shipmentQuotes',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'ShipmentQuote'
                        }, {
                            fieldName: 'isPriceUponRequest',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isDeleted',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isOnHold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isSold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isNotListed',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'canMakePurchase',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            fieldName: 'canBuyerMakeOffer',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'hasPreQuotedShipping',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            fieldName: 'hasRequestedHoldForBuyer',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                fieldName: 'accept',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'returnPolicy',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'ReturnPolicy'
                        }, Relay.QL.__frag(RQL_4), Relay.QL.__frag(RQL_5)]),
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'userId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }, {
                                calls: [{
                                    kind: 'Call',
                                    metadata: {},
                                    name: 'preventEmailFallback',
                                    value: {
                                        kind: 'CallValue',
                                        callValue: true
                                    }
                                }],
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'firstName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'lastName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'email',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            alias: 'canUseNetPrice',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_NET_PRICE'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'company',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'proAddress',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id'
                                },
                                type: 'Address'
                            }],
                            fieldName: 'addressBook',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'AddressBook'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_6), Relay.QL.__frag(RQL_7)]),
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'first',
                            value: {
                                kind: 'CallValue',
                                callValue: 1
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'sort',
                            value: {
                                kind: 'CallValue',
                                callValue: 'createdDate desc'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [{
                                    fieldName: 'isCanceled',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'serviceId',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'ID'
                                }, {
                                    children: [{
                                        fieldName: 'status',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'mostRecentOffer',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id'
                                    },
                                    type: 'Offer'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'Transaction'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'TransactionEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        fieldName: 'buyerRequestedItemNetPrice',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'buyerItemConversation',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Conversation'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(FavoriteDealerMutation.getFragment('favorite'), ContactDealerMutation.getFragment('seller'), HoldRequestMutation.getFragment('seller'), FavoriteDealerMutation.getFragment('seller'), ContactDealerMutation.getFragment('item'), HoldRequestMutation.getFragment('item'), ContactDealerMutation.getFragment('user'), HoldRequestMutation.getFragment('user'));
        }
    }
};

module.exports = function (Component) {
    return hoistStatics(compose(createRelayContainer(query), flattenProp('viewer'), withProps(function (_ref) {
        var user = _ref.user,
            item = _ref.item,
            buyerRequestedItemNetPrice = _ref.buyerRequestedItemNetPrice,
            buyerItemConversation = _ref.buyerItemConversation,
            transactions = _ref.transactions;
        return {
            isUserNameSet: !!get(user, 'profile.firstName'),
            isShowHoldRequest: shouldModalShowHoldRequestInput(item, user),
            redirectToMessageCenter: buyerRequestedItemNetPrice && buyerItemConversation,
            transaction: get(transactions, 'edges[0].node'),
            buyerItemConversation: buyerItemConversation
        };
    })))(Component);
};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);

var _require = __webpack_require__(37),
    recordAppInstallView = _require.recordAppInstallView;

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var appInstallHref = 'https://itunes.apple.com/us/app/1stdibs/id938157117';

var AppInstallPrompt = function (_Component) {
    _inherits(AppInstallPrompt, _Component);

    function AppInstallPrompt(props) {
        _classCallCheck(this, AppInstallPrompt);

        var _this = _possibleConstructorReturn(this, (AppInstallPrompt.__proto__ || Object.getPrototypeOf(AppInstallPrompt)).call(this, props));

        _this.handleAppInstallClick = _this.handleAppInstallClick.bind(_this);
        return _this;
    }

    _createClass(AppInstallPrompt, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            recordAppInstallView();
        }
    }, {
        key: 'handleAppInstallClick',
        value: function handleAppInstallClick() {
            this.props.closeModal();
            trackingHelpers.appInstallClicked();
            window.location.href = appInstallHref;
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'appInstallHeader')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    get(copy, 'appInstallDescription')
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.handleAppInstallClick },
                    get(copy, 'appInstallCta')
                )
            );
        }
    }]);

    return AppInstallPrompt;
}(Component);

AppInstallPrompt.propTypes = {
    closeModal: PropTypes.func.isRequired,
    seller: PropTypes.shape({
        favoritesByUser: PropTypes.array,
        sellerProfile: PropTypes.shape({
            company: PropTypes.string,
            type: PropTypes.string
        })
    }).isRequired
};

module.exports = AppInstallPrompt;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var tokenReplace = __webpack_require__(5);

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var FavoriteDealerPrompt = function (_Component) {
    _inherits(FavoriteDealerPrompt, _Component);

    function FavoriteDealerPrompt(props) {
        _classCallCheck(this, FavoriteDealerPrompt);

        var _this = _possibleConstructorReturn(this, (FavoriteDealerPrompt.__proto__ || Object.getPrototypeOf(FavoriteDealerPrompt)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.subtext = _this.subtext.bind(_this);
        return _this;
    }

    _createClass(FavoriteDealerPrompt, [{
        key: 'handleClick',
        value: function handleClick() {
            this.props.closeModal();
            this.props.favoriteDealer(this.props);
            trackingHelpers.favoriteDealerClicked();
        }
    }, {
        key: 'subtext',
        value: function subtext() {
            var subtextTemplate = get(copy, 'followDealerInstructions');
            var dealerType = get(this.props.seller, 'sellerProfile.type') || 'dealer';
            return tokenReplace(subtextTemplate, { dealerType: dealerType });
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'followDealerHeader')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    this.subtext()
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.handleClick },
                    get(copy, 'followDealerCta')
                )
            );
        }
    }]);

    return FavoriteDealerPrompt;
}(Component);

FavoriteDealerPrompt.propTypes = {
    closeModal: PropTypes.func.isRequired,
    favoriteDealer: PropTypes.func.isRequired,
    seller: PropTypes.shape({
        favoritesByUser: PropTypes.array,
        sellerProfile: PropTypes.shape({
            company: PropTypes.string,
            type: PropTypes.string
        })
    })
};

module.exports = FavoriteDealerPrompt;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var HoldRequestPrompt = function (_Component) {
    _inherits(HoldRequestPrompt, _Component);

    function HoldRequestPrompt(props) {
        _classCallCheck(this, HoldRequestPrompt);

        var _this = _possibleConstructorReturn(this, (HoldRequestPrompt.__proto__ || Object.getPrototypeOf(HoldRequestPrompt)).call(this, props));

        _this.goToHoldRequestModal = _this.goToHoldRequestModal.bind(_this);
        return _this;
    }

    _createClass(HoldRequestPrompt, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            trackingHelpers.holdRequestSecondaryMessageShown();
        }
    }, {
        key: 'goToHoldRequestModal',
        value: function goToHoldRequestModal() {
            this.props.goToStep({
                step: 'contactDealer',
                modalContentData: {
                    isShowHoldRequest: false,
                    isHoldRequestChecked: true,
                    copySuffix: 'placeOnHold'
                }
            });
            this.props.holdFromConfirmationModal();
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'placeHoldRequestPrompt')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    get(copy, 'placeHoldDescription')
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.goToHoldRequestModal },
                    get(copy, 'placeHoldCta')
                )
            );
        }
    }]);

    return HoldRequestPrompt;
}(Component);

HoldRequestPrompt.propTypes = {
    goToStep: PropTypes.func.isRequired,
    holdFromConfirmationModal: PropTypes.func.isRequired
};

module.exports = HoldRequestPrompt;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var OfferRow = __webpack_require__(55);
var css = __webpack_require__(40);

function LowBallOfferField(_ref) {
    var offerValue = _ref.offerValue,
        error = _ref.error,
        currencySymbol = _ref.currencySymbol,
        labelSubtext = _ref.labelSubtext,
        onOfferChange = _ref.onOfferChange,
        isPricePerPiece = _ref.isPricePerPiece,
        copy = _ref.copy;

    return React.createElement(
        'div',
        { className: css.lowballOfferField },
        React.createElement(OfferRow, {
            className: css.lowballOfferInput
            // disable OfferRow's quantity dropdown
            , isPricePerPiece: false,
            field: 'offer',
            value: offerValue,
            error: error,
            currencySymbol: currencySymbol,
            onFieldChanged: onOfferChange
            // displayPrice prop is used as placeholder prop
            , displayPrice: isPricePerPiece ? copy.get('per item') : undefined
        }),
        React.createElement(
            'span',
            { className: css.lowballOptionSubtext },
            labelSubtext
        )
    );
}

LowBallOfferField.propTypes = {
    offerValue: PropTypes.string,
    error: PropTypes.string,
    currencySymbol: PropTypes.string,
    labelSubtext: PropTypes.string,
    onOfferChange: PropTypes.func,
    isPricePerPiece: PropTypes.bool,
    copy: PropTypes.shape({ get: PropTypes.func })
};

module.exports = LowBallOfferField;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var LowBallOfferField = __webpack_require__(109);
var intelligentFormat = __webpack_require__(31);
var classNames = __webpack_require__(19);
var css = __webpack_require__(40);
var formCss = __webpack_require__(6);

function LowBallOption(props) {
    var name = props.name,
        value = props.value,
        currency = props.currency,
        label = props.label,
        labelSubtext = props.labelSubtext,
        checked = props.checked,
        isOther = props.isOther,
        onChange = props.onChange;

    var displayLabel = label || intelligentFormat(value, currency);
    var inputId = name + '-' + value;
    var labelClasses = classNames(formCss['form-radio-wrapper'], css.lowballOptionLabel);
    var titleClasses = classNames(css.lowballOption, formCss['form-radio-input']);

    var subcomponent = void 0;
    if (checked && isOther) {
        subcomponent = React.createElement(LowBallOfferField, props);
    } else {
        subcomponent = React.createElement(
            'div',
            { className: css.lowballOptionSubtext },
            labelSubtext
        );
    }

    return React.createElement(
        'label',
        {
            htmlFor: inputId,
            className: labelClasses
        },
        React.createElement('input', {
            type: 'radio',
            id: inputId,
            name: name,
            value: value,
            checked: checked,
            onChange: onChange
        }),
        React.createElement(
            'div',
            { className: titleClasses },
            React.createElement(
                'div',
                { className: css.lowballOptionContent },
                React.createElement(
                    'div',
                    { className: css.lowballOptionText },
                    displayLabel
                ),
                subcomponent
            )
        )
    );
}

LowBallOption.propTypes = {
    checked: PropTypes.bool,
    copy: PropTypes.shape({ get: PropTypes.func }),
    currency: PropTypes.string,
    currencySymbol: PropTypes.string,
    error: PropTypes.string,
    isOther: PropTypes.bool,
    isPricePerPiece: PropTypes.bool,
    label: PropTypes.string,
    labelSubtext: PropTypes.string,
    name: PropTypes.string,
    offerValue: PropTypes.string,
    onChange: PropTypes.func,
    onOfferChange: PropTypes.func,
    value: PropTypes.string.isRequired
};

module.exports = LowBallOption;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes,
    Component = React.Component;

var PRICE_TYPES = __webpack_require__(30);
var InputWrapper = __webpack_require__(18);
var QuantityField = __webpack_require__(56);
var LowBallOption = __webpack_require__(110);
var tokenReplace = __webpack_require__(5);
var intelligentFormat = __webpack_require__(31);
var css = __webpack_require__(40);

var LowBallOptionList = function (_Component) {
    _inherits(LowBallOptionList, _Component);

    function LowBallOptionList(props) {
        _classCallCheck(this, LowBallOptionList);

        var _this = _possibleConstructorReturn(this, (LowBallOptionList.__proto__ || Object.getPrototypeOf(LowBallOptionList)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(LowBallOptionList, [{
        key: 'onChange',
        value: function onChange(e) {
            var setLowBallOption = this.props.setLowBallOption;


            setLowBallOption({
                field: 'offer',
                value: e.target.value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var name = 'lowball-option-list';
            var _props = this.props,
                copy = _props.copy,
                currency = _props.currency,
                currencySymbol = _props.currencySymbol,
                errors = _props.errors,
                isPricePerPiece = _props.isPricePerPiece,
                offerValue = _props.offerValue,
                onOfferChange = _props.onOfferChange,
                onQuantityChange = _props.onQuantityChange,
                options = _props.options,
                pieces = _props.pieces,
                priceType = _props.priceType,
                priceValue = _props.priceValue,
                quantityValue = _props.quantityValue;

            var type = void 0;
            if (priceType === PRICE_TYPES.TYPE_NET) {
                type = copy.get('net');
            } else if (priceType === PRICE_TYPES.TYPE_SALE) {
                type = copy.get('sale');
            } else {
                type = copy.get('list');
            }

            var optionComponents = Object.keys(options).map(function (key) {
                var option = options[key];
                if (['selectedLowBallOption', 'isPreAuthOfferLowball'].indexOf(key) < 0) {
                    return React.createElement(LowBallOption, _extends({}, option, {
                        key: key,
                        error: errors.offer,
                        name: name,
                        currency: currency,
                        currencySymbol: currencySymbol,
                        offerValue: offerValue,
                        onChange: _this2.onChange,
                        onOfferChange: onOfferChange,
                        isPricePerPiece: isPricePerPiece,
                        copy: copy
                    }));
                }
                return false;
            });

            var lowBallLabelPrice = intelligentFormat(priceValue, currency);
            if (isPricePerPiece) {
                lowBallLabelPrice = '' + lowBallLabelPrice + copy.get('perItemSuffix');
            }
            return React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: css.lowballHeader },
                    React.createElement(
                        'span',
                        { className: css.lowballHeaderWarning },
                        copy.get('lowBallLabelHeading')
                    ),
                    tokenReplace(copy.get('lowBallLabel'), {
                        price: lowBallLabelPrice,
                        type: type
                    })
                ),
                React.createElement(
                    InputWrapper,
                    null,
                    optionComponents
                ),
                React.createElement(QuantityField, {
                    onOfferChange: onQuantityChange,
                    quantityValue: quantityValue,
                    isPricePerPiece: isPricePerPiece,
                    pieces: pieces,
                    copy: copy
                })
            );
        }
    }]);

    return LowBallOptionList;
}(Component);

LowBallOptionList.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currency: PropTypes.string,
    currencySymbol: PropTypes.string,
    errors: PropTypes.object,
    isPricePerPiece: PropTypes.bool,
    offerValue: PropTypes.string,
    onOfferChange: PropTypes.func,
    onQuantityChange: PropTypes.func,
    options: PropTypes.shape({
        checked: PropTypes.bool,
        isOther: PropTypes.bool,
        value: PropTypes.string,
        label: PropTypes.string,
        labelSubtext: PropTypes.string
    }),
    pieces: PropTypes.number,
    priceType: PropTypes.string,
    priceValue: PropTypes.number,
    quantityValue: PropTypes.string,
    setLowBallOption: PropTypes.func
};

module.exports = LowBallOptionList;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var tokenReplace = __webpack_require__(5);

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var MakeOfferPrompt = function (_Component) {
    _inherits(MakeOfferPrompt, _Component);

    function MakeOfferPrompt(props) {
        _classCallCheck(this, MakeOfferPrompt);

        var _this = _possibleConstructorReturn(this, (MakeOfferPrompt.__proto__ || Object.getPrototypeOf(MakeOfferPrompt)).call(this, props));

        _this.goToMakeOffer = _this.goToMakeOffer = _this.goToMakeOffer.bind(_this);
        return _this;
    }

    _createClass(MakeOfferPrompt, [{
        key: 'goToMakeOffer',
        value: function goToMakeOffer() {
            var _props = this.props,
                goToStep = _props.goToStep,
                item = _props.item,
                priceType = _props.priceType,
                seller = _props.seller,
                trackingParams = _props.trackingParams;

            trackingHelpers.makeOfferSecondaryCtaClicked();
            trackingHelpers.eventOfferEnable(_extends({}, trackingParams, {
                item: item,
                priceType: priceType,
                seller: seller
            }));
            goToStep({ step: 'makeOffer' });
        }
    }, {
        key: 'render',
        value: function render() {
            var dealerName = get(this.props.seller, 'sellerProfile.company');
            var descriptionTemplate = get(copy, 'makeOfferDescription');
            var description = tokenReplace(descriptionTemplate, { dealerName: dealerName });

            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'makeOfferPrompt')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    description
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.goToMakeOffer },
                    get(copy, 'makeOfferCta')
                )
            );
        }
    }]);

    return MakeOfferPrompt;
}(Component);

MakeOfferPrompt.propTypes = {
    goToStep: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    priceType: PropTypes.string,
    seller: PropTypes.shape({
        sellerProfile: PropTypes.shape({
            company: PropTypes.string
        })
    }),
    trackingParams: PropTypes.shape({
        isItem: PropTypes.bool,
        item: PropTypes.object,
        linkLocation: PropTypes.string,
        purchaseStatus: PropTypes.string,
        vpvParams: PropTypes.object,
        vpvParamsQuery: PropTypes.string
    })
};

module.exports = MakeOfferPrompt;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(41);
var componentCss = __webpack_require__(136);
var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var CursorInput = __webpack_require__(49);

function OfferInput(_ref) {
    var field = _ref.field,
        value = _ref.value,
        currencySymbol = _ref.currencySymbol,
        displayPrice = _ref.displayPrice,
        onFieldChanged = _ref.onFieldChanged;

    return React.createElement(
        'div',
        { className: css.inputWrapper },
        React.createElement(
            'span',
            { className: css.currency, 'data-tn': 'offer-input-currency' },
            currencySymbol
        ),
        React.createElement(CursorInput, { autoFocus: true,
            className: componentCss.input,
            value: value,
            onChange: function onChange(e) {
                return onFieldChanged({
                    field: field,
                    value: e.target.value.replace(/[^\d\.,]+/g, '')
                });
            },
            type: 'text',
            placeholder: displayPrice,
            'data-tn': 'offer-input'
        })
    );
};

OfferInput.propTypes = {
    value: PropTypes.string,
    field: PropTypes.string.isRequired,
    currencySymbol: PropTypes.string,
    displayPrice: PropTypes.string,
    onFieldChanged: PropTypes.func.isRequired,
    isOfferFocus: PropTypes.bool
};

module.exports = OfferInput;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);

var _require = __webpack_require__(37),
    persistNotTradeAnswer = _require.persistNotTradeAnswer;

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var tradeStatuses = {
    rejected: 'APPLIED_REJECTED'
};

var TradePrompt = function (_Component) {
    _inherits(TradePrompt, _Component);

    function TradePrompt(props) {
        _classCallCheck(this, TradePrompt);

        var _this = _possibleConstructorReturn(this, (TradePrompt.__proto__ || Object.getPrototypeOf(TradePrompt)).call(this, props));

        _this.goToTradeApplication = _this.goToTradeApplication.bind(_this);
        _this.handleNotTradeClick = _this.handleNotTradeClick.bind(_this);
        return _this;
    }

    _createClass(TradePrompt, [{
        key: 'goToTradeApplication',
        value: function goToTradeApplication() {
            trackingHelpers.tradeApplicationLinkClicked();
            window.location.href = '/trade/apply/';
        }
    }, {
        key: 'handleNotTradeClick',
        value: function handleNotTradeClick() {
            var _props = this.props,
                closeModal = _props.closeModal,
                relay = _props.relay,
                updateTradeStatus = _props.updateTradeStatus,
                user = _props.user;

            closeModal();
            persistNotTradeAnswer();
            updateTradeStatus(user, tradeStatuses.rejected, relay);
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'tradePrompt')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    get(copy, 'tradeDescription')
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.goToTradeApplication },
                    get(copy, 'tradeCta')
                ),
                React.createElement(
                    'div',
                    null,
                    React.createElement(
                        'a',
                        { className: css.secondaryCta, onClick: this.handleNotTradeClick },
                        get(copy, 'tradeSecondaryCta')
                    )
                )
            );
        }
    }]);

    return TradePrompt;
}(Component);

TradePrompt.propTypes = {
    closeModal: PropTypes.func.isRequired,
    relay: PropTypes.object,
    updateTradeStatus: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
};

module.exports = TradePrompt;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var get = __webpack_require__(1);
var PropTypes = React.PropTypes;


function ViewInvoiceLink(_ref) {
    var viewer = _ref.viewer,
        onClick = _ref.onClick,
        children = _ref.children,
        className = _ref.className;

    var itemId = get(viewer, 'item.serviceId');
    if (!get(viewer, 'user.canSeeInvoice') || get(viewer, 'preInvoiceTransactions.totalResults')) {
        return null;
    }
    return React.createElement(
        'a',
        {
            href: '/my/orders/invoice/id-' + itemId + '/',
            target: '_blank',
            className: className,
            onClick: onClick
        },
        children
    );
};

ViewInvoiceLink.defaultProps = {
    onClick: function onClick() {}
};

ViewInvoiceLink.propTypes = {
    viewer: PropTypes.object,
    onClick: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string
};

module.exports = ViewInvoiceLink;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var css = __webpack_require__(64);
// TODO: if this variant becomes canon, rename copy keys to be more descriptive

var suggestedTopics = ["History", "Dimensions", "Condition", "Shipping", "Customization", "Special Requests"];

function ModalSidebar(_ref) {
    var item = _ref.item,
        copy = _ref.copy;

    return React.createElement(
        'div',
        { className: css.sidebarWrapper },
        React.createElement('img', { src: get(item, 'firstPhotoWebPath') }),
        React.createElement(
            'div',
            { className: css.desktopPromptList },
            React.createElement(
                'p',
                { className: css.prompt },
                copy.get('modalSidebarDesktopPrompt')
            ),
            React.createElement(
                'ul',
                null,
                suggestedTopics.map(function (c) {
                    return React.createElement(
                        'li',
                        null,
                        c
                    );
                })
            )
        ),
        React.createElement(
            'div',
            { className: css.mobilePrompt },
            copy.get('modalSidebarMobilePrompt')
        )
    );
}

ModalSidebar.propTypes = {
    item: PropTypes.object.isRequired,
    copy: PropTypes.object
};

module.exports = ModalSidebar;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Checkmark = __webpack_require__(153);
var classnames = __webpack_require__(19);
var copy = __webpack_require__(145);
var style = __webpack_require__(126);
var Component = React.Component,
    PropTypes = React.PropTypes;

var OfferGuarantee = function (_Component) {
    _inherits(OfferGuarantee, _Component);

    function OfferGuarantee(props) {
        _classCallCheck(this, OfferGuarantee);

        var _this = _possibleConstructorReturn(this, (OfferGuarantee.__proto__ || Object.getPrototypeOf(OfferGuarantee)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(OfferGuarantee, [{
        key: 'onClick',
        value: function onClick() {
            var checked = this.props.checked;

            this.props.onChange(!checked);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                checked = _props.checked,
                onChange = _props.onChange;

            var checkboxClassName = classnames(style.checkbox, _defineProperty({}, style.checked, checked));

            return React.createElement(
                'div',
                { className: style.container },
                React.createElement(
                    'div',
                    { className: checkboxClassName, onClick: this.onClick },
                    checked && React.createElement(Checkmark, { className: style.icon })
                ),
                React.createElement(
                    'label',
                    { className: style.label, onClick: this.onClick },
                    copy.label
                ),
                React.createElement(
                    'p',
                    { className: style.description },
                    copy.description
                )
            );
        }
    }]);

    return OfferGuarantee;
}(Component);

OfferGuarantee.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};

module.exports = OfferGuarantee;

/***/ },
/* 118 */
/***/ function(module, exports) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var userAgentContains = exports.userAgentContains = function userAgentContains() {
    for (var _len = arguments.length, substrings = Array(_len), _key = 0; _key < _len; _key++) {
        substrings[_key] = arguments[_key];
    }

    return function () {
        try {
            var userAgentLowerCase = navigator.userAgent.toLowerCase();
            for (var i = 0; i < substrings.length; i++) {
                var subStr = substrings[i];
                if (userAgentLowerCase.indexOf(subStr.toLowerCase()) > -1) {
                    return true;
                }
            }
            return false;
        } catch (e) {
            console.warn('User agent check on string caused error:', e, 'substings: ' + substrings);
            return false;
        }
    };
};

var isAppleMobileDevice = exports.isAppleMobileDevice = userAgentContains('iphone', 'ipad');

/***/ },
/* 119 */
/***/ function(module, exports) {

"use strict";
'use strict';

function isTestVariant(optimizelyVariant) {
    return !!['makeOfferCheckbox', 'makeOfferCheckbox-checked'].find(function (variant) {
        return variant === optimizelyVariant;
    });
}

function isCheckboxChecked(optimizelyVariant) {
    return optimizelyVariant === 'makeOfferCheckbox-checked';
}

module.exports = {
    isTestVariant: isTestVariant,
    isCheckboxChecked: isCheckboxChecked
};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var get = __webpack_require__(1);
var qs = __webpack_require__(33);
var contactModalTracking = __webpack_require__(2);

module.exports = function (options) {
    var chatSuccessTag = options.chatSuccessTag,
        chatTracking = options.chatTracking,
        currency = options.currency,
        isContactDealer = options.isContactDealer,
        item = options.item,
        seller = options.seller,
        lowBallOptions = options.lowBallOptions,
        messageValue = options.messageValue,
        nameValue = options.nameValue,
        offerValue = options.offerValue,
        priceValue = options.priceValue,
        quantityValue = options.quantityValue,
        user = options.user;

    var trackingOptions = {
        offerAmount: offerValue,
        priceValue: priceValue,
        selectedLowballOption: lowBallOptions[lowBallOptions.selectedLowballOption]
    };
    if (isContactDealer) {
        trackingOptions.value = 1;
    }
    var trackChatEvent = chatTracking ? chatTracking[chatSuccessTag] : false;
    if (trackChatEvent) {
        trackChatEvent();
    }
    contactModalTracking.eventOfferSuccessWithLowballOptions(trackingOptions);

    var params = qs.stringify({
        chkIncludeOffer: true,
        message: messageValue,
        offerAmount: offerValue,
        offerCurrency: get(user, 'profile.currency') || currency,
        name: nameValue,
        quantity: quantityValue,
        sellerId: get(seller, 'serviceId')
    });

    window.location.href = '/checkout/id-' + get(item, 'serviceId') + '?' + params;
};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);
var get = __webpack_require__(1);
var pick = __webpack_require__(32);

var MakePreAuthOfferMutation = function (_Relay$Mutation) {
    _inherits(MakePreAuthOfferMutation, _Relay$Mutation);

    function MakePreAuthOfferMutation() {
        _classCallCheck(this, MakePreAuthOfferMutation);

        return _possibleConstructorReturn(this, (MakePreAuthOfferMutation.__proto__ || Object.getPrototypeOf(MakePreAuthOfferMutation)).apply(this, arguments));
    }

    _createClass(MakePreAuthOfferMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'transactionCreatePrivateOffer',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'TransactionCreatePrivateOfferInput!'
                    },
                    name: 'MakePreAuthOfferMutation',
                    responseType: 'TransactionCreatePrivateOfferPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            return Object.assign({}, pick(this.props, ['buyerId', 'itemId', 'offerAmountPerItem', 'offerCurrency', 'messageContent', 'quantity']), { isBuyerInquiry: true });
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'conversation',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Conversation'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'MakePreAuthOfferMutationRelayQL',
                    type: 'TransactionCreatePrivateOfferPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: {
                    conversation: get(this.props, 'conversation.id')
                }
            }];
        }
    }]);

    return MakePreAuthOfferMutation;
}(Relay.Mutation);

module.exports = MakePreAuthOfferMutation;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _require = __webpack_require__(63),
    getFailsMaxLengthFunc = _require.getFailsMaxLengthFunc,
    getMaxLengthError = _require.getMaxLengthError,
    getMatchesRegexFunc = _require.getMatchesRegexFunc,
    getFailsRequiredFunc = _require.getFailsRequiredFunc,
    sharedRegex = _require.sharedRegex;

var validEmail = sharedRegex.validEmail,
    specialChars = sharedRegex.specialChars;

var copy = __webpack_require__(66);

var MAX_EMAIL_LENGTH = 256;
var MAX_NAME_LENGTH = 50;
var MAX_MESSAGE_LENGTH = 5000;

module.exports = function (_ref) {
    var validationPayload = _ref.validationPayload,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;

    var checkIsEmailTooLong = getFailsMaxLengthFunc(MAX_EMAIL_LENGTH);
    var checkIsNameTooLong = getFailsMaxLengthFunc(MAX_NAME_LENGTH);
    var checkIsMessageTooLong = getFailsMaxLengthFunc(MAX_MESSAGE_LENGTH);

    var checkIsMissing = getFailsRequiredFunc();

    var checkIsEmailAddressValid = getMatchesRegexFunc(validEmail);
    var checkHasSpecialChars = getMatchesRegexFunc(specialChars);

    var emailInput = validationPayload.email,
        nameInput = validationPayload.name,
        messageInput = validationPayload.message;

    var errors = {};

    if (!options.fields || options.fields.indexOf('email') >= 0) {
        if (checkIsMissing(emailInput)) {
            errors.email = copy.isRequired;
        } else if (checkIsEmailTooLong(emailInput)) {
            errors.email = getMaxLengthError(MAX_EMAIL_LENGTH);
        } else if (!checkIsEmailAddressValid(emailInput)) {
            errors.email = copy.invalidEmail;
        }
    }

    if (!options.fields || options.fields.indexOf('name') >= 0) {
        if (checkIsMissing(nameInput)) {
            errors.name = copy.isRequired;
        } else if (checkIsNameTooLong(nameInput)) {
            errors.name = getMaxLengthError(MAX_NAME_LENGTH);
        } else if (checkHasSpecialChars(nameInput)) {
            errors.name = copy.specialChars;
        }
    }

    if (!options.fields || options.fields.indexOf('message') >= 0) {
        if (checkIsMissing(messageInput)) {
            errors.message = copy.isRequired;
        } else if (checkIsMessageTooLong(messageInput)) {
            errors.message = getMaxLengthError(MAX_MESSAGE_LENGTH);
        }
    }

    return errors;
};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var tokenReplace = __webpack_require__(5);
var copy = __webpack_require__(66);

var _require = __webpack_require__(63),
    getFailsRequiredFunc = _require.getFailsRequiredFunc;

var lowBallCoeff = 0.6;

module.exports = function (_ref) {
    var validationPayload = _ref.validationPayload,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;
    var offer = validationPayload.offer,
        relevantItemPrice = validationPayload.relevantItemPrice;

    var parsedOffer = parseInt(offer, 10);

    if (!relevantItemPrice) {
        throw new Error('You must supply a relevant item price against which to validate the offer!');
    }

    var checkIsOfferMissing = getFailsRequiredFunc();
    var errors = {};

    if (checkIsOfferMissing(offer)) {
        errors.offer = copy.isRequired;
    } else if (parsedOffer < 1) {
        errors.offer = copy.positiveNumber;
    } else if (parsedOffer >= relevantItemPrice) {
        errors.offer = copy.underListPrice;
    } else if (!options.bypassLowball && parsedOffer < relevantItemPrice * lowBallCoeff) {
        errors.offer = tokenReplace(copy.lowBallErrorLabel, { threshold: lowBallCoeff * 100 + '%' });
        errors.lowBall = true;
    }

    return errors;
};

/***/ },
/* 124 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-abTests-abandon-make-offer-modal---container---2WVpC","description":"src-scss-abTests-abandon-make-offer-modal---description---3vYw7","cta":"src-scss-abTests-abandon-make-offer-modal---cta---eSbov"};

/***/ },
/* 125 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"guidedPromptsContainer":"src-scss-abTests-guided-copy---guidedPromptsContainer---3x5ig","guidedOptionWrapper":"src-scss-abTests-guided-copy---guidedOptionWrapper---TxDjW","guidedCopySubtitle":"src-scss-abTests-guided-copy---guidedCopySubtitle---1ZSY8"};

/***/ },
/* 126 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-abTests-offer-guarantee---container---2RARx","checkbox":"src-scss-abTests-offer-guarantee---checkbox---31bNQ","checked":"src-scss-abTests-offer-guarantee---checked---115HW","icon":"src-scss-abTests-offer-guarantee---icon---ec8pr","label":"src-scss-abTests-offer-guarantee---label---24k83","description":"src-scss-abTests-offer-guarantee---description---1CjBg"};

/***/ },
/* 127 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"makeOfferModalLink":"src-scss-contact-dealer---makeOfferModalLink---1NSHL","makeOfferModalLinkCta":"src-scss-contact-dealer---makeOfferModalLinkCta---BIIRr"};

/***/ },
/* 128 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-hold-request---container---1JQOj","checkboxLabel":"src-scss-hold-request---checkboxLabel---vsg2a","checkboxLabelChecked":"src-scss-hold-request---checkboxLabelChecked---1_nrg","info":"src-scss-hold-request---info---35Bu2"};

/***/ },
/* 129 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"src-scss-input-wrapper---label---NZlXc","wrapper":"src-scss-input-wrapper---wrapper---jC-S5"};

/***/ },
/* 130 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"input":"src-scss-input---input---2Rzho"};

/***/ },
/* 131 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"textarea":"src-scss-message-field---textarea---KaNYM"};

/***/ },
/* 132 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"input":"src-scss-message---input---2_Kvq","messageWrapper":"src-scss-message---messageWrapper---2W1He","description":"src-scss-message---description---30ySl"};

/***/ },
/* 133 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headerBackLink":"src-scss-modal-wrapper---headerBackLink---1VUfn","spinnerWrapper":"src-scss-modal-wrapper---spinnerWrapper---2U6vx","centeredSpinner":"src-scss-modal-wrapper---centeredSpinner---vPmw-","serviceError":"src-scss-modal-wrapper---serviceError---lGqde","body":"src-scss-modal-wrapper---body---2UOqc","modalWrapper":"src-scss-modal-wrapper---modalWrapper---1XUOz","headerTitle":"src-scss-modal-wrapper---headerTitle---28d1_"};

/***/ },
/* 134 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"src-scss-modal---body---3YqHm","header":"src-scss-modal---header---2jh5K","successWrapper":"src-scss-modal---successWrapper---1Ou8v","messageWrapper":"src-scss-modal---messageWrapper---1aj_Q","message":"src-scss-modal---message---1c_3w","okButton":"src-scss-modal---okButton---3CoNB","userToUserHeader":"src-scss-modal---userToUserHeader---2S3wj","modalContent":"src-scss-modal---modalContent---2oNZ0"};

/***/ },
/* 135 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-net-price---container---3J6rh","recipient":"src-scss-net-price---recipient---1NhTj","message":"src-scss-net-price---message---1Hi-t","info":"src-scss-net-price---info---RydMb","confirmation":"src-scss-net-price---confirmation---3e0uv"};

/***/ },
/* 136 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"input":"src-scss-offer-input---input---2cTA2"};

/***/ },
/* 137 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-opt-in---container---3k9TY","checkboxLabel":"src-scss-opt-in---checkboxLabel---3gLmy"};

/***/ },
/* 138 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainFormContainer":"src-scss-preAuthOffer---mainFormContainer---fZ5-p","preAuthOfferInfo":"src-scss-preAuthOffer---preAuthOfferInfo---2GO6O","preAuthOfferDisplayPrice":"src-scss-preAuthOffer---preAuthOfferDisplayPrice---jTPo9"};

/***/ },
/* 139 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"src-scss-preContactDealer---body---QyAa7","question":"src-scss-preContactDealer---question---3j1sM","button":"src-scss-preContactDealer---button---1sBcb"};

/***/ },
/* 140 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-scss-section-toggle---wrapper---4gZ1P","toggle":"src-scss-section-toggle---toggle---23scp","icon":"src-scss-section-toggle---icon---3jSk4","label":"src-scss-section-toggle---label---3C3My"};

/***/ },
/* 141 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"submit":"src-scss-submit---submit---2LvYQ"};

/***/ },
/* 142 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"message":"src-scss-successGeneric---message---1vqtG","ctaArrow":"src-scss-successGeneric---ctaArrow---2Nyhr","successContainer":"src-scss-successGeneric---successContainer---2yWdJ"};

/***/ },
/* 143 */
/***/ function(module, exports) {

module.exports = {
	"guidedCopyHeader": "Contact {dealer}",
	"guidedCopySubtitle": "What would you like to do?",
	"askAboutShipping": "ASK ABOUT SHIPPING",
	"requestItemDetails": "REQUEST ITEM DETAILS",
	"makeAnOffer": "MAKE AN OFFER",
	"askAQuestion": "ASK A QUESTION",
	"askAboutShippingGhostText": "Let the dealer know your shipping destination and desired delivery date.",
	"requestItemDetailsGhostText": "Ask the dealer about condition, provenance, dimensions, sizing or any other details.",
	"askAQuestionGhostText": "Ask the dealer for details about the piece, shipping options or anything else."
};

/***/ },
/* 144 */
/***/ function(module, exports) {

module.exports = {
	"modalSidebarGhostText": "Send an inquiry to receive a personal response from the dealer.",
	"modalSidebarMobilePrompt": "Contact the dealer to learn more about the history and provenance of the piece or ask any other questions, including shipping details.",
	"modalSidebarDesktopPrompt": "What would you like to know about this piece? You may want to ask about:"
};

/***/ },
/* 145 */
/***/ function(module, exports) {

module.exports = {
	"label": "Fast-Track Your Offer",
	"description": "Dealers are more likely to accept offers that include payment and shipping information upfront. Provide your info now and you will only be charged if the dealer accepts your price."
};

/***/ },
/* 146 */
/***/ function(module, exports) {

module.exports = {
	"netPriceHeader": "Request Net Price",
	"netPriceSubjectItem": "1stdibs Net Price",
	"netPriceSubheader": "A request will be sent to the dealer to provide the net price.",
	"netPriceHoldInfoChecked": "If approved, this piece will be placed on hold exclusively for you.",
	"netPriceMessageInfo": "If approved, this piece will be placed on hold exclusively for you.",
	"sendRequestCta": "Send Request",
	"header": "Request Net Price",
	"subjectItem": "1stdibs Net Price",
	"hardcodedTextBody": "I would like to consider this piece for a client project. Could you please send me the net price?",
	"tradeInfo": "The dealer will be notified that you are a verified member of the trade."
};

/***/ },
/* 147 */
/***/ function(module, exports) {

module.exports = {
	"preContactDealerHeader": "Request More Information",
	"preContactDealerSubtitle": "What would you like to do?",
	"requestShippingQuote": "Request Shipping Quote",
	"requestConditionReport": "Request Condition Report",
	"requestToHoldItem": "Request to Hold Item",
	"viewInvoice": "View invoice",
	"askAQuestionCta": "Ask a question"
};

/***/ },
/* 148 */
/***/ function(module, exports) {

module.exports = require("dibs-browser-storage");

/***/ },
/* 149 */
/***/ function(module, exports) {

module.exports = require("dibs-com-modal");

/***/ },
/* 150 */
/***/ function(module, exports) {

module.exports = require("dibs-display-helpers/dist/pdpDisplayHelper");

/***/ },
/* 151 */
/***/ function(module, exports) {

module.exports = require("dibs-overlay-spinner/dist/main.css");

/***/ },
/* 152 */
/***/ function(module, exports) {

module.exports = require("dibs-vg/dist/react/arrow-right");

/***/ },
/* 153 */
/***/ function(module, exports) {

module.exports = require("dibs-vg/dist/react/checkmark");

/***/ },
/* 154 */
/***/ function(module, exports) {

module.exports = require("dibs-vg/dist/react/minus");

/***/ },
/* 155 */
/***/ function(module, exports) {

module.exports = require("dibs-vg/dist/react/plus");

/***/ },
/* 156 */
/***/ function(module, exports) {

module.exports = require("isomorphic-fetch");

/***/ },
/* 157 */
/***/ function(module, exports) {

module.exports = require("lodash.findkey");

/***/ },
/* 158 */
/***/ function(module, exports) {

module.exports = require("lodash.isempty");

/***/ },
/* 159 */
/***/ function(module, exports) {

module.exports = require("react-dom");

/***/ },
/* 160 */
/***/ function(module, exports) {

module.exports = require("recompose/createHelper");

/***/ },
/* 161 */
/***/ function(module, exports) {

module.exports = require("recompose/toClass");

/***/ },
/* 162 */
/***/ function(module, exports) {

module.exports = require("server-vars");

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

module.exports = {
    CursorInput: __webpack_require__(49),
    DisplayPrice: __webpack_require__(34),
    EmailField: __webpack_require__(50),
    HoldRequestInput: __webpack_require__(35),
    MessageField: __webpack_require__(15),
    NameField: __webpack_require__(22),
    OptInInput: __webpack_require__(53),
    OfferField: __webpack_require__(52),
    SectionToggle: __webpack_require__(23),
    Submit: __webpack_require__(12),
    MakePreAuthOffer: __webpack_require__(82),
    Confirmation: __webpack_require__(48),

    PreContactDealer: __webpack_require__(83),
    ContactDealer: __webpack_require__(79),
    GuidedCopy: __webpack_require__(85),
    MakeOffer: __webpack_require__(81),
    AbandonMakeOfferModal: __webpack_require__(78),
    LowBall: __webpack_require__(80),
    NetPrice: __webpack_require__(51),

    ContactDealerModal: __webpack_require__(73),
    MakeOfferModal: __webpack_require__(74),
    MakePreAuthOfferModal: __webpack_require__(75),
    ModalWrapper: __webpack_require__(76),
    NetPriceModal: __webpack_require__(77),

    SuccessGeneric: __webpack_require__(84),

    ContactModalTracking: __webpack_require__(2),

    reducers: {
        contactDealer: __webpack_require__(86),
        fields: __webpack_require__(87),
        lowBall: __webpack_require__(88),
        modalWrapper: __webpack_require__(89),
        price: __webpack_require__(90),
        tracking: __webpack_require__(91),
        validation: __webpack_require__(92)
    },
    actions: {
        contactDealer: __webpack_require__(46),
        fields: __webpack_require__(13),
        makeOffer: __webpack_require__(14),
        modalWrapper: __webpack_require__(8),
        mutation: __webpack_require__(11),
        netPrice: __webpack_require__(47),
        validation: __webpack_require__(10)
    }
};

/***/ }
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/dibs-contact-modal/dist/bundle.js
// module id = 516
// module chunks = 63